// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"3E0DQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _farmavalJs = require("./farmaval.js");
var _calendarJs = require("./calendar.js");
// M10 — sección Formación (módulo autónomo)
var _indexJs = require("./formacion/index.js");
var _indexJs1 = require("./clients/farmavel/index.js");
var _workshopsJs = require("./formacion/workshops.js");
var _apiResolverJs = require("./apiResolver.js");
var _selectElementsJs = require("./selectElements.js");
var _versionJs = require("./version.js");
var _servicesJs = require("../config/services.js");
var _serviceMenusJs = require("../config/serviceMenus.js");
var _logoProbiomentorSymbolPng = require("url:../img/logo-probiomentor-symbol.png");
var _logoProbiomentorSymbolPngDefault = parcelHelpers.interopDefault(_logoProbiomentorSymbolPng);
function get_absolute_url(url) {
    if (!url) return "";
    if (url.startsWith("http://") || url.startsWith("https://")) return url;
    const apiBase = _indexJs1.farmavel.getBaseUrl();
    const serverBase = apiBase.endsWith("api/") ? apiBase.slice(0, -4) : apiBase;
    const cleanUrl = url.startsWith("/") ? url.slice(1) : url;
    return serverBase + cleanUrl;
}
let pharm_training = null;
let _probioHasFormation = false;
let _activeServiceCodes = new Set();
let _activeServiceGroups = new Set();
// Mapa de instancias Vue activas (servicios Gen 2)
const vueServiceApps = {};
async function mountVueService(serviceName) {
    const containerId = `service_vue_${serviceName}`;
    const container = document.getElementById(containerId);
    if (!container) return;
    container.innerHTML = "";
    container.classList.remove("hide");
    let App, createApp;
    if (serviceName === "probiomentor") {
        // Importar Vue y App.vue del mismo chunk para garantizar la misma instancia Vue
        const [vue, appMod] = await Promise.all([
            require("420234599e934fc9"),
            require("4b2f661b5d264aec")
        ]);
        createApp = vue.createApp;
        App = appMod.default;
    }
    if (!App || !createApp) return;
    const cacheRaw = localStorage.getItem("farmaval_pharm_cache");
    let staffList = [];
    if (cacheRaw) try {
        const cacheData = JSON.parse(cacheRaw);
        staffList = cacheData?.data?.staff || [];
    } catch (e) {
        staffList = [];
    }
    const app = createApp(App, {
        pharmId: localStorage.getItem("pharm_id") || "",
        token: localStorage.getItem("farmavel_token") || "",
        lng: localStorage.getItem("farmaval_lng") || "es",
        staff: staffList,
        onClose: ()=>unmountVueService(serviceName),
        onStaffCreated: on_vue_staff_created
    });
    vueServiceApps[serviceName] = app;
    app.mount(container);
}
function unmountVueService(serviceName) {
    const app = vueServiceApps[serviceName];
    if (app) {
        app.unmount();
        delete vueServiceApps[serviceName];
    }
    const container = document.getElementById(`service_vue_${serviceName}`);
    if (container) container.classList.add("hide");
}
// Alta rápida de un miembro del equipo desde PROBIOMENTOR: los mismos refrescos que el
// alta en Perfil → Equipo (caché y desplegables vía staff_updated) más la tabla del
// equipo, que en el formulario legacy repinta aria-list.
function on_vue_staff_created(lists) {
    myfuncs.staff_updated({
        data: lists
    });
    fill_list(document.getElementById("staff_list"), lists.allstaff, item_click);
}
function test_pending(state, group = null) {
    if (state != 3 && state != 4) return false;
    const prev = document.querySelector("section.selected");
    if (prev) prev.classList.remove("selected");
    if (state == 3) document.getElementById("section_pending").classList.add("selected");
    else document.getElementById("section_checking").classList.add("selected");
    if (group) document.querySelectorAll("[aria-agreement").forEach((el)=>{
        el.setAttribute("aria-group", group);
    });
    document.getElementById("btn_logout").classList.remove("hide");
    document.getElementById("main").classList.remove("hide");
    return true;
}
function show_logged(logged, passwords = false) {
    let show = ".nologged";
    let hide = ".logged";
    if (logged) {
        show = ".logged";
        hide = ".nologged";
        document.querySelector("body").classList.add("user_logged");
    } else document.querySelector("body").classList.remove("user_logged");
    document.querySelectorAll(show).forEach((el)=>{
        el.classList.remove("hide");
    });
    document.querySelectorAll(hide).forEach((el)=>{
        el.classList.add("hide");
    });
    document.getElementById("login_user").value = "";
    document.getElementById("login_password").value = "";
    document.getElementById("new_password").value = "";
    document.getElementById("renew_password").value = "";
    if (passwords) {
        document.getElementById("section_login").classList.add("hide");
        document.getElementById("section_update_password").classList.remove("hide");
    } else document.getElementById("section_update_password").classList.add("hide");
}
function render_nav_pharm_name(pharm = {}) {
    const navPharmName = document.getElementById("nav_pharm_name");
    if (!navPharmName) return;
    const simpleName = (pharm.pharm_name || "").trim();
    navPharmName.textContent = simpleName;
    if (simpleName) navPharmName.setAttribute("title", simpleName);
    else navPharmName.removeAttribute("title");
}
/**
 * Guarda los datos completos de la farmacia en localStorage
 * @param {Object} pharmData - Datos completos de la respuesta del backend
 */ function savePharmDataToCache(pharmData) {
    try {
        const cacheData = {
            pharm: pharmData.pharm,
            data: pharmData.data,
            agreement: pharmData.agreement,
            group: pharmData.group,
            session: pharmData.session,
            token: pharmData.token,
            // Sesión de un mentor: se restaura desde caché antes de que responda /v1/auth/me.
            mentor: pharmData.mentor,
            cachedAt: new Date().toISOString()
        };
        localStorage.setItem("farmaval_pharm_cache", JSON.stringify(cacheData));
        console.log("\uD83D\uDCBE Datos de farmacia guardados en cach\xe9 local");
    } catch (error) {
        console.error("Error al guardar cach\xe9 de farmacia:", error);
    }
}
/**
 * Recupera los datos de la farmacia desde localStorage
 * @returns {Object|null} - Datos de la farmacia o null si no existe
 */ function getPharmDataFromCache() {
    try {
        const cached = localStorage.getItem("farmaval_pharm_cache");
        if (!cached) return null;
        const cacheData = JSON.parse(cached);
        console.log("\uD83D\uDCE6 Datos de farmacia recuperados del cach\xe9 local");
        return cacheData;
    } catch (error) {
        console.error("Error al recuperar cach\xe9 de farmacia:", error);
        return null;
    }
}
/**
 * Refleja un alta o baja de personal en la caché de farmacia, de donde PROBIOMENTOR
 * lee la lista de responsables, y en la caché aria-cache "staff".
 * @param {Object} lists - { staff, allstaff } con la forma de /v1/auth/me
 */ function update_staff_cache(lists) {
    if (!lists) return;
    const cached = getPharmDataFromCache();
    if (cached?.data) {
        if (lists.staff) cached.data.staff = lists.staff;
        if (lists.allstaff) cached.data.allstaff = lists.allstaff;
        savePharmDataToCache(cached);
    }
    if (lists.staff) update_cache({
        staff: lists.staff
    });
}
/**
 * AD-31 — refleja un alta, edición o baja de «Mis productos» (o un /v1/auth/me
 * fresco) en la tabla, en el desplegable de ventas y en la caché de farmacia.
 * Sin esto la farmacia veía la lista vieja al recargar, creía que no se había
 * guardado y volvía a crear el producto.
 * @param {Array} products - con la forma de /v1/client/products
 */ function update_products_cache(products) {
    if (!Array.isArray(products)) return;
    const cached = getPharmDataFromCache();
    if (cached?.data) {
        cached.data.products = products;
        savePharmDataToCache(cached);
    }
    update_cache({
        products
    });
    fill_report_products(products);
    const list = document.getElementById("products_list");
    if (list) fill_list(list, products, item_click);
}
/**
 * Rellena el desplegable de ventas del informe y deja lista la primera opción
 * con su precio, igual que al cargar la página.
 * @param {Array} products
 */ function fill_report_products(products) {
    fill_pharm_options({
        products
    }, "products", [
        "prod_display_name",
        "prod_name"
    ], "prod_id", [
        {
            name: "aria-cost",
            field: "prod_cost"
        }
    ]);
    document.getElementById("report_product_type")?.dispatchEvent(new Event("change"));
}
function adaptAuthMePayload(data) {
    return {
        status: true,
        pharm: data.pharm || {},
        data: data.data || {},
        agreement: data.agreement,
        group: data.group,
        mentor: data.mentor
    };
}
function applyRestoredPharm(pharmData) {
    applyMentorMode(pharmData.mentor, pharmData.pharm);
    // El cambio de contraseña obligatorio es cosa de la farmacia, no del mentor que entra como ella.
    if (pharmData.pharm.pharm_reset_password == 1 && !pharmData.mentor) {
        show_logged(false, true);
        return;
    }
    if (!test_pending(pharmData.pharm.pharm_active, pharmData.group)) show_logged(true);
    load_pharm_data(pharmData);
    // TL-01: tras recargar también hay que habilitar los iconos de taller accesibles.
    (0, _workshopsJs.initWorkshopIcons)();
}
function applyLivePharmRefresh(data) {
    const adapted = adaptAuthMePayload(data);
    applyMentorMode(adapted.mentor, adapted.pharm);
    savePharmDataToCache(adapted);
    // La pantalla se pintó desde la caché: los productos se repintan con los datos
    // frescos para no enseñar una lista un paso atrás (AD-31).
    update_products_cache(adapted.data?.products);
    applyServiceCards(data.data?.services);
    ensureServicesCatalog().then((cat)=>applyServiceVisibility(data.data?.services, cat));
}
/**
 * Limpia los datos de sesión del usuario del localStorage
 * Mantiene solo datos no sensibles como el idioma
 */ function clearUserSession() {
    // Guardar idioma antes de limpiar
    const lng = localStorage.getItem("farmaval_lng");
    // Limpiar todos los datos de usuario
    localStorage.removeItem("farmaval_session");
    localStorage.removeItem("farmavel_token");
    localStorage.removeItem("pharm_token");
    localStorage.removeItem("pharm_id");
    localStorage.removeItem("backup_services");
    localStorage.removeItem("syncro_date");
    localStorage.removeItem("farmaval_pharm_cache");
    // M10 — persona activa de Formación (identificación ligera C4)
    (0, _indexJs.resetFormacionSession)();
    // Restaurar idioma si existía
    if (lng) localStorage.setItem("farmaval_lng", lng);
    render_nav_pharm_name();
    console.log("\uD83E\uDDF9 Sesi\xf3n de usuario limpiada del localStorage");
}
// ─── Cache-busting: compuerta de versión ──────────────────────────────────────
// Claves con datos backend (field-configs y listas) que quedan obsoletas entre deploys.
// NUNCA se incluyen: backup_services (cola offline de pacientes), farmavel_token,
// farmaval_session, pharm_token, pharm_id (sesión activa), farmaval_lng (idioma).
const VERSIONED_DATA_KEYS = [
    "farmaval_pharm_cache",
    "staff",
    "drugs",
    "days",
    "products",
    "farmaval_services_catalog"
];
/**
 * Elimina solo las cachés de datos backend (field-configs / listas).
 * Preserva sesión, cola offline y preferencia de idioma.
 */ function purgeDataCaches() {
    VERSIONED_DATA_KEYS.forEach((k)=>localStorage.removeItem(k));
    console.log("\uD83E\uDDF9 Cach\xe9s de datos purgados por cambio de versi\xf3n (sesi\xf3n y cola offline intactas)");
}
/**
 * Compara la versión del bundle en ejecución (inlinada por Parcel desde APP_BUILD_VERSION)
 * con la almacenada en localStorage. Si difieren, purga cachés de datos obsoletos
 * y actualiza la versión guardada.
 * Debe llamarse al inicio de load(), ANTES de cualquier lectura de caché.
 */ function checkAppVersion() {
    try {
        const stored = localStorage.getItem("app_build_version");
        if (stored !== (0, _versionJs.APP_BUILD_VERSION)) {
            console.log(`\u{1F195} Versi\xf3n de app cambi\xf3: ${stored} \u{2192} ${(0, _versionJs.APP_BUILD_VERSION)}`);
            purgeDataCaches();
            localStorage.setItem("app_build_version", (0, _versionJs.APP_BUILD_VERSION));
        }
    } catch (e) {
        console.error("checkAppVersion error:", e);
    }
}
/**
 * Devuelve true si hay un servicio/overlay abierto.
 * Usado como guarda para no recargar a mitad de un formulario activo.
 */ function isServiceActive() {
    return [
        "service_iframe",
        "report_view",
        "agreement_popup"
    ].some((id)=>{
        const el = document.getElementById(id);
        return el && !el.classList.contains("hide");
    });
}
/**
 * Consulta /version.json (sin caché) para detectar si el index.html servido al cliente
 * estaba obsoleto (edge/CDN sirvió versión vieja). Si la versión del servidor difiere
 * del bundle en ejecución, recarga UNA sola vez — y solo si no hay servicio abierto.
 * Usa sessionStorage para evitar bucles de recarga.
 */ function checkServerVersion() {
    fetch("/version.json?t=" + Date.now(), {
        cache: "no-store"
    }).then((r)=>r.ok ? r.json() : null).then((info)=>{
        if (!info || !info.version) return;
        if (info.version === (0, _versionJs.APP_BUILD_VERSION)) return;
        // Guarda por versión destino: solo un intento por versión nueva dentro de la sesión.
        const guardKey = "reload_guard_" + info.version;
        if (sessionStorage.getItem(guardKey)) {
            console.warn("\u23F8\uFE0F Recarga ya intentada para", info.version, "\u2014 omitida");
            return;
        }
        if (isServiceActive()) {
            console.log("\u23F8\uFE0F Servicio activo \u2014 recarga de versi\xf3n pospuesta");
            return;
        }
        sessionStorage.setItem(guardKey, "1");
        console.log("\uD83D\uDD01 index.html obsoleto detectado, recargando a versi\xf3n", info.version);
        location.reload();
    }).catch((e)=>console.warn("checkServerVersion ignorado (posiblemente offline):", e));
}
// ─────────────────────────────────────────────────────────────────────────────
function createServerV2Session(session, pharm_id) {
    const { server_base } = (0, _apiResolverJs.getServerConfig)();
    return fetch(server_base + "functions.php", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            function: "startSession",
            session: session,
            user_pharm: pharm_id
        })
    });
}
window.downloadImage = function(imageUrl, filename) {
    // Si la URL es relativa (no empieza con http/https), le concatenamos la base del sitio actual
    // para asegurar que se resuelva correctamente en cualquier entorno (Nginx, Local, etc.)
    let finalUrl = imageUrl;
    if (!imageUrl.startsWith("http") && !imageUrl.startsWith("//")) {
        // En producción (Parcel), las imágenes pueden estar en la raíz o en carpetas procesadas.
        // Intentamos resolver la URL relativa a la ubicación actual del JS/HTML.
        const baseUrl = window.location.origin + window.location.pathname.replace(/\/[^\/]*$/, "");
        finalUrl = baseUrl + (imageUrl.startsWith("/") ? "" : "/") + imageUrl;
    }
    console.log("Intentando descargar desde:", finalUrl);
    // Método 1: Intentar descargar vía Blob (más robusto para forzar descarga)
    fetch(finalUrl).then((response)=>{
        if (!response.ok) throw new Error("Network response was not ok");
        return response.blob();
    }).then((blob)=>{
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }).catch((error)=>{
        console.warn("Error al descargar v\xeda Blob, intentando m\xe9todo directo:", error);
        // Método 2: Fallback al método tradicional (enlace directo)
        // Si el 404 persiste aquí, es que la ruta construida es incorrecta para el servidor
        const link = document.createElement("a");
        link.href = imageUrl; // Usamos la URL original por si la base construida estaba mal
        link.download = filename;
        link.target = "_blank";
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    });
    return false;
};
function load() {
    (0, _farmavalJs.set_version)();
    (0, _farmavalJs.translate_page)((0, _farmavalJs.page_lng));
    (0, _farmavalJs.set_enter)();
    // Purgar cachés de datos obsoletos si la versión del bundle cambió.
    // Debe ir ANTES de cualquier lectura de localStorage (getPharmDataFromCache).
    checkAppVersion();
    document.querySelectorAll(".btn_lng").forEach((el)=>{
        el.addEventListener("click", (e)=>{
            e.preventDefault();
            (0, _farmavalJs.translate_page)(el.getAttribute("href"), true);
        });
    });
    document.querySelectorAll(".disabled_link").forEach((el)=>{
        el.addEventListener("click", (e)=>{
            e.preventDefault();
            const link = document.createElement("a");
            link.href = el.getAttribute("aria-url");
            if (!el.hasAttribute("aria-target")) link.target = "_blank";
            link.rel = "noopener noreferrer";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    });
    if (document.getElementById("btn_login")) document.getElementById("btn_login").addEventListener("click", async (e)=>{
        e.preventDefault();
        const login_error = document.querySelector(".login_error");
        login_error.classList.add("hide");
        try {
            const username = (0, _selectElementsJs.$)("#login_user").val();
            const password = (0, _selectElementsJs.$)("#login_password").val();
            const response = await _indexJs1.login(username, password);
            // FIC-07: la farmacia está Suspendida o de Baja y no puede entrar.
            if (response?.accessBlocked) {
                login_error.innerHTML = (0, _farmavalJs.page_text)["login_error_blocked"];
                login_error.classList.remove("hide");
                return;
            }
            /*
           * Si la credencial no es de farmacia, puede ser la de un mentor (la
           * MISMA del panel): elige con cuál de sus farmacias entrar, o la
           * farmacia espejo de formación (BIB-05). No toca el login normal.
           */ if (!response || !response.token) {
                if (await showMentorPharmacies(username, password)) return;
            }
            if (response && response.token) {
                // Guardar el token de farmavel en localStorage
                localStorage.setItem("farmavel_token", response.token);
                // Mantener compatibilidad con código existente
                // Si no viene session del backend, usar el token como session
                if (response.session) localStorage.farmaval_session = response.session;
                else // Usar el token como session para compatibilidad con código legacy
                localStorage.farmaval_session = response.token;
                if (response.pharm?.pharm_id) localStorage.setItem("pharm_id", response.pharm.pharm_id);
                // Si también viene pharm_token, guardarlo para compatibilidad
                if (response.pharm_token) localStorage.setItem("pharm_token", response.pharm_token);
                console.log("\u2705 Credenciales guardadas:", {
                    farmavel_token: "\u2713",
                    farmaval_session: "\u2713",
                    pharm_id: response.pharm?.pharm_id ? "\u2713" : "\u2717"
                });
                // Adaptar la respuesta al formato esperado por el código existente
                const adaptedData = {
                    status: true,
                    pharm: response.pharm || response.user || {},
                    data: response.data || {},
                    agreement: response.agreement,
                    group: response.group,
                    session: response.session || response.token,
                    token: response.pharm_token || response.token
                };
                // Guardar todos los datos en caché para uso posterior
                savePharmDataToCache(adaptedData);
                // TL-01: habilitar los iconos de taller accesibles (vitalicio)
                (0, _workshopsJs.initWorkshopIcons)();
                createServerV2Session(response.session, response.pharm.pharm_id);
                if (adaptedData.pharm.pharm_reset_password == 1) show_logged(false, true);
                else {
                    load_pharm_data(adaptedData);
                    if (!test_pending(adaptedData.pharm.pharm_active, adaptedData.group)) show_logged(true);
                }
            } else {
                login_error.innerHTML = (0, _farmavalJs.page_text)["login_error_user"];
                login_error.classList.remove("hide");
            }
        } catch (err) {
            console.error("Login error:", err);
            login_error.innerHTML = (0, _farmavalJs.page_text)["login_error_server"] || (0, _farmavalJs.page_text)["login_error_user"];
            login_error.classList.remove("hide");
        }
    });
    initMentorAccess();
    // JWT en localStorage = sesión viva. farmaval_session es legado (mismo valor).
    const hasToken = localStorage.getItem("farmavel_token");
    console.log("\uD83D\uDD0D Estado de autenticaci\xf3n:", {
        hasToken: hasToken ? "S\xcd" : "NO",
        tokenPreview: hasToken ? hasToken.substring(0, 20) + "..." : "N/A"
    });
    if (hasToken) {
        const cachedData = getPharmDataFromCache();
        const hasCache = Boolean(cachedData && cachedData.pharm);
        if (hasCache) {
            console.log("\uD83D\uDD04 Sesi\xf3n restaurada desde cach\xe9 local");
            applyRestoredPharm(cachedData);
        } else console.log("\u26A0\uFE0F Sin cach\xe9 local, restaurando con GET /v1/auth/me");
        _indexJs1.refreshPharmData().then((data)=>{
            if (data && data.status) {
                console.log("\u2705 Sesi\xf3n validada con /v1/auth/me");
                if (hasCache) applyLivePharmRefresh(data);
                else {
                    const adapted = adaptAuthMePayload(data);
                    savePharmDataToCache(adapted);
                    applyRestoredPharm(adapted);
                }
                return;
            }
            if (data?.httpStatus === 401) {
                console.warn("\u274C Token rechazado por /v1/auth/me, cerrando sesi\xf3n");
                clearUserSession();
                show_logged(false);
                return;
            }
            console.warn("\u26A0\uFE0F /v1/auth/me no disponible, se conserva el token:", data);
            if (!hasCache) show_logged(false);
        });
    } else {
        console.log("\u2139\uFE0F No hay credenciales v\xe1lidas, mostrando login");
        show_logged(false);
    }
    if (document.getElementById("btn_logout")) document.getElementById("btn_logout").addEventListener("click", (e)=>{
        e.preventDefault();
        (0, _farmavalJs.server_function)("logout", {}, (data)=>{
            console.log("Logout:", data);
            // Validar que el logout fue exitoso (o forzar limpieza si falla)
            if (!data || data.status || data.result === "ok") {
                // Limpiar datos de sesión del localStorage
                clearUserSession();
                // Actualizar UI
                show_logged(false);
                // Recargar página para reiniciar estado
                location.reload();
            } else {
                // Si el servidor falla, forzar limpieza local de todos modos
                console.error("Logout fall\xf3 en servidor, forzando limpieza local");
                clearUserSession();
                show_logged(false);
                location.reload();
            }
        });
    });
    // Cancel password update button - logs out and redirects to login
    if (document.getElementById("btn_cancel_password")) document.getElementById("btn_cancel_password").addEventListener("click", (e)=>{
        e.preventDefault();
        (0, _farmavalJs.server_function)("logout", {}, (data)=>{
            clearUserSession();
            show_logged(false);
            location.reload();
        });
    });
    document.querySelectorAll("[aria-btn-trigger]").forEach((element)=>{
        element.addEventListener("keypress", function(e) {
            if (e.key === "Enter") document.getElementById(this.getAttribute("aria-btn-trigger")).dispatchEvent(new Event("click"));
        }, false);
    });
    document.querySelectorAll(".btn_signature").forEach((el)=>{
        el.addEventListener("click", (e)=>{
            e.preventDefault();
            const popup = document.getElementById(el.getAttribute("href"));
            popup.setAttribute("target", el.getAttribute("target"));
            popup.classList.remove("hide");
            const canvas = popup.querySelector("canvas");
            let ctx = canvas.getContext("2d");
            ctx.canvas.width = canvas.offsetWidth;
            ctx.canvas.height = canvas.offsetHeight;
        });
    });
    document.querySelectorAll(".popup_signature").forEach((el)=>{
        const canvas = el.querySelector("canvas");
        enable_touchevents(canvas);
        let mousePressed = false;
        let x = 0, y = 0;
        let ctx = canvas.getContext("2d");
        canvas.addEventListener("mousedown", (e)=>{
            mousePressed = true;
            x = e.offsetX;
            y = e.offsetY;
        });
        canvas.addEventListener("mouseup", (e)=>{
            mousePressed = false;
        });
        canvas.addEventListener("mousemove", (e)=>{
            if (!mousePressed) return;
            ctx.beginPath();
            ctx.strokeStyle = "black";
            ctx.lineWidth = 1;
            ctx.lineJoin = "round";
            ctx.moveTo(x, y);
            x = e.offsetX;
            y = e.offsetY;
            ctx.lineTo(x, y);
            ctx.stroke();
        });
        canvas.addEventListener("mouseleave", (e)=>{
            mousePressed = false;
        });
        el.querySelector(".btn_signature_cancel").addEventListener("click", (e)=>{
            e.preventDefault();
            ctx.setTransform(1, 0, 0, 1, 0, 0);
            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
            el.classList.add("hide");
        });
        el.querySelector(".btn_signature_use").addEventListener("click", (e)=>{
            e.preventDefault();
            document.getElementById(el.getAttribute("target")).src = canvas.toDataURL();
            ctx.setTransform(1, 0, 0, 1, 0, 0);
            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
            el.classList.add("hide");
        });
        el.querySelector(".btn_signature_clear").addEventListener("click", (e)=>{
            e.preventDefault();
            ctx.setTransform(1, 0, 0, 1, 0, 0);
            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        });
    });
    if (page_vars["test"]) document.querySelectorAll(".test").forEach((el)=>{
        el.classList.remove("test");
    });
    document.querySelectorAll(".btn_select_file").forEach((el)=>{
        const input = document.getElementById(el.getAttribute("href"));
        el.addEventListener("click", (e)=>{
            e.preventDefault();
            input.click();
        });
        input.addEventListener("change", function(e) {
            e.preventDefault();
            if (this.files.length === 0) return;
            var imageFile = this.files[0];
            const target = document.getElementById(input.getAttribute("target"));
            var reader = new FileReader();
            reader.onload = function(aImg) {
                return function(e) {
                    target.setAttribute("src", e.target.result);
                };
            }(target);
            reader.readAsDataURL(imageFile);
        });
    });
    const reportsTabAutoLoad = {
        reports_list: {
            btn: "btn_list_reports",
            isLoaded: ()=>!!document.querySelector("#table_reports tbody tr")
        },
        reports_staff: {
            btn: "btn_list_staff",
            isLoaded: ()=>!!document.querySelector("#table_reports_staff tbody tr")
        },
        reports_stats: {
            btn: "btn_show_stats",
            isLoaded: ()=>!document.getElementById("report_stats_window")?.classList.contains("hide")
        },
        reports_stats_iretia: {
            btn: "btn_show_stats_iretia",
            isLoaded: ()=>!document.getElementById("report_stats_iretia_window")?.classList.contains("hide")
        },
        reports_dosing: {
            btn: "btn_list_dosing",
            isLoaded: ()=>!!document.querySelector("#table_dosing_results tbody tr")
        }
    };
    document.querySelectorAll("[aria-section]").forEach((el)=>{
        el.addEventListener("click", (e)=>{
            e.preventDefault();
            el.parentNode.querySelector(".selected").classList.remove("selected");
            el.classList.add("selected");
            document.querySelector("section.selected").classList.remove("selected");
            document.getElementById(el.getAttribute("aria-section")).classList.add("selected");
            // Una sección puede declarar la función que carga sus datos al abrirse,
            // igual que hacen los tabs con `aria-function`.
            //
            // El atributo es `aria-section-function` y NO `aria-function` a
            // propósito: el handler genérico de `[aria-function]` manda todo lo que
            // no esté migrado al backend legado, así que reutilizar ese nombre
            // dispararía además una llamada a `functions.php`.
            const sectionFunction = el.getAttribute("aria-section-function");
            if (sectionFunction && custom_functions[sectionFunction]) custom_functions[sectionFunction](el);
            if (el.getAttribute("aria-section") === "section_reports") {
                const activeTab = document.querySelector("#section_reports .tab_btn.selected")?.getAttribute("href");
                const tabConfig = reportsTabAutoLoad[activeTab];
                if (tabConfig && !tabConfig.isLoaded()) document.getElementById(tabConfig.btn)?.click();
            } else if (el.getAttribute("aria-section") === "section_marketing") load_materials();
        });
    });
    document.querySelectorAll("#section_reports .tab_btn").forEach((el)=>{
        el.addEventListener("click", ()=>{
            const tabId = el.getAttribute("href");
            const tabConfig = reportsTabAutoLoad[tabId];
            if (tabConfig && !tabConfig.isLoaded()) document.getElementById(tabConfig.btn)?.click();
        });
    });
    document.getElementById("new_password").addEventListener("input", validate_password);
    document.getElementById("renew_password").addEventListener("input", validate_password);
    if (document.getElementById("btn_update_password")) document.getElementById("btn_update_password").addEventListener("click", (e)=>{
        e.preventDefault();
        if (e.target.disabled) return;
        const update_error = document.querySelector("#section_update_password .login_error");
        update_error.classList.add("hide");
        (0, _farmavalJs.server_function)("updatePassword", {
            password: document.getElementById("new_password").value
        }, (res)=>{
            if (res.status) on_password_updated();
            else {
                if (res.error == "error_same") update_error.innerHTML = (0, _farmavalJs.page_text)["update_same"];
                else update_error.innerHTML = (0, _farmavalJs.page_text)["update_error"];
                update_error.classList.remove("hide");
            }
        });
    });
    if (document.getElementById("btn_register_pharm")) document.getElementById("btn_register_pharm").addEventListener("click", (e)=>{
        e.preventDefault();
        if (e.target.disabled) return;
        const update_error = document.querySelector("#section_update_password .login_error");
        update_error.classList.add("hide");
        (0, _farmavalJs.server_function)("updatePassword", {
            password: document.getElementById("new_password").value
        }, (res)=>{
            if (res.status) location.reload();
            else update_error.classList.remove("hide");
        });
    });
    document.querySelectorAll(".tab_btn").forEach((el)=>{
        el.addEventListener("click", (e)=>{
            e.preventDefault();
            if (el.classList.contains("selected")) return;
            const tabScope = el.closest(".tabs_top") || el.parentNode;
            const prev = tabScope.querySelector(".tab_btn.selected");
            if (prev) {
                prev.classList.remove("selected");
                document.getElementById(prev.getAttribute("href")).classList.add("hide");
            }
            el.classList.add("selected");
            if (el.hasAttribute("aria-function")) custom_functions[el.getAttribute("aria-function")](el);
            document.getElementById(el.getAttribute("href")).classList.remove("hide");
        });
    });
    document.querySelectorAll(".operation_confirm input").forEach((el)=>{
        el.addEventListener("keydown", (e)=>{
            if (e.keyCode == 27) {
                el.value = "";
                el.parentElement.classList.add("hide");
            }
        });
    });
    document.querySelectorAll(".close_popup").forEach((el)=>{
        el.addEventListener("click", (e)=>{
            e.preventDefault();
            document.getElementById(el.getAttribute("href")).classList.remove("visible");
        });
    });
    document.querySelectorAll(".popup_cover").forEach((el)=>{
        el.addEventListener("click", (e)=>{
            e.preventDefault();
            const w = document.querySelector(".popup.visible");
            if (w) w.classList.remove("visible");
        });
    });
    const serviceItems = document.querySelectorAll(".service_item");
    serviceItems.forEach((el)=>{
        el.addEventListener("click", async (e)=>{
            // Si está deshabilitado, no hacer nada
            if (el.classList.contains("disabled")) {
                e.preventDefault();
                return;
            }
            // Si tiene atributo default, permitir navegación normal (no prevenir)
            if (el.hasAttribute("default")) // No hacemos preventDefault para permitir navegación normal
            return;
            // Para todos los demás casos, prevenir navegación por defecto
            e.preventDefault();
            // === Manejo de servicios Vue.js (Gen 2) ===
            if (el.hasAttribute("data-vue-service")) {
                const vueName = el.getAttribute("data-vue-service");
                await mountVueService(vueName);
                return;
            }
            // === NUEVO: Manejo de Links Firmados ===
            if (el.hasAttribute("data-requires-signed-link")) {
                // Obtener pharm_id del localStorage
                const pharmId = localStorage.getItem("pharm_id");
                if (!pharmId) {
                    alert((0, _farmavalJs.page_text)["error_session"] || "Error de sesi\xf3n. Por favor, vuelva a iniciar sesi\xf3n.");
                    return;
                }
                const loadingElement = el.querySelector(".service_loading");
                if (loadingElement) loadingElement.classList.remove("hide");
                try {
                    const signedUrl = await generateProbioSignedLink(pharmId);
                    if (loadingElement) loadingElement.classList.add("hide");
                    if (signedUrl) {
                        const link = document.createElement("a");
                        link.href = signedUrl;
                        link.target = "_blank";
                        link.rel = "noopener noreferrer";
                        link.click();
                    } else alert((0, _farmavalJs.page_text)["error_probio_link"] || "No se pudo generar el acceso a Probio. Por favor, intente nuevamente.");
                } catch (error) {
                    if (loadingElement) loadingElement.classList.add("hide");
                    alert((0, _farmavalJs.page_text)["error_server"] || "Error de conexi\xf3n. Por favor, intente nuevamente.");
                }
                return;
            }
            // === FIN NUEVO ===
            // Manejo de servicios externos SIN firma (comportamiento actual)
            if (el.hasAttribute("extern")) {
                const link = document.createElement("a");
                link.href = el.getAttribute("href");
                link.target = "_blank";
                link.rel = "noopener noreferrer";
                link.click();
                return;
            }
            // Manejo de servicios internos en iframe (comportamiento actual)
            const { old_server_base } = (0, _apiResolverJs.getServerConfig)();
            const service_url = old_server_base + "service.php";
            const src = service_url + "?id=" + el.getAttribute("href") + "&session=" + localStorage.getItem("farmavel_token") + "&token=" + localStorage.getItem("farmavel_token") + "&pharm=" + localStorage.getItem("pharm_id") + "&user_pharm=" + localStorage.getItem("pharm_id") + "&type=v2" + "&lng=" + (0, _farmavalJs.page_lng) + "&v=" + (0, _versionJs.APP_BUILD_VERSION);
            console.log("Service URL:", src);
            const iframe = document.getElementById("service_iframe");
            iframe.src = src;
            iframe.classList.remove("hide");
        });
    });
    window.addEventListener("message", function(e) {
        // console.log("Post Message:",e);
        if (e.data.msg == "close_service") {
            document.getElementById("service_iframe").classList.add("hide");
            update_cache(null);
            if (e.data.login) show_logged(false);
        //location.reload();
        } else if (e.data.msg == "service_error") {
            console.log("service_error:", e.data);
            let services = null;
            if (this.localStorage.backup_services) services = JSON.parse(this.localStorage.backup_services);
            else services = [];
            services.push(e.data.service);
            localStorage.backup_services = JSON.stringify(services);
        }
    });
    // Botones de cierre para servicios Vue.js (Gen 2)
    document.querySelectorAll('[id^="btn_close_vue_"]').forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            const vueName = btn.id.replace("btn_close_vue_", "");
            unmountVueService(vueName);
        });
    });
    /**
   * Genera un link firmado dinámicamente desde el backend
   * @param {string} pharmId - ID de la farmacia
   * @returns {Promise<string|null>} - URL firmada o null si hay error
   */ async function generateProbioSignedLink(pharmId) {
        return new Promise((resolve)=>{
            (0, _farmavalJs.server_function)("getProbioMentorLink", {
                pharm_id: pharmId,
                lng: (0, _farmavalJs.page_lng)
            }, (response)=>{
                if (response && response.status === true && response.url) resolve(response.url);
                else if (response && response.status === false) {
                    console.error("\u274C Error del backend:", response.error || "Error desconocido");
                    resolve(null);
                } else {
                    console.error("\u274C Respuesta inesperada del backend");
                    console.error("Contenido:", response);
                    resolve(null);
                }
            });
        });
    }
    document.querySelectorAll("[aria-popup]").forEach((el)=>{
        el.addEventListener("click", (e)=>{
            e.preventDefault();
            const popup = document.getElementById(el.getAttribute("href"));
            if (popup) {
                empty_fields(popup);
                const callback = el.getAttribute("aria-prefunction");
                if (callback) myfuncs[callback](popup);
                clear_errors(popup, "add");
                if (popup.classList.contains("popup")) popup.classList.add("visible");
            }
        });
    });
    const todayFormatted = (()=>{
        const d = new Date();
        return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
    })();
    document.querySelectorAll("[aria-today]").forEach((el)=>{
        el.value = todayFormatted;
    });
    const filterServiceFrom = document.getElementById("filter_service_from");
    if (filterServiceFrom) filterServiceFrom.value = "2020-01-01";
    const reportsFromDateIds = [
        "filter_staff_from",
        "filter_stats_from",
        "filter_stats_iretia_from",
        "filter_dosing_from"
    ];
    reportsFromDateIds.forEach((id)=>{
        const el = document.getElementById(id);
        if (el) el.value = "2020-01-01";
    });
    document.querySelectorAll(".btn_show_report").forEach((el)=>{
        el.addEventListener("click", (e)=>{
            e.preventDefault();
            const viewer = document.getElementById("report_view");
            const reportHref = el.getAttribute("href");
            const sep = reportHref.includes("?") ? "&" : "?";
            viewer.querySelector("iframe").setAttribute("src", reportHref + sep + "v=" + (0, _versionJs.APP_BUILD_VERSION));
            viewer.classList.remove("hide");
        });
    });
    window.addEventListener("message", async function(e) {
        // console.log('Post: ', e)
        if (e.data == null) return;
        if (typeof e.data === "object") {
            if (e.data.msg == "farmaval_signature") document.getElementById(e.data.type).setAttribute("src", e.data.img);
            return;
        }
        if (e.data == "farmaval_close_agreement") {
            document.getElementById("agreement_popup").classList.add("hide");
            if (document.getElementById("ag_signer_signature").hasAttribute("src") && document.getElementById("ag_debtor_signature").hasAttribute("src")) {
                document.getElementById("btn_pending_upload").click();
                document.getElementById("pending_data").querySelectorAll("[aria-field]").forEach((el)=>{
                    el.disabled = true;
                });
            }
            return;
        }
        if (e.data == "farmaval_agreement_data") {
            const form = "pending_data";
            const now = new Date();
            const data = {
                ag_date_day: now.getDate(),
                ag_date_month_es: (0, _farmavalJs.page_text_es)["pending_months"].split(",")[now.getMonth()],
                ag_date_month_ca: (0, _farmavalJs.page_text_ca)["pending_months"].split(",")[now.getMonth()],
                ag_date_year: now.getFullYear(),
                ag_date: new Date().toLocaleDateString("es-ES", {
                    year: "numeric",
                    month: "long",
                    day: "numeric"
                })
            };
            document.getElementById(form).querySelectorAll("[aria-field]").forEach((el)=>{
                if (el.value && el.value !== "") {
                    if (el.tagName === "SELECT") data[el.getAttribute("id")] = el.options[el.selectedIndex].text;
                    else data[el.getAttribute("id")] = el.value;
                }
            });
            e.source.postMessage({
                msg: "farmaval_agreement_data",
                data: data
            });
            return;
        }
        if (e.data == "close_report") document.getElementById("report_view").classList.add("hide");
        if (e.data == "farmaval_close_report") document.getElementById("report_view").classList.add("hide");
        if (e.data == "farmaval_send_data") {
            const popup = document.getElementById("popup_report");
            (0, _farmavalJs.server_function)("getDataForReport", {
                rep_id: popup.querySelector("#rep_id").value,
                rep_service: popup.querySelector("#rep_service").value,
                server_base: (0, _farmavalJs.server_base)
            }, (res)=>{
                if (res.status) e.source.postMessage({
                    msg: "farmaval_data",
                    conditions: res.conditions,
                    values: res.values
                });
                else {
                    document.getElementById("report_view").classList.add("hide");
                    alert("error");
                }
            });
        }
    });
    if (document.getElementById("btn_print_stats")) document.getElementById("btn_print_stats").addEventListener("click", (e)=>{
        e.preventDefault();
        const w = window.open("stats.html", "");
        w.onload = function() {
            const el = w.document.querySelector(".print_preview");
            el.innerHTML = document.getElementById("report_stats_window").innerHTML;
            el.querySelectorAll("[aria-data]").forEach((lbl)=>{
                const date = new Date(document.getElementById(lbl.getAttribute("aria-data")).value);
                lbl.innerHTML = date.toLocaleString("es", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit"
                });
            });
            el.querySelectorAll("canvas").forEach((canvas)=>{
                const from = document.getElementById(canvas.getAttribute("id"));
                if (from) canvas.getContext("2d").drawImage(from, 0, 0);
            });
            setTimeout(function() {
                w.print();
            }, 1000);
        };
    });
    if (document.getElementById("btn_print_stats_iretia")) document.getElementById("btn_print_stats_iretia").addEventListener("click", (e)=>{
        e.preventDefault();
        const w = window.open("stats.html", "");
        w.onload = function() {
            const el = w.document.querySelector(".print_preview");
            el.innerHTML = document.getElementById("report_stats_iretia_window").innerHTML;
            setTimeout(function() {
                w.print();
            }, 1000);
        };
    });
    document.querySelectorAll("[aria-function]").forEach((el)=>{
        el.addEventListener("click", async (e)=>{
            const reportFunctions = [
                "getReports",
                "getStaffServices",
                "getStats",
                "getStatsIretia",
                "getDosingResults"
            ];
            const isReportFunction = reportFunctions.includes(el.getAttribute("aria-function"));
            const loadingOverlay = document.getElementById("reports_loading");
            const showReportsLoading = ()=>{
                if (isReportFunction && loadingOverlay) {
                    loadingOverlay.classList.remove("hide");
                    el.classList.add("loading");
                }
            };
            const hideReportsLoading = ()=>{
                if (isReportFunction && loadingOverlay) {
                    loadingOverlay.classList.add("hide");
                    el.classList.remove("loading");
                }
            };
            const resFunction = (res)=>{
                hideReportsLoading();
                console.log("Result: ", res);
                if (res.status) {
                    if (!el.hasAttribute("aria-sameform")) {
                        if (parent.classList.contains("popup")) parent.classList.remove("visible");
                        clear_errors(parent, "add");
                        empty_fields(parent);
                    }
                    if (!el.hasAttribute("aria-nook")) show_result(parent.getAttribute("aria-error-element"), "result_ok");
                    if (el.getAttribute("aria-post-function")) myfuncs[el.getAttribute("aria-post-function")](res);
                    if (el.getAttribute("aria-table")) fill_table(document.getElementById(el.getAttribute("aria-table")), res.data, item_click);
                    if (el.hasAttribute("aria-list")) {
                        if (res.data) {
                            const list = document.getElementById(el.getAttribute("aria-list"));
                            fill_list(list, res.data[list.getAttribute("aria-load")], item_click);
                        }
                    }
                } else show_result(parent.getAttribute("aria-error-element"), "error_operation", true, res.error);
            };
            e.preventDefault();
            let params = {
                lng: (0, _farmavalJs.page_lng),
                user_pharm: localStorage.getItem("pharm_id") ?? null
            };
            const parent = document.getElementById(el.getAttribute("href"));
            if (parent) {
                show_result(parent.getAttribute("aria-error-element"));
                const noreq = el.hasAttribute("noreq");
                const fields = parent.querySelectorAll("[aria-field]");
                for (const field of fields){
                    let valid = true;
                    if (field.tagName == "IMG") {
                        if (field.hasAttribute("required")) valid = field.getAttribute("src") ? true : false;
                    } else valid = field.checkValidity();
                    if (!valid && !noreq) field.classList.add("novalid");
                    else {
                        field.classList.remove("novalid");
                        if (field.tagName == "IMG") {
                            if (field.hasAttribute("src")) params[field.getAttribute("id")] = field.getAttribute("src");
                        } else params[field.getAttribute("id")] = field.value;
                    }
                }
                if (parent.querySelector("[aria-field].novalid")) {
                    show_result(parent.getAttribute("aria-error-element"), "error_empty_fields", true);
                    return;
                }
            }
            if (el.hasAttribute("aria-custom-function")) {
                custom_functions[el.getAttribute("aria-function")](el);
                return;
            }
            if (el.getAttribute("aria-confirm")) {
                const confirm1 = document.getElementById(el.getAttribute("aria-confirm"));
                const input = confirm1.querySelector("input");
                if (input.value != (0, _farmavalJs.page_text)[input.getAttribute("aria-text")]) {
                    confirm1.classList.remove("hide");
                    input.focus();
                    return;
                }
            }
            if (el.getAttribute("aria-pre-function")) myfuncs[el.getAttribute("aria-pre-function")](parent, params);
            showReportsLoading();
            console.log("Params " + el.getAttribute("aria-function") + ": ", params);
            switch(el.getAttribute("aria-function")){
                // Funciones migradas a Farmavel
                case "getDosingResults":
                    const dosingResults = await _indexJs1.getDosingResults({
                        from: params.filter_dosing_from,
                        to: params.filter_dosing_to,
                        drug: params.filter_dosing_drug,
                        patient: params.filter_dosing_patient,
                        state: params.filter_dosing_state || "active"
                    });
                    resFunction(dosingResults);
                    if (dosingResults?.status) {
                        attachDosingDeleteActions();
                        attachDosingAcceptanceToggle();
                        applyDosingCorrectionFilter();
                    }
                    break;
                case "getStats":
                    const satiReport = await _indexJs1.getSatiReport(params.user_pharm, params.filter_stats_from, params.filter_stats_to, params.lng);
                    resFunction(satiReport);
                    break;
                case "getReports":
                    const reportsList = await _indexJs1.getReports({
                        service: params.filter_service_type || "0",
                        from: params.filter_service_from,
                        to: params.filter_service_to,
                        patient: params.filter_service_patient
                    });
                    resFunction(reportsList);
                    break;
                case "updateReport":
                    {
                        // Migración fase A: la edición del informe y de sus ventas deja de
                        // pasar por `farmaval-server-v2`.
                        //
                        // `rep_sales` lo prepara `pre_add_sales`: los elementos con `sale_id`
                        // son bajas y el resto altas. Si no hay ninguna venta que tocar, la
                        // clave no viaja.
                        const updatedReport = await _indexJs1.updateReport(params.rep_id, params.rep_comments, params.rep_sales || []);
                        resFunction(updatedReport);
                        break;
                    }
                case "addProduct":
                    {
                        // AD-31: «Mis productos» contra farmavel, la misma fuente que usan los
                        // servicios. Antes iba a farmaval-server-v2, que devolvía otra lista.
                        const savedProduct = await _indexJs1.savePharmacyProduct(params);
                        resFunction(savedProduct);
                        if (savedProduct?.status) update_products_cache(savedProduct.data?.products);
                        break;
                    }
                case "deleteProduct":
                    {
                        const deletedProduct = await _indexJs1.deletePharmacyProduct(params.prod_id, params.lng);
                        resFunction(deletedProduct);
                        if (deletedProduct?.status) update_products_cache(deletedProduct.data?.products);
                        break;
                    }
                default:
                    // Funciones no migradas a Farmavel
                    (0, _farmavalJs.server_function)(el.getAttribute("aria-function"), params, resFunction);
                    return;
            }
        });
    });
    if (document.getElementById("btn_syncro_now")) document.getElementById("btn_syncro_now").addEventListener("click", (e)=>{
        e.preventDefault();
        const services = JSON.parse(localStorage.backup_services);
        const list = document.querySelectorAll("#table_cache_services tbody .backup_row");
        syncro_all_services(services, list);
    });
    setupDosingDeletePopup();
    setupProbioHistoryDeletePopup();
    document.getElementById("filter_dosing_correction")?.addEventListener("change", applyDosingCorrectionFilter);
    // Verificar en segundo plano si el servidor tiene una versión más nueva.
    // Si index.html estaba cacheado (edge/CDN obsoleto), recarga una sola vez — solo si
    // no hay un servicio/formulario abierto (nunca interrumpir a un farmacéutico).
    checkServerVersion();
}
async function syncro_service(params) {
    let res;
    if (params.new_server) res = await (0, _farmavalJs.server_function)(null, params);
    else res = await (0, _farmavalJs.old_server_function)(params);
    if (res.result == "ok" || res.status) return {
        res: true
    };
    else return {
        res: false,
        error: "Error: " + res.type
    };
}
async function syncro_all_services(services, list) {
    let bad_services = [];
    let count = list.length;
    let row = services.length - 1;
    for(let e = 0; e < list.length; e++){
        const element = list[e];
        console.log("Syncro:", services[row]);
        const ret = await syncro_service(services[row]);
        if (ret.res) {
            element.classList.add("done");
            element.classList.remove("error");
            element.querySelector(".result").innerHTML = "OK";
            count--;
            setTimeout(function() {
                const parent = element.parentNode;
                element.remove();
                if (!parent.hasChildNodes()) document.getElementById("syncro_services_wrapper").classList.add("disabled");
            }, 1000);
        } else {
            bad_services.push(services[row]);
            element.classList.add("error");
            element.classList.remove("done");
            element.querySelector(".result").innerHTML = ret.error;
        }
        row--;
        if (row < 0) {
            localStorage.backup_services = JSON.stringify(bad_services);
            document.querySelectorAll(".syncro_data_services").forEach((el)=>{
                el.innerHTML = count;
            });
        }
    }
}
function enable_touchevents(canvas) {
    canvas.addEventListener("touchstart", function(e) {
        var touch = e.touches[0];
        var mouseEvent = new MouseEvent("mousedown", {
            clientX: touch.clientX,
            clientY: touch.clientY
        });
        canvas.dispatchEvent(mouseEvent);
    }, false);
    canvas.addEventListener("touchend", function(e) {
        var mouseEvent = new MouseEvent("mouseup", {});
        canvas.dispatchEvent(mouseEvent);
    }, false);
    canvas.addEventListener("touchmove", function(e) {
        var touch = e.touches[0];
        var mouseEvent = new MouseEvent("mousemove", {
            clientX: touch.clientX,
            clientY: touch.clientY
        });
        canvas.dispatchEvent(mouseEvent);
    }, false);
    document.body.addEventListener("touchstart", function(e) {
        if (e.target == canvas) e.preventDefault();
    }, {
        passive: false
    });
    document.body.addEventListener("touchend", function(e) {
        if (e.target == canvas) e.preventDefault();
    }, {
        passive: false
    });
    document.body.addEventListener("touchmove", function(e) {
        if (e.target == canvas) e.preventDefault();
    }, {
        passive: false
    });
}
function show_result(el, text = null, error = false, type = null) {
    const err = document.getElementById(el);
    if (err) {
        if (text) {
            if (error) err.classList.remove("server_ok");
            else err.classList.add("server_ok");
            err.innerHTML = (0, _farmavalJs.page_text)[text];
            if (type) {
                if ((0, _farmavalJs.page_text)[type]) type = (0, _farmavalJs.page_text)[type];
                err.innerHTML += " (" + type + ")";
            }
            err.classList.remove("hide");
        } else err.classList.add("hide");
    }
}
function fill_pharm_options(data, type, field_name, field_value, more_values = null) {
    if (data[type]) document.querySelectorAll("[aria-pharm-data='" + type + "']").forEach((el)=>{
        el.innerHTML = "";
        for(const s in data[type]){
            const item = data[type][s];
            // Filtrar servicios no agendables del dropdown del calendario
            if (el.id === "date_service" && type === "services" && item.is_schedulable === 0) continue;
            // `field_name` admite una lista de campos por prioridad: los tres
            // backends no resuelven el idioma en la misma clave (farmavel manda el
            // nombre ya resuelto en prod_name; server-v2 y v1 lo mandan aparte en
            // prod_display_name), así que se coge el primero que venga.
            const label = Array.isArray(field_name) ? field_name.map((f)=>item[f]).find((v)=>v != null && v !== "") : item[field_name];
            const option = new Option(label ?? "", item[field_value]);
            if (more_values) for(const v in more_values)option.setAttribute(more_values[v].name, item[more_values[v].field]);
            el.add(option);
        }
    });
}
function update_cache(data) {
    if (data) document.querySelectorAll("[aria-cache]").forEach((el)=>{
        const type = el.getAttribute("aria-cache");
        if (data[type]) {
            el.innerHTML = data[type].length;
            localStorage[type] = JSON.stringify(data[type]);
        }
    });
    const count = localStorage.backup_services ? JSON.parse(localStorage.backup_services).length : 0;
    document.querySelectorAll(".syncro_data_services").forEach((el)=>{
        el.innerHTML = count;
    });
    if (!count) document.getElementById("syncro_services_wrapper").classList.add("disabled");
    else {
        document.getElementById("syncro_services_wrapper").classList.remove("disabled");
        if (localStorage.backup_services) {
            const services = JSON.parse(localStorage.backup_services);
            const table = document.querySelector("#table_cache_services tbody");
            table.innerHTML = "";
            for(let a = count - 1; a >= 0; a--){
                console.log("Cache: ", services[a]);
                const item = document.querySelector("#elements .backup_row").cloneNode(true);
                item.querySelector("[aria-field='service_date']").innerHTML = services[a].rep_start || services[a].data.start;
                item.querySelector("[aria-field='service_type']").innerHTML = services[a].rep_service || services[a].data.type;
                table.append(item);
            }
        }
    }
    if (localStorage.syncro_date) document.getElementById("syncro_data_date").innerHTML = localStorage.syncro_date;
    else document.getElementById("syncro_data_date").innerHTML = "---";
}
// ── Probióticos de farmacia — tab de perfil (Vue 3 embebido) ─────────────────
// Instancia montada del tab (para no re-montar en cada apertura del tab).
let _profileProbioticsApp = null;
let _probioticsTabInitialized = false;
let _probioConsultasFiltersInit = false;
let _probioHistoryNoticeTimer = null;
/**
 * Monta el componente Vue del tab Probióticos dentro de su panel (#profile_probiotics).
 * Import dinámico: el bundle Vue solo se carga cuando el usuario abre el tab.
 */ async function mountProfileProbioticsVue() {
    if (_profileProbioticsApp) return;
    const container = document.getElementById("profile_probiotics");
    if (!container) return;
    const [vue, appMod] = await Promise.all([
        require("420234599e934fc9"),
        require("600e499a5dbbb36f")
    ]);
    container.innerHTML = "";
    const app = vue.createApp(appMod.default, {
        pharmId: localStorage.getItem("pharm_id") || "",
        token: localStorage.getItem("farmavel_token") || "",
        lng: localStorage.getItem("farmaval_lng") || "es"
    });
    app.mount(container);
    _profileProbioticsApp = app;
}
/**
 * Engancha el montaje perezoso del tab Probióticos: se monta la primera vez que
 * el usuario abre el tab (o de inmediato si el panel ya está visible).
 */ function init_profile_probiotics_tab() {
    if (_probioticsTabInitialized) return;
    _probioticsTabInitialized = true;
    document.getElementById("tab_btn_profile_probiotics")?.addEventListener("click", ()=>{
        mountProfileProbioticsVue();
    });
    const panel = document.getElementById("profile_probiotics");
    if (panel && !panel.classList.contains("hide")) mountProfileProbioticsVue();
}
// ── Seguimiento de pacientes respiratorios — tab de Pacientes (FA-07 / FA-08) ──
let _patientFollowupApp = null;
let _patientFollowupMounting = null;
let _patientFollowupTabInitialized = false;
/**
 * Monta el componente Vue del tab Seguimiento dentro de su panel (#patients_followup).
 * Import dinámico: el bundle Vue solo se carga cuando el usuario abre el tab. Guarda la
 * promesa del montaje para que dos llamadas seguidas (abrir el tab y «Ver historial») no
 * monten la app dos veces.
 */ function mountPatientFollowupVue() {
    if (_patientFollowupApp) return Promise.resolve();
    if (_patientFollowupMounting) return _patientFollowupMounting;
    _patientFollowupMounting = (async ()=>{
        const container = document.getElementById("patients_followup");
        if (!container) return;
        const [vue, appMod] = await Promise.all([
            require("420234599e934fc9"),
            require("6184bf91fbf2fa0a")
        ]);
        container.innerHTML = "";
        const app = vue.createApp(appMod.default, {
            lng: localStorage.getItem("farmaval_lng") || "es"
        });
        app.mount(container);
        _patientFollowupApp = app;
    })();
    return _patientFollowupMounting;
}
/**
 * «Ver historial» en la ficha de un paciente (FA-07): cierra la ficha, pasa al tab
 * Seguimiento y abre allí el historial de ese paciente.
 */ async function open_patient_history(patientId) {
    if (!patientId) return;
    document.getElementById("popup_patient")?.classList.remove("visible");
    const tab = document.getElementById("tab_btn_patients_followup");
    if (tab && !tab.classList.contains("selected")) tab.click();
    await mountPatientFollowupVue();
    window.dispatchEvent(new CustomEvent("farmaval:patient-history", {
        detail: {
            patientId
        }
    }));
}
/** Engancha el montaje perezoso del tab Seguimiento: se monta la primera vez que se abre. */ function init_patient_followup_tab() {
    if (_patientFollowupTabInitialized) return;
    _patientFollowupTabInitialized = true;
    document.getElementById("tab_btn_patients_followup")?.addEventListener("click", ()=>{
        mountPatientFollowupVue();
    });
    document.getElementById("btn_patient_history")?.addEventListener("click", (e)=>{
        e.preventDefault();
        open_patient_history(document.querySelector("#popup_patient #patient_id")?.value);
    });
}
/**
 * Filtros de las pantallas de Consultas Probiomentor (Etapa 09).
 * Viven en la sección de reportes, no en el tab de perfil.
 */ function init_probio_consultas_filters() {
    if (_probioConsultasFiltersInit) return;
    _probioConsultasFiltersInit = true;
    document.getElementById("btn_filter_probio_history")?.addEventListener("click", ()=>{
        const from = document.getElementById("probio_filter_from")?.value || null;
        const to = document.getElementById("probio_filter_to")?.value || null;
        load_probiomentor_history(from, to);
    });
    document.getElementById("btn_filter_probio_team")?.addEventListener("click", ()=>{
        const from = document.getElementById("probio_team_from")?.value || null;
        const to = document.getElementById("probio_team_to")?.value || null;
        load_probiomentor_team_stats(from, to);
    });
    document.getElementById("btn_filter_probio_consultas")?.addEventListener("click", ()=>{
        const from = document.getElementById("probio_consultas_from")?.value || null;
        const to = document.getElementById("probio_consultas_to")?.value || null;
        load_probiomentor_consultas_stats(from, to);
    });
}
// ── Etapa 09: Consultas Probiomentor ─────────────────────────────────────────
async function load_probiomentor_history(from, to) {
    const params = {};
    if (from) params.from = from;
    if (to) params.to = to;
    const resp = await _indexJs1.getProbiomentorHistory(params);
    const rows = resp?.data || [];
    const tbody = document.getElementById("tbody_probio_history");
    const empty = document.getElementById("probio_history_empty");
    if (!tbody) return;
    tbody.innerHTML = "";
    if (!rows.length) {
        empty?.classList.remove("hide");
        return;
    }
    empty?.classList.add("hide");
    rows.forEach((row)=>{
        const tr = document.createElement("tr");
        tr.className = "tr probio_history_row";
        const isDeleted = Boolean(row.deleted_at);
        if (isDeleted) tr.classList.add("probio_history_row_deleted");
        tr.innerHTML = `
            <td class="td">${row.staff_name}</td>
            <td class="td">${row.date ?? "-"}</td>
            <td class="td">${row.time ?? "-"}</td>
            <td class="td">${row.indication ?? "-"}</td>
            <td class="td">${row.probiotic ?? "-"}</td>
            <td class="td">${row.probiotic_cn ?? "-"}</td>
            <td class="td ${row.accepted ? "text_success" : "text_warning"}">${row.accepted ? "\u2713 S\xed" : "\u2717 No"}</td>
            <td class="td">${row.pvp != null ? row.pvp + " \u20AC" : "-"}</td>
            <td class="td">${row.duration_min != null ? row.duration_min + " min" : "-"}</td>
            <td class="td text_center"></td>
        `;
        const actionsCell = tr.lastElementChild;
        if (isDeleted) actionsCell.textContent = (0, _farmavalJs.page_text)["probio_history_deleted_badge"] || "";
        else if (row.id != null) {
            const btn = document.createElement("div");
            btn.className = "btn_default btn_small btn_warning probio_history_delete_btn";
            btn.style.cursor = "pointer";
            btn.textContent = (0, _farmavalJs.page_text)["btn_delete"] || "";
            btn.onclick = (event)=>{
                event.preventDefault();
                event.stopPropagation();
                openProbioHistoryDeletePopup(row.id);
            };
            actionsCell.appendChild(btn);
        }
        tbody.appendChild(tr);
    });
}
function setupProbioHistoryDeletePopup() {
    const confirmButton = document.getElementById("btn_probio_history_delete_confirm");
    if (!confirmButton) return;
    confirmButton.onclick = async (event)=>{
        event.preventDefault();
        const popup = document.getElementById("popup_probio_history_delete");
        const id = document.getElementById("probio_history_delete_id")?.value;
        const reason = document.getElementById("probio_history_delete_reason")?.value?.trim() || "";
        if (!popup || !id) return;
        confirmButton.classList.add("disabled");
        const result = await _indexJs1.deleteProbiomentorService(id, reason);
        if (result?.status) {
            popup.classList.remove("visible");
            show_result("probio_history_delete_error");
            confirmButton.classList.remove("disabled");
            const from = document.getElementById("probio_filter_from")?.value || null;
            const to = document.getElementById("probio_filter_to")?.value || null;
            load_probiomentor_history(from, to);
            // Aviso de confirmación sobre la tabla; se oculta solo pasados unos segundos.
            show_result("probio_history_notice", "probio_history_deleted_ok", false);
            clearTimeout(_probioHistoryNoticeTimer);
            _probioHistoryNoticeTimer = setTimeout(()=>show_result("probio_history_notice"), 5000);
            return;
        }
        confirmButton.classList.remove("disabled");
        show_result("probio_history_delete_error", "error_operation", true);
    };
}
function openProbioHistoryDeletePopup(id) {
    const popup = document.getElementById("popup_probio_history_delete");
    if (!popup) return;
    empty_fields(popup);
    clear_errors(popup, "add");
    document.getElementById("probio_history_delete_id").value = id;
    popup.classList.add("visible");
}
async function load_probiomentor_team_stats(from, to) {
    const params = {};
    if (from) params.from = from;
    if (to) params.to = to;
    const [resp, statsResp] = await Promise.all([
        _indexJs1.getProbiomentorTeamStats(params),
        _indexJs1.getProbiomentorServicesStats(params)
    ]);
    const t = (key)=>(0, _farmavalJs.page_text)[key] || key;
    // Tabla: prestación por miembro del equipo (con ventas)
    const rows = resp?.data || [];
    const tbody = document.getElementById("tbody_probio_team");
    if (tbody) tbody.innerHTML = rows.map((row)=>{
        const rateClass = row.acceptance_rate >= 80 ? "text_success" : row.acceptance_rate >= 50 ? "text_warning" : "text_danger";
        return `
            <tr class="tr">
                <td class="td">${row.staff_name}</td>
                <td class="td">${row.total}</td>
                <td class="td text_success">${row.accepted}</td>
                <td class="td text_warning">${row.rejected}</td>
                <td class="td ${rateClass}">${row.acceptance_rate}%</td>
                <td class="td">${row.avg_duration_min ?? 0} min</td>
                <td class="td">${row.sales ?? 0} \u{20AC}</td>
                <td class="td">${row.avg_sale ?? 0} \u{20AC}</td>
            </tr>`;
    }).join("");
    // Tabla: datos generales (mi farmacia / media / mejor)
    const general = statsResp?.general;
    const dgTbody = document.getElementById("tbody_probio_services_stats");
    if (dgTbody && general) {
        const dgRows = [
            {
                label: t("probio_dg_services"),
                m: general.services
            },
            {
                label: t("probio_dg_services_per_day"),
                m: general.services_per_day
            },
            {
                label: t("probio_dg_services_per_person"),
                m: general.services_per_person
            },
            {
                label: t("probio_dg_avg_time"),
                m: general.avg_time_min
            },
            {
                label: t("probio_dg_total_sales"),
                m: general.total_sales
            },
            {
                label: t("probio_dg_avg_sale"),
                m: general.avg_sale
            },
            {
                label: t("probio_dg_with_sales"),
                m: general.with_sales_rate
            }
        ];
        dgTbody.innerHTML = dgRows.map((r)=>`
            <tr class="tr">
                <td class="td">${r.label}</td>
                <td class="td">${r.m?.pharmacy ?? 0}</td>
                <td class="td">${r.m?.average ?? 0}</td>
                <td class="td">${r.m?.best ?? 0}</td>
            </tr>`).join("");
    }
    // Tabla: indicaciones más frecuentes
    const indTbody = document.getElementById("tbody_probio_indications");
    if (indTbody) {
        const inds = statsResp?.indications || [];
        if (!inds.length) indTbody.innerHTML = `<tr class="tr"><td class="td" colspan="3">${t("probio_indications_empty")}</td></tr>`;
        else {
            indTbody.innerHTML = inds.map((i)=>{
                if (i.is_others) {
                    const others = i.others || [];
                    const head = `
            <tr class="tr probio_others_row">
                <td class="td"><span class="probio_others_caret"></span>${t("probio_indications_others")}${others.length ? ` (${others.length})` : ""}</td>
                <td class="td">${i.pharmacy_pct}%</td>
                <td class="td">${i.average_pct}%</td>
            </tr>`;
                    const detail = others.map((o)=>`
            <tr class="tr probio_others_detail hide">
                <td class="td">${o.name}</td>
                <td class="td">${o.pharmacy_pct}%</td>
                <td class="td">${o.average_pct}%</td>
            </tr>`).join("");
                    return head + detail;
                }
                return `
            <tr class="tr">
                <td class="td">${i.name}</td>
                <td class="td">${i.pharmacy_pct}%</td>
                <td class="td">${i.average_pct}%</td>
            </tr>`;
            }).join("");
            const othersRow = indTbody.querySelector(".probio_others_row");
            if (othersRow) othersRow.addEventListener("click", ()=>{
                othersRow.classList.toggle("probio_others_open");
                indTbody.querySelectorAll(".probio_others_detail").forEach((r)=>r.classList.toggle("hide"));
            });
        }
    }
    // Tabla: probióticos más dispensados (1º/2º/3º)
    const topTbody = document.getElementById("tbody_probio_top");
    if (topTbody) {
        const tops = statsResp?.top_probiotics || [];
        topTbody.innerHTML = tops.map((tp)=>`
            <tr class="tr">
                <td class="td">${tp.rank}\xba</td>
                <td class="td">${tp.pharmacy ?? "\u2014"}</td>
            </tr>`).join("");
    }
    // Tabla: probióticos vendidos (+ fila de totales)
    const prodTbody = document.getElementById("tbody_probio_products");
    if (prodTbody) {
        const ps = statsResp?.products_sold || {
            items: [],
            total_quantity: 0,
            total: 0
        };
        if (ps.items && ps.items.length) prodTbody.innerHTML = ps.items.map((p)=>`
            <tr class="tr">
                <td class="td">${p.product}</td>
                <td class="td">${p.quantity}</td>
                <td class="td">${p.total} \u{20AC}</td>
            </tr>`).join("") + `
            <tr class="tr tr_total">
                <td class="td"><strong>${t("probio_products_total_row")}</strong></td>
                <td class="td"><strong>${ps.total_quantity}</strong></td>
                <td class="td"><strong>${ps.total} \u{20AC}</strong></td>
            </tr>`;
        else prodTbody.innerHTML = `<tr class="tr"><td class="td" colspan="3">${t("probio_products_empty")}</td></tr>`;
    }
}
async function load_probiomentor_consultas_stats(from, to) {
    const params = {};
    if (from) params.from = from;
    if (to) params.to = to;
    const resp = await _indexJs1.getProbiomentorConsultationsStats(params);
    const rows = resp?.data || [];
    const total = resp?.total ?? 0;
    const tbody = document.getElementById("tbody_probio_consultas");
    if (!tbody) return;
    tbody.innerHTML = "";
    const countEl = document.getElementById("probio_consultas_total_count");
    if (countEl) countEl.textContent = total;
    rows.forEach((row)=>{
        const tr = document.createElement("tr");
        tr.className = "tr";
        tr.innerHTML = `
            <td class="td">${row.staff_name}</td>
            <td class="td">${row.consultas}</td>
        `;
        tbody.appendChild(tr);
    });
}
// ── Motor de visibilidad por grupo médico de servicio ─────────────────────────
//
// Reemplaza las funciones hardcodeadas de Etapa 06 (is_only_probiomentor,
// apply_probiomentor_restrictions, get_active_service_codes).
//
// La visibilidad de cada elemento del DOM se calcula como la UNIÓN de grupos
// activos. Si la farmacia tiene al menos un servicio activo de los grupos
// declarados para un elemento → visible; si no → oculto.
//
// Para añadir un servicio/grupo nuevo: editar src/config/serviceMenus.js y
// sembrar el grupo en la BD. No se toca este archivo.
/**
 * Resuelve el elemento del DOM descrito en una entrada de MANAGED_MENUS.
 * Si la entrada tiene `closest`, devuelve el ancestro más cercano que coincida.
 */ function resolveMenuEl(entry) {
    const el = document.querySelector(entry.selector);
    if (!el) return null;
    return entry.closest ? el.closest(entry.closest) : el;
}
/**
 * Helper: obtiene el catálogo desde caché local o lo carga del backend.
 * Devuelve el array [{code, group}] o null si falla.
 */ async function ensureServicesCatalog() {
    const CACHE_KEY = "farmaval_services_catalog";
    try {
        const cached = localStorage.getItem(CACHE_KEY);
        if (cached) return JSON.parse(cached);
    } catch (_) {
        localStorage.removeItem(CACHE_KEY);
    }
    const res = await _indexJs1.getServicesCatalog();
    if (res && res.status && Array.isArray(res.services)) {
        try {
            localStorage.setItem(CACHE_KEY, JSON.stringify(res.services));
        } catch (_) {}
        return res.services;
    }
    return null;
}
/**
 * Aplica la visibilidad de menús/secciones según los grupos médicos activos.
 *
 * @param {Array}       services  Array de objetos {ps_service, ps_active} de la farmacia.
 * @param {Array|null}  catalog   Array de {code, group} del endpoint /v1/services.
 *                                Si es null/vacío → fail-open (no se oculta nada).
 */ function applyServiceVisibility(services, catalog) {
    if (!catalog || !catalog.length) {
        console.warn("[applyServiceVisibility] Cat\xe1logo de servicios no disponible \u2014 visibilidad sin cambios");
        return;
    }
    // Mapa código → grupo (normalizado por aliases)
    const codeToGroup = Object.fromEntries(catalog.map((s)=>[
            s.code,
            s.group
        ]));
    // Grupos de los servicios activos de esta farmacia
    const activeGroups = new Set((services || []).filter((s)=>s.ps_active == null || s.ps_active == 1).map((s)=>codeToGroup[(0, _servicesJs.normalizeServiceCode)(s.ps_service)]).filter(Boolean));
    // Mostrar u ocultar cada elemento según su perfil de grupos
    (0, _serviceMenusJs.MANAGED_MENUS).forEach((m)=>{
        const visible = m.groups.some((g)=>activeGroups.has(g));
        resolveMenuEl(m)?.classList.toggle("hide", !visible);
    });
}
/**
 * Habilita/deshabilita las tarjetas de servicio del grid según los servicios
 * activos de la farmacia.
 *
 * Es idempotente: parte de todas las tarjetas deshabilitadas y solo levanta las
 * activas. Así puede re-ejecutarse tras un refresco de datos en segundo plano
 * (GET /v1/auth/me) y reflejar altas y bajas de servicio sin recargar la página.
 *
 * @param {Array} services Array de {ps_service, ps_active} de la farmacia.
 */ function applyServiceCards(services) {
    // domId se lee del registry (src/config/services.js).
    Object.values((0, _servicesJs.SERVICES)).forEach((meta)=>{
        document.getElementById(meta.domId)?.classList.add("disabled");
    });
    (services || []).filter((s)=>s.ps_active == null || s.ps_active == 1).forEach((s)=>{
        const rawCode = s.ps_service;
        const meta = (0, _servicesJs.SERVICES)[(0, _servicesJs.normalizeServiceCode)(rawCode)]; // alias PROBIO→PROBIOMENTOR
        // Servicio desconocido en el registry: id convencional como fallback
        const domId = meta ? meta.domId : "service_" + rawCode;
        document.getElementById(domId)?.classList.remove("disabled");
    });
}
// ─────────────────────────────────────────────────────────────────────────────
async function load_pharm_data(data, month = null, year = null) {
    document.getElementById("ag_pharm").value = data.pharm.pharm_id;
    render_nav_pharm_name(data.pharm);
    // Guardar pharm_id en localStorage para uso posterior (por ejemplo, links firmados)
    if (data.pharm && data.pharm.pharm_id) localStorage.setItem("pharm_id", data.pharm.pharm_id);
    if (data.agreement) fill_form("pending_data", data.agreement);
    const now = new Date();
    localStorage.syncro_date = now.toLocaleDateString() + " " + now.toLocaleTimeString();
    update_cache(data.data);
    // ── Habilitar tarjetas de servicios activos de la farmacia ───────────────────
    applyServiceCards(data.data.services);
    // is_schedulable se anota sobre los datos de la farmacia (lo consume la agenda).
    for(let service in data.data.services){
        const meta = (0, _servicesJs.SERVICES)[(0, _servicesJs.normalizeServiceCode)(data.data.services[service].ps_service)];
        data.data.services[service].is_schedulable = meta ? meta.schedulable ? 1 : 0 : 1;
    }
    // ── Visibilidad de menús/secciones según grupos médicos ───────────────────
    // La visibilidad de Pacientes, Calendario, firma, y tabs de reportes se
    // calcula ahora en applyServiceVisibility() a partir del catálogo de grupos.
    // Se llama más abajo tras obtener el catálogo.
    const hasProbiomentor = data.data.services?.some((s)=>(0, _servicesJs.normalizeServiceCode)(s.ps_service) === "PROBIOMENTOR" && (s.ps_active == null || s.ps_active == 1));
    // Re-translate page after removing disabled class from services
    (0, _farmavalJs.translate_page)((0, _farmavalJs.page_lng), false);
    fill_pharm_options(data.data, "staff", "staff_name", "staff_id");
    fill_pharm_options(data.data, "services", "ps_service", "ps_service");
    fill_pharm_options(data.data, "lngs", "text", "id");
    // El desplegable muestra el nombre ya resuelto al idioma en curso.
    fill_pharm_options(data.data, "products", [
        "prod_display_name",
        "prod_name"
    ], "prod_id", [
        {
            name: "aria-cost",
            field: "prod_cost"
        }
    ]);
    const select = document.getElementById("report_product_type");
    select.addEventListener("change", (el)=>{
        if (select.selectedIndex < 0) return;
        document.getElementById("report_product_id").value = select.options[select.selectedIndex].value;
        document.getElementById("report_product_cost").value = select.options[select.selectedIndex].getAttribute("aria-cost");
        document.getElementById("report_product_quantity").value = "1";
    });
    select.dispatchEvent(new Event("change"));
    document.getElementById("btn_product_add").addEventListener("click", (e)=>{
        e.preventDefault();
        const prod = {
            sale_id: "0",
            sale_product_id: document.getElementById("report_product_type").value,
            sale_product_name: select.options[select.selectedIndex].innerHTML,
            sale_cost: document.getElementById("report_product_cost").value,
            sale_quantity: document.getElementById("report_product_quantity").value
        };
        if (prod.sale_product_name != "" && prod.sale_cost != "" && prod.sale_quantity != "") add_to_list(document.getElementById("table_sales"), prod, sale_click, "aria-col");
    });
    fill_form("form_pharm", data.pharm);
    fill_form("form_admin", data.pharm);
    if (data.pharm.pharm_current_password) document.getElementById("pharm_password").removeAttribute("required");
    else document.getElementById("pharm_password").removeAttribute("placeholder");
    document.querySelectorAll("[aria-load]").forEach((el)=>{
        const type = el.getAttribute("aria-load");
        console.log(data.data[type]);
        fill_list(el, data.data[type], item_click);
    });
    // ── Seguimiento de pacientes (tab Vue de Pacientes, FA-07 / FA-08) ──
    init_patient_followup_tab();
    // ── Probióticos de farmacia (tab Vue) + filtros de Consultas Probiomentor ──
    if (hasProbiomentor) {
        init_profile_probiotics_tab();
        init_probio_consultas_filters();
    }
    // ── Visibilidad de menús por grupo médico (motor data-driven) ────────────
    const servicesCatalog = await ensureServicesCatalog();
    applyServiceVisibility(data.data.services, servicesCatalog);
    const codeToGroup = servicesCatalog ? Object.fromEntries(servicesCatalog.map((s)=>[
            s.code,
            s.group
        ])) : {};
    _activeServiceCodes = new Set((data.data.services || []).filter((s)=>s.ps_active == null || s.ps_active == 1).map((s)=>(0, _servicesJs.normalizeServiceCode)(s.ps_service)));
    _activeServiceGroups = new Set(Array.from(_activeServiceCodes).map((code)=>codeToGroup[code]).filter(Boolean));
    // ── Etapa 07: flag para card de formación en grid de Training ────────────
    const probioService = data.data.services?.find((s)=>(s.ps_service === "PROBIOMENTOR" || s.ps_service === "PROBIO") && (s.ps_active == null || s.ps_active == 1));
    _probioHasFormation = !!probioService?.has_formation && _activeServiceGroups.has("probioticos");
    if (month == null) {
        const today = new Date();
        month = today.getMonth() + 1;
        year = today.getFullYear();
    }
    // Usar SDK de farmavel para obtener las fechas del mes
    const res = await _indexJs1.getMonthDates(month, year);
    if (res && res.dates) document.querySelectorAll(".calendar").forEach((el)=>{
        (0, _calendarJs.show_calendar)(el, (0, _farmavalJs.page_text)["calendar_months"], data.data.days, res.dates, calendar_day_click, calendar_month_change);
    });
    // Training
    if (!data.data.training) return;
    show_training(data.data.training);
}
function _build_probio_formation_card() {
    const card = document.createElement("a");
    card.className = "training_item probio_formation_card";
    card.href = "#";
    card.innerHTML = `
        <div class="probio_formation_thumb">
            <img src="${0, _logoProbiomentorSymbolPngDefault.default}" alt="ProbioMentor" class="probio_formation_logo" />
        </div>
        <div class="info">
            <div class="title">${(0, _farmavalJs.page_text)["probio_formation_btn"] || "Acceder a Provio Experts"}</div>
            <div class="author">${(0, _farmavalJs.page_text)["probio_formation_sub"] || ""}</div>
        </div>`;
    card.addEventListener("click", async (e)=>{
        e.preventDefault();
        card.classList.add("disabled");
        const resp = await _indexJs1.getFormationLink();
        card.classList.remove("disabled");
        if (resp?.url) window.open(resp.url, "_blank", "noopener,noreferrer");
    });
    return card;
}
function show_training(data) {
    pharm_training = data;
    training_show_sections(data);
}
function training_show_sections(tr_data, section = 0) {
    const training = document.getElementById("section_videos");
    const folders = document.getElementById("training_content");
    const videos = document.getElementById("training_videos");
    training.querySelector(".formation_video").classList.add("hide");
    const data = tr_data.sections;
    if (data && data[section]) {
        videos.classList.add("hide");
        const tab_sections = training.querySelector(".tabs_top");
        if (section == 0) {
            tab_sections.innerHTML = "";
            const item = document.createElement("a");
            item.classList.add("tab_btn");
            item.href = "Inicio";
            item.innerHTML = "Inicio";
            item.addEventListener("click", (e)=>{
                e.preventDefault();
                training_show_sections(tr_data, 0);
            });
            tab_sections.append(item);
        }
        const training_content = document.getElementById("training_content");
        training_content.innerHTML = "";
        if (section == 0 && _probioHasFormation) training_content.append(_build_probio_formation_card());
        for(let a in data[section]){
            const tsName = data[section][a].ts_name;
            const nameLower = tsName ? tsName.toLowerCase() : "";
            let shouldShow = true;
            if (section == 0) {
                if (nameLower.includes("sati")) shouldShow = _activeServiceCodes.has("SATI");
                else if (nameLower.includes("cepoc")) shouldShow = _activeServiceCodes.has("CEPOC");
                else if (nameLower.includes("iretia")) shouldShow = _activeServiceCodes.has("IRETIA");
                else if (nameLower.includes("sesiones de valor") || nameLower.includes("sessions de valor") || (0, _farmavalJs.page_text)["formation_all"] && nameLower === (0, _farmavalJs.page_text)["formation_all"].toLowerCase()) shouldShow = _activeServiceGroups.has("respiratorio");
                else if (nameLower.includes("probiomentor")) shouldShow = _activeServiceGroups.has("probioticos");
            }
            if (!shouldShow) continue;
            const t = document.querySelector("#elements .training_item").cloneNode(true);
            if (data[section][a].ts_cover) t.querySelector("img").src = data[section][a].ts_cover;
            if (data[section][a].ts_author) t.querySelector(".author").innerHTML = data[section][a].ts_author;
            t.querySelector(".title").innerHTML = data[section][a].ts_name;
            t.href = data[section][a].ts_name;
            t.setAttribute("aria-section-id", data[section][a].ts_id);
            t.addEventListener("click", (e)=>{
                e.preventDefault();
                training_show_sections(tr_data, data[section][a].ts_id, data[section][a].ts_name);
                const lbl = document.createElement("a");
                lbl.classList.add("tab_btn");
                lbl.href = data[section][a].ts_name;
                lbl.innerHTML = data[section][a].ts_name;
                lbl.addEventListener("click", (e)=>{
                    e.preventDefault();
                    training_show_sections(tr_data, data[section][a].ts_id);
                    // eliminar siguientes
                    while(e.target.nextSibling)e.target.nextSibling.remove();
                });
                tab_sections.append(lbl);
            });
            training_content.append(t);
        }
        folders.classList.remove("hide");
    } else {
        if (section == 0 && _probioHasFormation) {
            const training_content = document.getElementById("training_content");
            training_content.innerHTML = "";
            training_content.append(_build_probio_formation_card());
            folders.classList.remove("hide");
            return;
        }
        folders.classList.add("hide");
        if (tr_data.content[section]) {
            if (tr_data.content[section].videos) {
                training.querySelector(".formation_label.label_videos").classList.remove("hide");
                training_add_videos(training, tr_data.content[section].videos);
            } else training_add_videos(training, null);
            if (tr_data.content[section].docs) {
                training.querySelector(".formation_label.label_material").classList.remove("hide");
                training_add_docs(training, tr_data.content[section].docs);
            } else training_add_docs(training, null);
        } else {
            training.querySelector(".formation_label.label_videos").classList.add("hide");
            training.querySelector(".videos_list").innerHTML = "";
            training.querySelector(".formation_label.label_material").classList.add("hide");
            training.querySelector(".material_list").innerHTML = "";
        }
        videos.classList.remove("hide");
    }
}
function training_add_videos(parent, content) {
    if (content.length < 10) {
        const target = parent.querySelector(".training_grid");
        parent.querySelector(".training_list").classList.add("hide");
        target.classList.remove("hide");
        const grid = target.querySelector(".videos_list");
        grid.innerHTML = "";
        if (!content) return;
        if (!content.length) return;
        let order = 1;
        for (let v of content){
            const item = document.querySelector("#elements .item_video").cloneNode(true);
            item.querySelector("iframe").src = v.training_url;
            item.querySelector(".item_video_title").innerHTML = order + ". " + v.training_title;
            grid.append(item);
            order++;
        }
        return;
    }
    const target = parent.querySelector(".training_list");
    target.classList.remove("hide");
    parent.querySelector(".training_grid").classList.add("hide");
    const grid = target.querySelector(".videos_list");
    grid.innerHTML = "";
    if (!content) return;
    if (!content.length) return;
    const video_iframe = parent.querySelector(".formation_video");
    for (let v of content){
        const item = document.createElement("a");
        item.classList.add("video_link");
        item.href = v.training_url;
        item.innerHTML = v.training_title;
        item.addEventListener("click", (e)=>{
            e.preventDefault();
            if (item.parentNode.querySelector(".selected")) item.parentNode.querySelector(".selected").classList.remove("selected");
            item.classList.add("selected");
            video_iframe.classList.remove("hide");
            video_iframe.setAttribute("src", item.getAttribute("href"));
        });
        grid.append(item);
    }
}
function training_add_docs(parent, content) {
    const target = parent.querySelector(".training_style:not(.hide)");
    const grid = target.querySelector(".material_list");
    grid.innerHTML = "";
    if (!content) return;
    if (content.length == 0) return;
    const icons = document.querySelector("#elements .filetypes");
    for (let v of content){
        const item = document.createElement("a");
        item.classList.add("material_link");
        item.href = v.training_url.replace("farmaval.net", "farmaval.net/appload.php?file=");
        item.target = "_new";
        const ext = v.training_url.split(".").slice(-1)[0];
        let icon = icons.querySelector(`[aria-extension-${ext}]`);
        if (!icon) icon = icons.querySelector("[aria-extension-generic]");
        //item.append(v.training_title+" <b><small>("+ext+")</small></b>");
        item.append(icon.cloneNode(true));
        item.append(v.training_title);
        grid.append(item);
    }
}
// ============ Material Divulgativo ============
// Reemplaza la antigua sección "Material divulgativo" hardcodeada. Carpetas
// anidadas servidas ya filtradas por servicio activo desde el backend
// (GET v1/materials) — el cliente solo navega el árbol recibido, sin volver
// a filtrar nada. Ver farmavel: MaterialController (farmacia).
let materialsTree = [];
let materialsStack = []; // nodos abiertos, del más externo al más interno; vacío = viendo las carpetas raíz
function is_material_image_extension(extension) {
    return [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "webp"
    ].includes(String(extension || "").toLowerCase());
}
async function load_materials() {
    const res = await _indexJs1.getMaterials();
    materialsTree = res && res.data ? res.data : [];
    materialsStack = [];
    render_materials();
}
function materials_open(folder) {
    materialsStack.push(folder);
    render_materials();
}
function materials_breadcrumb_click(index) {
    materialsStack = index < 0 ? [] : materialsStack.slice(0, index + 1);
    render_materials();
}
function render_materials() {
    const current = materialsStack[materialsStack.length - 1];
    const folders = current ? current.children || [] : materialsTree;
    const files = current ? current.files || [] : [];
    render_materials_breadcrumbs();
    render_materials_folders(folders);
    render_materials_files(files);
    document.getElementById("materials_empty").classList.toggle("hide", folders.length > 0 || files.length > 0);
}
function render_materials_breadcrumbs() {
    const bar = document.getElementById("materials_breadcrumbs");
    bar.innerHTML = "";
    const rootTab = document.createElement("a");
    rootTab.classList.add("tab_btn");
    rootTab.href = "#";
    if (materialsStack.length === 0) rootTab.classList.add("selected");
    rootTab.innerHTML = (0, _farmavalJs.page_text)["marketing_root_label"] || "Inicio";
    rootTab.addEventListener("click", (e)=>{
        e.preventDefault();
        materials_breadcrumb_click(-1);
    });
    bar.append(rootTab);
    materialsStack.forEach((folder, index)=>{
        const tab = document.createElement("a");
        tab.classList.add("tab_btn");
        tab.href = "#";
        if (index === materialsStack.length - 1) tab.classList.add("selected");
        tab.innerHTML = folder.name;
        tab.addEventListener("click", (e)=>{
            e.preventDefault();
            materials_breadcrumb_click(index);
        });
        bar.append(tab);
    });
}
function render_materials_folders(folders) {
    const grid = document.getElementById("materials_grid");
    grid.innerHTML = "";
    folders.forEach((folder)=>{
        const item = document.querySelector("#elements .training_item").cloneNode(true);
        const cover = item.querySelector("img");
        if (folder.cover_url) {
            cover.src = get_absolute_url(folder.cover_url);
            cover.alt = folder.name;
            cover.classList.remove("hide");
        } else cover.classList.add("hide");
        item.querySelector(".title").innerHTML = folder.name;
        const childCount = (folder.children ? folder.children.length : 0) + (folder.files ? folder.files.length : 0);
        item.querySelector(".author").innerHTML = childCount === 1 ? "1 elemento" : `${childCount} elementos`;
        item.href = "#";
        item.addEventListener("click", (e)=>{
            e.preventDefault();
            materials_open(folder);
        });
        grid.append(item);
    });
}
function render_materials_files(files) {
    const list = document.getElementById("materials_files");
    list.innerHTML = "";
    if (!files || files.length === 0) return;
    const icons = document.querySelector("#elements .filetypes");
    files.forEach((file)=>{
        const item = document.createElement("a");
        item.classList.add("material_link", "material_card");
        item.href = get_absolute_url(file.url);
        item.target = "_new";
        item.title = file.name;
        const ext = (file.ext || file.url.split(".").slice(-1)[0] || "").toLowerCase();
        let icon = icons.querySelector(`[aria-extension-${ext}]`);
        if (!icon) icon = icons.querySelector("[aria-extension-generic]");
        // Tarjeta con vista previa grande: los posts se distinguen a simple vista
        const media = document.createElement("div");
        media.classList.add("material_card_media");
        if (is_material_image_extension(ext) && file.preview_url) {
            const thumb = document.createElement("img");
            thumb.src = get_absolute_url(file.preview_url);
            thumb.alt = file.name;
            thumb.loading = "lazy";
            thumb.classList.add("material_thumb");
            media.append(thumb);
        } else media.append(icon.cloneNode(true));
        const name = document.createElement("span");
        name.classList.add("material_card_name");
        name.textContent = file.name;
        item.append(media, name);
        list.append(item);
    });
}
function remove_sale(e) {
    e.preventDefault();
    const item = e.target.parentElement;
    if (item.querySelector("[aria-col='sale_id']").innerHTML == "0") item.remove();
    else item.classList.add("hide");
}
function sale_click(parent, item) {
    if (item.classList.contains("selected")) {
        item.classList.remove("selected");
        return;
    }
    const prev = parent.querySelector(".row_select.selected");
    if (prev) prev.classList.remove("selected");
    item.classList.add("selected");
    item.querySelector(".col_btn").removeEventListener("click", remove_sale);
    item.querySelector(".col_btn").addEventListener("click", remove_sale);
}
function calendar_month_change(target, month, year) {
    (0, _farmavalJs.server_function)("getMonthDates", {
        month: month + 1,
        year: year
    }, (res)=>{
        (0, _calendarJs.update_calendar)(target, month, year, res.dates);
    });
}
async function render_cepoc_candidates() {
    const tbody = document.getElementById("cepoc_candidates_body");
    tbody.innerHTML = "";
    const patient_name = document.getElementById("cepoc_filter_name").value.trim();
    const date_from = document.getElementById("cepoc_filter_date_from").value;
    const date_to = document.getElementById("cepoc_filter_date_to").value;
    const res = await _indexJs1.getCepocCandidates({
        patient_name,
        date_from,
        date_to
    });
    if (!res || !res.data || res.data.length === 0) {
        const tr = document.createElement("tr");
        tr.innerHTML = `<td colspan="4" class="td">${(0, _farmavalJs.page_text)["cepoc_no_results"]}</td>`;
        tbody.appendChild(tr);
        return;
    }
    res.data.forEach((item)=>{
        const tr = document.createElement("tr");
        tr.className = "tr";
        const date = item.ics_screening_date ? item.ics_screening_date.substring(0, 10) : "";
        tr.innerHTML = `
            <td class="td">${item.ics_patient_name || ""}</td>
            <td class="td">${item.ics_patient_phone || ""}</td>
            <td class="td">${date}</td>
            <td class="td">
                <a class="btn_default btn_small btn_danger cepoc_delete_btn" data-id="${item.ics_id}">${(0, _farmavalJs.page_text)["cepoc_btn_delete"] || "Eliminar"}</a>
            </td>
        `;
        const btn = tr.querySelector(".cepoc_delete_btn");
        btn.addEventListener("click", async ()=>{
            if (!confirm((0, _farmavalJs.page_text)["cepoc_confirm_delete"] || "\xbfEst\xe1 seguro de eliminar este candidato?")) return;
            const result = await _indexJs1.deleteCepocCandidate(item.ics_id);
            if (result && result.status) await render_cepoc_candidates();
        });
        tbody.appendChild(tr);
    });
}
function attachDosingDeleteActions() {
    const table = document.getElementById("table_dosing_results");
    if (!table) return;
    table.querySelectorAll(".dosing_result_row").forEach((row)=>{
        const id = row.querySelector("[aria-field='drug_dosing_result_id']")?.innerHTML;
        const deletedAt = row.querySelector("[aria-field='deleted_at']")?.innerHTML?.trim();
        const button = row.querySelector(".dosing_delete_btn");
        if (!id) return;
        if (deletedAt) {
            row.classList.add("dosing_result_deleted");
            button?.classList.add("hide");
            return;
        }
        if (!button) return;
        button.dataset.id = id;
        button.onclick = (event)=>{
            event.preventDefault();
            event.stopPropagation();
            openDosingDeletePopup(id);
        };
    });
}
function attachDosingAcceptanceToggle() {
    const table = document.getElementById("table_dosing_results");
    if (!table) return;
    table.querySelectorAll(".dosing_result_row").forEach((row)=>{
        const id = row.querySelector("[aria-field='drug_dosing_result_id']")?.innerHTML;
        const deletedAt = row.querySelector("[aria-field='deleted_at']")?.innerHTML?.trim();
        const cell = row.querySelector(".dosing_toggle_accepts_btn");
        if (!id || !cell) return;
        const isOn = cell.textContent.trim() === "si";
        cell.innerHTML = `<span class="dosing_switch${isOn ? " dosing_switch_on" : ""}"><span class="dosing_switch_thumb"></span></span>`;
        if (deletedAt) return;
        cell.onclick = async (event)=>{
            event.preventDefault();
            event.stopPropagation();
            const switchEl = cell.querySelector(".dosing_switch");
            switchEl.style.opacity = "0.5";
            switchEl.style.pointerEvents = "none";
            const result = await _indexJs1.toggleDosingAcceptance(id);
            switchEl.style.opacity = "";
            switchEl.style.pointerEvents = "";
            if (!result?.status) return;
            if (result.patient_accepts_adjustment === "si") switchEl.classList.add("dosing_switch_on");
            else switchEl.classList.remove("dosing_switch_on");
        };
    });
}
function applyDosingCorrectionFilter() {
    const correction = document.getElementById("filter_dosing_correction")?.value ?? "adjusted";
    const rows = document.querySelectorAll("#table_dosing_results tbody .dosing_result_row");
    rows.forEach((row)=>{
        const statusValue = row.querySelector("[aria-field='status'] .option:not(.hide)")?.getAttribute("value") ?? "";
        const visible = correction === "all" || correction === "correct" && statusValue === "correct" || correction === "adjusted" && statusValue !== "correct";
        row.classList.toggle("hide", !visible);
    });
}
function setupDosingDeletePopup() {
    const confirmButton = document.getElementById("btn_dosing_delete_confirm");
    if (!confirmButton) return;
    confirmButton.onclick = async (event)=>{
        event.preventDefault();
        const popup = document.getElementById("popup_dosing_delete");
        const id = document.getElementById("dosing_delete_id")?.value;
        const reason = document.getElementById("dosing_delete_reason")?.value?.trim() || "";
        if (!popup || !id) return;
        confirmButton.classList.add("disabled");
        const result = await _indexJs1.deleteDosingResult(id, reason);
        if (result?.status) {
            popup.classList.remove("visible");
            show_result("dosing_delete_error");
            show_result("filter_dosing_error");
            document.getElementById("btn_list_dosing")?.click();
            confirmButton.classList.remove("disabled");
            return;
        }
        confirmButton.classList.remove("disabled");
        show_result("dosing_delete_error", "error_operation", true);
    };
}
function openDosingDeletePopup(id) {
    const popup = document.getElementById("popup_dosing_delete");
    if (!popup) return;
    empty_fields(popup);
    clear_errors(popup, "add");
    document.getElementById("dosing_delete_id").value = id;
    popup.classList.add("visible");
}
async function calendar_day_click(target, day, shift) {
    const date = day.split("-");
    document.getElementById("calendar_date").innerHTML = date[2] + "/" + date[1] + "/" + date[0];
    if (shift) document.getElementById("calendar_shift").innerHTML = shift;
    else document.getElementById("calendar_shift").innerHTML = (0, _farmavalJs.page_text)["date_no_shift"];
    const table = document.getElementById(target.getAttribute("dates-list"));
    const list = table.querySelector("tbody");
    list.innerHTML = "";
    const res = await _indexJs1.getDayDates(day);
    if (res && res.dates) {
        if (res.dates && res.dates.length) fill_list(table, res.dates, item_click);
    }
}
function item_click(parent, item) {
    const prev = parent.querySelector(".row_select.selected");
    if (prev) prev.classList.remove("selected");
    item.classList.add("selected");
    const form = document.getElementById(item.getAttribute("href"));
    for (const child of item.children){
        const field = form.querySelector("#" + child.getAttribute("aria-field"));
        if (field) {
            if (child.hasAttribute("aria-select")) {
                const selected = child.querySelector(".option:not(.hide)");
                if (selected) field.value = selected.getAttribute("value");
                else field.value = "";
                continue;
            }
            if (child.firstElementChild) field.value = child.firstElementChild.innerHTML;
            else field.value = child.innerHTML;
        }
    }
    clear_errors(form, "edit");
    const callback = parent.getAttribute("aria-prefunction");
    if (callback) myfuncs[callback](form);
    if (form.classList.contains("popup")) form.classList.add("visible");
}
function fill_form(form, data) {
    document.getElementById(form).querySelectorAll("[aria-field]").forEach((el)=>{
        const field = el.getAttribute("id");
        if (data[field]) {
            if (el.tagName == "IMG") {
                const value = data[field];
                // Si ya es una URL absoluta, usarla directamente
                if (value.startsWith("http://") || value.startsWith("https://")) el.src = value;
                else // Para rutas relativas que vienen desde el backend
                // El backend devuelve rutas como "uploads/logos/archivo.png"
                // Usamos assets_base_url que apunta al backend configurado
                el.src = (0, _farmavalJs.assets_base_url) + value;
            } else el.value = data[field];
        } else el.value = "";
    });
}
function fill_table(parent, data, func = null) {
    fill_list(parent, data, func);
}
function fill_list(parent, data, func = null, field = "aria-field") {
    const noselect = parent.hasAttribute("aria-noclick");
    const row = parent.getAttribute("aria-row");
    const field_id = parent.getAttribute(field);
    const list = parent.querySelector("tbody");
    list.innerHTML = "";
    if (!data) return;
    if (!data.length) return;
    const el = document.querySelector("#elements ." + row);
    for(let d in data){
        const item = el.cloneNode(true);
        item.setAttribute("id", field_id + "_" + data[d][field_id]);
        for (const child of item.children)if (data[d][child.getAttribute(field)]) {
            if (child.classList.contains("truncate")) {
                child.querySelector(".data").innerHTML = data[d][child.getAttribute(field)];
                continue;
            }
            if (child.hasAttribute("aria-select")) {
                child.querySelector(".option[value='" + data[d][child.getAttribute(field)] + "']").classList.remove("hide");
                continue;
            }
            child.innerHTML = data[d][child.getAttribute(field)];
        }
        if (!noselect) {
            if (func) item.addEventListener("click", (e)=>{
                e.preventDefault();
                func(parent, item);
            });
        }
        list.append(item);
    }
    if (list.hasAttribute("last_selected")) {
        const el = document.getElementById(list.getAttribute("last_selected"));
        if (el) el.classList.add("selected");
    }
    list.removeAttribute("last_selected");
}
function add_to_list(parent, data, func = null, field = "aria-field") {
    const noselect = parent.hasAttribute("aria-noclick");
    const row = parent.getAttribute("aria-row");
    const field_id = parent.getAttribute(field);
    const list = parent.querySelector("tbody");
    if (!data) return;
    const el = document.querySelector("#elements ." + row);
    const item = el.cloneNode(true);
    item.setAttribute("id", field_id + "_" + data[field_id]);
    for (const child of item.children)if (data[child.getAttribute(field)]) {
        if (child.classList.contains("truncate")) {
            child.querySelector(".data").innerHTML = data[child.getAttribute(field)];
            continue;
        }
        if (child.hasAttribute("aria-select")) {
            child.querySelector(".option[value='" + data[child.getAttribute(field)] + "']").classList.remove("hide");
            continue;
        }
        child.innerHTML = data[child.getAttribute(field)];
    }
    if (!noselect) {
        if (func) item.addEventListener("click", (e)=>{
            e.preventDefault();
            func(parent, item);
        });
    }
    list.append(item);
    if (list.hasAttribute("last_selected")) {
        const el = document.getElementById(list.getAttribute("last_selected"));
        if (el) el.classList.add("selected");
    }
    list.removeAttribute("last_selected");
}
function clear_errors(form, type) {
    if (type == "add") {
        form.classList.add("add");
        form.classList.remove("edit");
    } else {
        form.classList.add("edit");
        form.classList.remove("add");
    }
    const err = document.getElementById(form.getAttribute("aria-error-element"));
    err.innerHTML = "";
    err.classList.add("hide");
    form.querySelectorAll("[aria-field]").forEach((el)=>{
        el.classList.remove("novalid");
    });
    form.querySelectorAll(".operation_confirm").forEach((el)=>{
        el.querySelector("input").value = "";
        el.classList.add("hide");
    });
}
function empty_fields(form) {
    form.querySelectorAll("[aria-field]").forEach((el)=>{
        if (el.tagName === "SELECT") {
            const defaultOption = el.querySelector("option[selected]");
            el.selectedIndex = defaultOption ? defaultOption.index : 0;
        } else el.value = el.hasAttribute("data-default") ? el.getAttribute("data-default") : "";
        el.disabled = false;
    });
}
const myfuncs = {
    pending_checking: function(res) {
        if (res.status) test_pending(4);
    },
    new_popup_date: function(popup) {
        const date = document.getElementById("calendar_date").innerHTML.split("/");
        popup.querySelector("#date_date").value = date[2] + "-" + date[1].padStart(2, "0") + "-" + date[0].padStart(2, "0");
    },
    edit_popup_date: function(popup) {},
    post_update_calendar: function(data) {
        const calendar = document.querySelector(".calendar");
        const list = document.getElementById("dates_list");
        const month = parseInt(calendar.getAttribute("current_month"));
        const year = parseInt(calendar.getAttribute("current_year"));
        if (list.querySelector(".row_select.selected")) list.querySelector("tbody").setAttribute("last_selected", list.querySelector(".row_select.selected").getAttribute("id"));
        let href = null;
        if (calendar.querySelector("td.selected a")) href = calendar.querySelector("td.selected a").getAttribute("href");
        (0, _farmavalJs.server_function)("getMonthDates", {
            month: month + 1,
            year: year
        }, (res)=>{
            (0, _calendarJs.update_calendar)(calendar, month, year, res.dates);
            if (href) {
                if (calendar.querySelector("[href='" + href + "']")) calendar.querySelector("[href='" + href + "']").click();
            }
        });
    },
    enable_product_data: function(data) {
        const disabled = data.querySelector("#prod_pharm").value == 0;
        data.querySelectorAll("[aria-field]").forEach((el)=>{
            el.disabled = disabled;
        });
        data.querySelector("#prod_cost").disabled = false;
        if (disabled) document.getElementById("btn_product_delete").classList.add("hide");
        else document.getElementById("btn_product_delete").classList.remove("hide");
    },
    staff_updated: function(data) {
        // Sin esto, PROBIOMENTOR seguía mostrando la lista vieja hasta recargar la página.
        update_staff_cache(data.data);
        fill_pharm_options(data.data, "staff", "staff_name", "staff_id");
    },
    days_updated: function(data) {
        (0, _calendarJs.update_calendar_days)(document.querySelector(".calendar"), data.data.days);
    },
    before_popup_report: function(popup) {
        // AD-31: el desplegable de ventas ofrece lo mismo que el servicio del informe
        // (su catálogo de Farmaval y los productos propios activos), no «Mis productos».
        const report_service = popup.querySelector("#rep_service")?.value;
        if (report_service) _indexJs1.getPharmacyProducts(report_service, (0, _farmavalJs.page_lng)).then((res)=>{
            if (res?.status) fill_report_products(res.data?.products ?? []);
        });
        (0, _farmavalJs.server_function)("getSales", {
            rep_id: popup.querySelector("#rep_id").value
        }, (res)=>{
            if (res.status) fill_list(document.getElementById("table_sales"), res.data, sale_click, "aria-col");
        });
        if (document.getElementById("filter_service_type").value == "*") {
            document.getElementById("btn_report_delete").classList.add("hide");
            document.getElementById("btn_report_save").classList.add("hide");
            document.getElementById("btn_report_remove").classList.remove("hide");
            document.getElementById("btn_report_recover").classList.remove("hide");
            document.getElementById("btn_product_add").classList.add("hide");
        } else {
            document.getElementById("btn_report_delete").classList.remove("hide");
            document.getElementById("btn_report_save").classList.remove("hide");
            document.getElementById("btn_report_remove").classList.add("hide");
            document.getElementById("btn_report_recover").classList.add("hide");
            document.getElementById("btn_product_add").classList.remove("hide");
        }
        // ocultar botones
        popup.querySelectorAll("[aria-to]").forEach((el)=>{
            const link = document.getElementById(el.getAttribute("aria-to"));
            if (!el.value || el.value == "") link.classList.add("hide");
            else {
                link.classList.remove("hide");
                if (popup.querySelector("#rep_report_source").value == "local") link.href = el.value.replace(/&amp;/g, "&");
                else link.href = (0, _farmavalJs.server_base) + el.value.replace(/&amp;/g, "&");
            }
        });
    },
    pre_add_sales: function(parent, params) {
        const sales = [];
        document.querySelectorAll("#table_sales .sale_row").forEach((sale)=>{
            const sale_id = sale.querySelector("[aria-col='sale_id']").innerHTML;
            if (sale_id == 0) sales.push({
                product_id: sale.querySelector("[aria-col='sale_product_id']").innerHTML,
                product_name: sale.querySelector("[aria-col='sale_product_name']").innerHTML,
                product_cost: sale.querySelector("[aria-col='sale_cost']").innerHTML,
                product_quantity: sale.querySelector("[aria-col='sale_quantity']").innerHTML
            });
            else if (sale.classList.contains("hide")) sales.push({
                sale_id: sale_id
            });
        });
        if (sales.length) params["rep_sales"] = sales;
    },
    post_update_report: function(data) {
        const row = document.getElementById("table_reports").querySelector(".report_row.selected");
        row.querySelector("[aria-field='rep_comments']").innerHTML = data.comments;
        if (data.product) row.querySelector("[aria-field='rep_product']").innerHTML = data.product + "\u20AC";
        else row.querySelector("[aria-field='rep_product']").innerHTML = "-";
    },
    post_delete_report: function(data) {
        document.getElementById("table_reports").querySelector(".report_row.selected").remove();
    },
    before_popup_patient: function(popup) {
        (0, _farmavalJs.server_function)("getPatient", {
            patient_id: popup.querySelector("#patient_id").value
        }, (res)=>{
            console.log("Patient:", res);
            if (res.status) fill_form("form_patient", res.data);
        });
    },
    new_popup_patient: function(popup) {},
    post_update_patient: function(data) {
        if (document.querySelector("#table_patients tbody").hasChildNodes()) document.getElementById("btn_list_patients").click();
    },
    post_delete_patient: function(data) {
        document.querySelector("#table_patients tbody .patient_row.selected").remove();
    },
    post_show_stats_iretia: function(data) {
        const stats = data.data;
        document.getElementById("report_stats_iretia_window").classList.remove("hide");
        document.getElementById("btn_print_stats_iretia").classList.remove("hide");
        console.log("Stats:", stats);
        document.getElementById("report_stats_iretia").querySelectorAll("[aria-data]").forEach((el)=>{
            const data = el.getAttribute("aria-data");
            if (data !== "") {
                if (el.hasAttribute("aria-row")) {
                    el.innerHTML = "";
                    const type = el.getAttribute("aria-row");
                    const clone_item = document.querySelector("#elements ." + type);
                    for (const field of stats[data]){
                        const item = clone_item.cloneNode(true);
                        for(let c = 0; c < item.children.length; c++){
                            item.children[c].innerHTML = field[item.children[c].getAttribute("aria-field")];
                            if (item.children[c].hasAttribute("aria-post")) item.children[c].innerHTML += item.children[c].getAttribute("aria-post");
                        }
                        el.append(item);
                    }
                } else {
                    const parts = data.split("/");
                    if (stats[parts[0]]) {
                        if (stats[parts[0]][parts[1]] != null) {
                            el.innerHTML = stats[parts[0]][parts[1]];
                            if (el.hasAttribute("aria-post")) el.innerHTML += el.getAttribute("aria-post");
                        }
                    }
                }
            }
        });
    },
    post_show_stats: function(data) {
        // financial
        const stats = data.data;
        document.getElementById("report_stats_window").classList.remove("hide");
        document.getElementById("btn_print_stats").classList.remove("hide");
        console.log("Stats:", stats);
        const sections = new Array("financial", "service");
        for(let i = 0; i < sections.length; i++)if (stats[sections[i]]) {
            for (const [type, rows] of Object.entries(stats[sections[i]]))if (rows) {
                const tbody = document.querySelector(`[aria-stats="${sections[i] + "_" + type}"]`);
                tbody.innerHTML = "";
                const from_row = document.querySelector("#elements ." + tbody.getAttribute("aria-row"));
                if (from_row) for (const row of rows){
                    const item = from_row.cloneNode(true);
                    for(let c = 0; c < item.children.length; c++){
                        const key = item.children[c].getAttribute("aria-field");
                        if (row[key] != null) {
                            if (row[key][0] == "*") item.children[c].innerHTML = (0, _farmavalJs.page_text)[row[key].replaceAll("*", "")];
                            else item.children[c].innerHTML = row[key];
                            if (item.children[c].hasAttribute("aria-post")) item.children[c].innerHTML += item.children[c].getAttribute("aria-post");
                        }
                    }
                    tbody.append(item);
                }
            }
        }
        // charts as tables
        const charts = data.data.charts;
        const monetaryChartSections = new Set([
            "chart_prescriptions",
            "chart_prescriptions_service"
        ]);
        const preferredFinancialDatasetOrder = new Map([
            [
                "chart_pharm",
                0
            ],
            [
                "chart_media",
                1
            ],
            [
                "chart_best",
                2
            ]
        ]);
        for(let c = 0; c < charts.length; c++){
            const parent = document.getElementById(charts[c].section);
            parent.innerHTML = "";
            const chartName = get_text(charts[c].name);
            const orderedChartDatasets = charts[c].datasets.map((dataset, index)=>{
                const normalizedDataset = dataset.startsWith("*") ? dataset.substring(1) : dataset;
                const datasetPriority = preferredFinancialDatasetOrder.get(normalizedDataset) ?? Number.MAX_SAFE_INTEGER;
                return {
                    dataset,
                    data: charts[c].data[index],
                    index,
                    datasetPriority
                };
            }).sort((left, right)=>{
                if (left.datasetPriority === right.datasetPriority) return left.index - right.index;
                return left.datasetPriority - right.datasetPriority;
            });
            const table = document.createElement("table");
            table.className = "financial_table chart_table";
            const thead = document.createElement("thead");
            const headerRow = document.createElement("tr");
            const firstColTh = document.createElement("th");
            firstColTh.className = "stats_table_title";
            firstColTh.setAttribute("aria-lng", "stats_col_visits");
            firstColTh.textContent = (0, _farmavalJs.page_text)["stats_col_visits"] || "Visitas";
            headerRow.appendChild(firstColTh);
            for(let d = 0; d < orderedChartDatasets.length; d++){
                const th = document.createElement("th");
                const datasetLabel = orderedChartDatasets[d].dataset;
                if (datasetLabel[0] == "*") th.setAttribute("aria-lng", datasetLabel.substring(1));
                th.textContent = get_text(datasetLabel);
                headerRow.appendChild(th);
            }
            thead.appendChild(headerRow);
            table.appendChild(thead);
            const tbody = document.createElement("tbody");
            for(let i = 0; i < charts[c].labels.length; i++){
                const tr = document.createElement("tr");
                const nameTd = document.createElement("td");
                if (charts[c].labels[i][0] == "*") nameTd.setAttribute("aria-lng", charts[c].labels[i].substring(1));
                nameTd.textContent = get_text(charts[c].labels[i]);
                tr.appendChild(nameTd);
                for(let d = 0; d < orderedChartDatasets.length; d++){
                    const td = document.createElement("td");
                    const rawValue = orderedChartDatasets[d].data[i];
                    if (rawValue != null) td.innerHTML = monetaryChartSections.has(charts[c].section) ? rawValue + "<small>\u20AC</small>" : rawValue;
                    else td.textContent = "-";
                    tr.appendChild(td);
                }
                tbody.appendChild(tr);
            }
            table.appendChild(tbody);
            const chartTitle = document.createElement("div");
            chartTitle.className = "stats_section_subtitle";
            if (charts[c].name[0] == "*") chartTitle.setAttribute("aria-lng", charts[c].name.substring(1));
            chartTitle.textContent = chartName;
            parent.appendChild(chartTitle);
            const chartHelpKey = satiChartHelpKeys[charts[c].section];
            if (chartHelpKey) parent.appendChild(create_stats_help(chartHelpKey));
            parent.appendChild(table);
        }
        // dosing section
        const dosingParent = document.getElementById("dosing_section");
        if (dosingParent) {
            dosingParent.innerHTML = "";
            const dosing = data.data;
            const hasAccepted = dosing.dosing_impact != null || dosing.dosing_corrections_count != null || dosing.dosing_top_drugs && dosing.dosing_top_drugs.length > 0;
            const hasMissing = dosing.missing_dosing_impact != null || dosing.missing_dosing_corrections_count != null || dosing.missing_dosing_top_drugs && dosing.missing_dosing_top_drugs.length > 0;
            const buildDosingSubsection = (subtitleKey, corrections, impact, topDrugs, isWarning = false)=>{
                // Subtítulo de la subsección
                const subtitle = document.createElement("div");
                subtitle.className = isWarning ? "stats_subtitle warning" : "stats_subtitle success";
                subtitle.setAttribute("aria-lng", subtitleKey);
                subtitle.textContent = (0, _farmavalJs.page_text)[subtitleKey];
                dosingParent.appendChild(subtitle);
                dosingParent.appendChild(create_stats_help(isWarning ? "stats_help_dosing_missing" : "stats_help_dosing_accepted"));
                // Tabla resumen de impacto (2 columnas)
                const impactRows = [];
                if (corrections != null) impactRows.push({
                    key: "stats_dosing_corrections",
                    value: corrections
                });
                if (impact != null) impactRows.push({
                    key: "stats_dosing_monthly_revenue",
                    value: impact.monthly_total_revenue + "\u20AC"
                }, {
                    key: "stats_dosing_monthly_margin",
                    value: impact.monthly_total_margin + "\u20AC"
                }, {
                    key: "stats_dosing_annual_revenue",
                    value: impact.annualized_revenue + "\u20AC"
                }, {
                    key: "stats_dosing_annual_margin",
                    value: impact.annualized_margin + "\u20AC"
                });
                if (impactRows.length > 0) {
                    const impactTable = document.createElement("table");
                    impactTable.className = "financial_table chart_table dosing_summary_table";
                    const impactThead = document.createElement("thead");
                    const impactHeaderRow = document.createElement("tr");
                    const impactColumns = [
                        {
                            key: "stats_dosing_item",
                            fallback: "Item"
                        },
                        {
                            key: "stats_dosing_value",
                            fallback: "Valor"
                        }
                    ];
                    impactColumns.forEach(({ key, fallback }, index)=>{
                        const th = document.createElement("th");
                        if (index === 0) th.className = "stats_table_title";
                        th.setAttribute("aria-lng", key);
                        th.textContent = (0, _farmavalJs.page_text)[key] || fallback;
                        impactHeaderRow.appendChild(th);
                    });
                    impactThead.appendChild(impactHeaderRow);
                    impactTable.appendChild(impactThead);
                    const impactTbody = document.createElement("tbody");
                    for (const row of impactRows){
                        const tr = document.createElement("tr");
                        const tdLabel = document.createElement("td");
                        tdLabel.setAttribute("aria-lng", row.key);
                        tdLabel.textContent = (0, _farmavalJs.page_text)[row.key];
                        const tdValue = document.createElement("td");
                        tdValue.textContent = row.value;
                        tr.appendChild(tdLabel);
                        tr.appendChild(tdValue);
                        impactTbody.appendChild(tr);
                    }
                    impactTable.appendChild(impactTbody);
                    dosingParent.appendChild(impactTable);
                }
                // Tabla medicamentos principales
                if (topDrugs && topDrugs.length > 0) {
                    const drugsTable = document.createElement("table");
                    drugsTable.className = "financial_table chart_table";
                    const drugsThead = document.createElement("thead");
                    const drugsHeaderRow = document.createElement("tr");
                    const drugsCols = [
                        "stats_dosing_drug_name",
                        "stats_dosing_drug_format",
                        "stats_dosing_drug_monthly_revenue",
                        "stats_dosing_drug_monthly_margin",
                        "stats_dosing_drug_annual_revenue",
                        "stats_dosing_drug_annual_margin"
                    ];
                    drugsCols.forEach((key, i)=>{
                        const th = document.createElement("th");
                        if (i === 0) th.className = "stats_table_title";
                        th.setAttribute("aria-lng", key);
                        th.textContent = (0, _farmavalJs.page_text)[key];
                        drugsHeaderRow.appendChild(th);
                    });
                    drugsThead.appendChild(drugsHeaderRow);
                    drugsTable.appendChild(drugsThead);
                    const drugsTbody = document.createElement("tbody");
                    for (const drug of topDrugs){
                        const tr = document.createElement("tr");
                        const vals = [
                            drug.drug_name,
                            drug.drug_format || "",
                            drug.total_monthly_revenue + "\u20AC",
                            drug.total_monthly_margin + "\u20AC",
                            drug.annualized_revenue + "\u20AC",
                            drug.annualized_margin + "\u20AC"
                        ];
                        vals.forEach((val)=>{
                            const td = document.createElement("td");
                            td.textContent = val;
                            tr.appendChild(td);
                        });
                        drugsTbody.appendChild(tr);
                    }
                    drugsTable.appendChild(drugsTbody);
                    dosingParent.appendChild(drugsTable);
                }
            };
            if (hasAccepted || hasMissing) {
                const title = document.createElement("div");
                title.className = "stats_section_subtitle";
                title.setAttribute("aria-lng", "stats_dosing_title");
                title.textContent = (0, _farmavalJs.page_text)["stats_dosing_title"];
                dosingParent.appendChild(title);
                if (hasAccepted) buildDosingSubsection("stats_dosing_accepted_subtitle", dosing.dosing_corrections_count, dosing.dosing_impact, dosing.dosing_top_drugs);
                if (hasMissing) buildDosingSubsection("stats_dosing_missing_subtitle", dosing.missing_dosing_corrections_count, dosing.missing_dosing_impact, dosing.missing_dosing_top_drugs, true);
            }
        }
    }
};
function get_text(text) {
    if (text[0] == "*") return (0, _farmavalJs.page_text)[text.substring(1)];
    return text;
}
function create_stats_help(lngKey) {
    const help = document.createElement("p");
    help.className = "stats_help";
    help.setAttribute("aria-lng", lngKey);
    help.textContent = (0, _farmavalJs.page_text)[lngKey] || "";
    return help;
}
const satiChartHelpKeys = {
    chart_services: "stats_help_chart_services",
    chart_times: "stats_help_chart_times",
    chart_prescriptions: "stats_help_chart_prescriptions",
    chart_prescriptions_service: "stats_help_chart_prescriptions_service"
};
function get_array_text(arr) {
    var res = new Array();
    for(let a = 0; a < arr.length; a++)res.push(get_text(arr[a]));
    return res;
}
const custom_functions = {
    load_formacion: (0, _indexJs.load_formacion),
    /*
   * Carrito de reposición (FA-01 a FA-04).
   *
   * Lo invoca tanto el enlace del menú como su pestaña, así que el listener del
   * botón de tramitar se registra una sola vez con la marca `listenerSet`,
   * igual que en load_cepoc_candidates.
   */ load_cart: async function() {
        await render_cart();
        await render_cart_catalog();
        const btn = document.getElementById("btn_cart_submit");
        if (btn && !btn.dataset.listenerSet) {
            btn.dataset.listenerSet = "1";
            btn.addEventListener("click", async (e)=>{
                e.preventDefault();
                if (btn.classList.contains("disabled")) return;
                await submit_cart();
            });
        }
        // FA-06: alta manual de productos.
        const add_btn = document.getElementById("btn_cart_add");
        if (add_btn && !add_btn.dataset.listenerSet) {
            add_btn.dataset.listenerSet = "1";
            add_btn.addEventListener("click", async (e)=>{
                e.preventDefault();
                if (add_btn.classList.contains("disabled")) return;
                await add_cart_line();
            });
        }
        const select = document.getElementById("cart_product");
        if (select && !select.dataset.listenerSet) {
            select.dataset.listenerSet = "1";
            select.addEventListener("change", paint_cart_add_cost);
        }
    },
    load_cart_orders: async function() {
        await render_cart_orders();
    },
    show_agreement: function(el) {
        document.getElementById("ag_date").value = format_date(new Date());
        const popup = document.getElementById("agreement_popup");
        popup.setAttribute("aria-form", el.getAttribute("href"));
        let src = el.getAttribute("aria-agreement");
        if (el.hasAttribute("aria-group")) src += "_" + el.getAttribute("aria-group");
        popup.querySelector("iframe").setAttribute("src", src + ".html?v=" + (0, _versionJs.APP_BUILD_VERSION));
        popup.classList.remove("hide");
        document.getElementById("ag_signer_signature").removeAttribute("src");
        document.getElementById("ag_debtor_signature").removeAttribute("src");
        document.getElementById("btn_pending_upload").classList.add("hide");
        document.getElementById("btn_pending_again").classList.add("hide");
    },
    redo_agreement: function(el) {
        document.getElementById("btn_pending_upload").classList.add("hide");
        document.getElementById("btn_pending_again").classList.add("hide");
        document.getElementById("btn_pending_service").classList.remove("hide");
        document.getElementById("pending_data").querySelectorAll("[aria-field]").forEach((el)=>{
            el.disabled = false;
        });
    },
    load_cepoc_candidates: async function() {
        await render_cepoc_candidates();
        const btn = document.getElementById("btn_cepoc_filter");
        if (!btn.dataset.listenerSet) {
            btn.dataset.listenerSet = "1";
            btn.addEventListener("click", async ()=>{
                await render_cepoc_candidates();
            });
            document.getElementById("btn_cepoc_clear").addEventListener("click", async ()=>{
                document.getElementById("cepoc_filter_name").value = "";
                document.getElementById("cepoc_filter_date_from").value = "";
                document.getElementById("cepoc_filter_date_to").value = "";
                await render_cepoc_candidates();
            });
            [
                "cepoc_filter_name",
                "cepoc_filter_date_from",
                "cepoc_filter_date_to"
            ].forEach((id)=>{
                document.getElementById(id).addEventListener("keydown", async (e)=>{
                    if (e.key === "Enter") await render_cepoc_candidates();
                });
            });
        }
    },
    update_video: function(el) {
        const prev = document.getElementById(el.getAttribute("href")).querySelector(".videos_list .selected");
        prev;
    },
    load_probio_history_tab: ()=>{
        const from = document.getElementById("probio_filter_from")?.value || null;
        const to = document.getElementById("probio_filter_to")?.value || null;
        load_probiomentor_history(from, to);
    },
    load_probio_team_tab: ()=>{
        const from = document.getElementById("probio_team_from")?.value || null;
        const to = document.getElementById("probio_team_to")?.value || null;
        load_probiomentor_team_stats(from, to);
    },
    load_probio_team_consultas_tab: ()=>{
        const from = document.getElementById("probio_consultas_from")?.value || null;
        const to = document.getElementById("probio_consultas_to")?.value || null;
        load_probiomentor_consultas_stats(from, to);
    }
};
function format_date(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}
function validate_password(e) {
    const submitButton = document.getElementById("btn_update_password");
    const req1 = document.getElementById("password_req_1");
    const req2 = document.getElementById("password_req_2");
    const req3 = document.getElementById("password_req_3");
    const req4 = document.getElementById("password_req_4");
    const password = document.getElementById("new_password").value;
    const repassword = document.getElementById("renew_password").value;
    // Validar número
    if (/\d/.test(password)) req1.classList.add("valid");
    else req1.classList.remove("valid");
    // Validar mayúscula
    if (/[A-Z]/.test(password)) req2.classList.add("valid");
    else req2.classList.remove("valid");
    // Validar símbolo
    if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) req3.classList.add("valid");
    else req3.classList.remove("valid");
    // Validar coincidencia
    if (password === repassword && password !== "") req4.classList.add("valid");
    else req4.classList.remove("valid");
    // Habilitar/deshabilitar botón
    const allValid = document.querySelectorAll(".password_reqs li.valid").length === 4;
    if (allValid) {
        submitButton.disabled = false;
        submitButton.classList.remove("disabled");
    } else {
        submitButton.disabled = true;
        submitButton.classList.add("disabled");
    }
}
/**
 * Tras cambiar la contraseña obligatoria: entra al portal sin recargar.
 * Recargar restauraba la sesión desde la caché local, que aún tenía
 * pharm_reset_password = 1, y volvía a pedir el cambio de contraseña.
 */ function on_password_updated() {
    const cached = getPharmDataFromCache();
    if (!cached || !cached.pharm) {
        location.reload();
        return;
    }
    cached.pharm.pharm_reset_password = 0;
    savePharmDataToCache(cached);
    document.getElementById("section_update_password").classList.add("hide");
    applyRestoredPharm(cached);
    alert_popup((0, _farmavalJs.page_text)["update_ok_title"], (0, _farmavalJs.page_text)["update_ok"], false);
}
function close_alert_popup() {
    document.getElementById("popup_msg").classList.remove("visible");
}
async function alert_popup(title, msg, err, is_input = false, password = false, extra_data = null) {
    const popup = document.getElementById("popup_msg");
    document.body.append(popup);
    popup.querySelector(".modal_title").innerHTML = title;
    popup.querySelector(".modal_msg").innerHTML = msg;
    const input = popup.querySelector(".modal_prompt");
    if (err) popup.classList.add("error");
    else popup.classList.remove("error");
    if (is_input) {
        popup.classList.add("input_box");
        //if(password)
        //	input.setAttribute("type","password");
        //else
        input.setAttribute("type", "text");
    } else popup.classList.remove("input_box");
    const extra = popup.querySelector(".modal_extra");
    if (extra_data) {
        const link = extra.querySelector(".modal_extra_link");
        const new_link = link.cloneNode(true);
        link.replaceWith(new_link);
        new_link.innerHTML = extra_data.link;
        new_link.addEventListener("click", (e)=>{
            e.preventDefault();
            extra_data.callback();
        });
        extra.querySelector(".modal_extra_info").innerHTML = extra_data.info;
        extra.classList.remove("hide");
    } else extra.classList.add("hide");
    const btn_confirm = popup.querySelector(".modal_btn_ok");
    const btn_cancel = popup.querySelector(".modal_btn_cancel");
    btn_confirm.replaceWith(btn_confirm.cloneNode(true));
    btn_cancel.replaceWith(btn_cancel.cloneNode(true));
    popup.classList.add("visible");
    if (is_input) input.focus();
    return new Promise((resolve)=>{
        popup.querySelector(".modal_btn_ok").onclick = (e)=>{
            e.preventDefault();
            popup.classList.remove("visible");
            if (is_input) {
                const val = popup.querySelector(".modal_prompt").value;
                popup.querySelector(".modal_prompt").value = "";
                resolve(val);
            }
            resolve(true);
        };
        popup.querySelector(".modal_btn_cancel").onclick = (e)=>{
            e.preventDefault();
            popup.classList.remove("visible");
            popup.querySelector(".modal_prompt").value = "";
            resolve(false);
        };
    });
}
document.addEventListener("DOMContentLoaded", load, false);
// ── FA-01 a FA-06 — carrito de reposición y modo espejo del mentor ──────────
/**
 * Carrito abierto de la farmacia, tal cual lo devuelve el servidor. Los
 * totales, el IVA y los gastos de envío llegan YA calculados: aquí no se
 * recalcula ningún importe.
 */ let cart_state = null;
function cart_text(key, fallback = '') {
    return (0, _farmavalJs.page_text)[key] || fallback;
}
function build_cart_row(line) {
    const tr = document.createElement('tr');
    tr.className = 'tr';
    tr.innerHTML = `
        <td class="td">${line.name || ''}</td>
        <td class="td">${line.supplier_ref || "\u2014"}</td>
        <td class="td">
            <input type="number" min="1" max="999" class="cart_qty" value="${line.quantity}">
        </td>
        <td class="td">${line.unit_price} \u{20AC}</td>
        <td class="td">${line.iva} %</td>
        <td class="td">${line.line_total} \u{20AC}</td>
        <td class="td">
            <a href="#" class="btn_default btn_small btn_danger cart_remove">${cart_text('cart_btn_remove', 'Quitar')}</a>
        </td>
    `;
    const input = tr.querySelector('.cart_qty');
    const save_quantity = async ()=>{
        const quantity = parseInt(input.value, 10);
        if (!Number.isInteger(quantity) || quantity < 1) {
            input.value = line.quantity;
            return;
        }
        // Sin cambio real no se llama al servidor ni se sube la versión del
        // carrito: salir del campo sin tocar nada no es una edición.
        if (quantity === line.quantity) return;
        const res = await _indexJs1.updateCartLine(line.id, quantity);
        handle_cart_response(res, ()=>input.value = line.quantity);
    };
    // `change` y no `input`: se guarda cuando la farmacia termina de escribir,
    // no con cada tecla. Enter guarda sin tener que salir del campo.
    input.addEventListener('change', save_quantity);
    input.addEventListener('keydown', async (e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            await save_quantity();
        }
    });
    tr.querySelector('.cart_remove').addEventListener('click', async (e)=>{
        e.preventDefault();
        if (!confirm(cart_text('cart_confirm_remove', "\xbfQuitar este producto del carrito?"))) return;
        const res = await _indexJs1.removeCartLine(line.id);
        handle_cart_response(res);
    });
    return tr;
}
function paint_cart(cart) {
    const tbody = document.getElementById('cart_body');
    const empty = document.getElementById('cart_empty');
    const table = document.getElementById('cart_table');
    const submit_btn = document.getElementById('btn_cart_submit');
    tbody.innerHTML = '';
    const has_lines = cart.lines && cart.lines.length > 0;
    empty.classList.toggle('hide', has_lines);
    table.classList.toggle('hide', !has_lines);
    // FA-02: se puede tramitar cualquier importe; lo único que bloquea es que no
    // haya nada que pedir.
    submit_btn.classList.toggle('disabled', !has_lines);
    // Un carrito vacío no tiene resumen que mostrar: dejarlo visible anunciaría
    // "envío gratuito" sobre un pedido que no existe.
    document.querySelector('#cart_current .form_sticky').classList.toggle('hide', !has_lines);
    if (has_lines) cart.lines.forEach((line)=>tbody.appendChild(build_cart_row(line)));
    paint_cart_totals(cart.totals);
}
function paint_cart_totals(totals) {
    if (!totals) return;
    document.getElementById('cart_subtotal').innerHTML = `${totals.subtotal} \u{20AC}`;
    document.getElementById('cart_total').innerHTML = `${totals.total} \u{20AC}`;
    document.getElementById('cart_shipping').innerHTML = totals.free_shipping ? cart_text('cart_free', 'Gratis') : `${totals.shipping} \u{20AC}`;
    // Un desglose por tipo de IVA, porque el material CEPOC va al 10 % y el
    // resto al 21 %: un único importe agregado no sería comprobable.
    const taxes = document.getElementById('cart_taxes');
    taxes.innerHTML = '';
    (totals.tax_breakdown || []).forEach((tax)=>{
        const row = document.createElement('div');
        row.className = 'cart_summary_row';
        row.innerHTML = `<span>${cart_text('cart_lbl_iva', 'IVA')} ${tax.rate} %</span><span>${tax.tax} \u{20AC}</span>`;
        taxes.appendChild(row);
    });
    const hint = document.getElementById('cart_free_shipping_hint');
    if (totals.free_shipping) {
        hint.innerHTML = cart_text('cart_free_shipping_ok', '');
        hint.classList.toggle('hide', !cart_text('cart_free_shipping_ok', ''));
    } else {
        hint.innerHTML = cart_text('cart_free_shipping_hint', '').replace('{amount}', totals.missing_for_free_shipping);
        hint.classList.remove('hide');
    }
}
/** Precio de reposición del producto elegido, solo informativo. */ function paint_cart_add_cost() {
    const select = document.getElementById('cart_product');
    const cost = document.getElementById('cart_add_cost');
    if (!select || !cost) return;
    const option = select.options[select.selectedIndex];
    cost.value = option ? `${option.getAttribute('aria-cost')} \u{20AC}` : '';
}
/**
 * Repinta con la respuesta del servidor, que ya trae el carrito recalculado.
 * Si algo falló, avisa y deja que quien llama revierta lo que muestre la UI.
 */ function handle_cart_response(res, on_error) {
    if (res && res.status !== false && res.data) {
        cart_state = res.data;
        paint_cart(cart_state);
        return true;
    }
    alert(res && res.message || cart_text('cart_error_generic', "No se ha podido completar la operaci\xf3n."));
    if (typeof on_error === 'function') on_error();
    return false;
}
async function add_cart_line() {
    const select = document.getElementById('cart_product');
    const quantity_input = document.getElementById('cart_add_quantity');
    if (!select || !select.value) return;
    const quantity = parseInt(quantity_input.value, 10);
    if (!quantity || quantity < 1) {
        quantity_input.value = '1';
        return;
    }
    const btn = document.getElementById('btn_cart_add');
    btn.classList.add('disabled');
    const res = await _indexJs1.addCartLine(parseInt(select.value, 10), quantity);
    btn.classList.remove('disabled');
    handle_cart_response(res);
    if (res && res.status !== false) quantity_input.value = '1';
}
async function submit_cart() {
    if (!cart_state || !cart_state.lines || cart_state.lines.length === 0) return;
    if (!confirm(cart_text('cart_confirm_submit', "\xbfTramitar el pedido de reposici\xf3n?"))) return;
    const btn = document.getElementById('btn_cart_submit');
    const label = btn.innerHTML;
    btn.classList.add('disabled');
    btn.innerHTML = cart_text('cart_submitting', 'Tramitando...');
    // La versión evita pisar cambios: si el carrito cambió mientras la farmacia
    // lo revisaba (o si Farmaval lo tramitó por ella), el servidor responde 409.
    const res = await _indexJs1.submitCart(cart_state.version);
    btn.innerHTML = label;
    btn.classList.remove('disabled');
    if (!res || res.status === false) {
        alert(res && res.message || cart_text('cart_error_generic', ''));
        await render_cart();
        return;
    }
    alert(cart_text('cart_order_placed', 'Pedido {number} tramitado correctamente.').replace('{number}', res.data.number));
    await render_cart();
}
async function render_cart() {
    const tbody = document.getElementById('cart_body');
    if (!tbody) return;
    const res = await _indexJs1.getCart();
    if (!res || res.status === false || !res.data) {
        tbody.innerHTML = '';
        document.getElementById('cart_empty').classList.remove('hide');
        return;
    }
    cart_state = res.data;
    paint_cart(cart_state);
}
/**
 * FA-06 — catálogo de productos de Farmaval que esta farmacia puede reponer.
 *
 * Se pide una sola vez y se guarda en memoria: son unas decenas de productos y
 * no cambian mientras la farmacia está dentro de la pantalla.
 */ let cart_catalog = null;
async function render_cart_catalog() {
    const select = document.getElementById('cart_product');
    if (!select) return;
    if (cart_catalog === null) {
        const res = await _indexJs1.getCartCatalog();
        cart_catalog = res && res.status !== false && Array.isArray(res.data) ? res.data : [];
    }
    select.innerHTML = '';
    cart_catalog.forEach((product)=>{
        const name = (0, _farmavalJs.page_lng) === 'ca' && product.prod_name_ca ? product.prod_name_ca : product.prod_name;
        const option = new Option(name, product.prod_id);
        option.setAttribute('aria-cost', product.prod_cost);
        select.appendChild(option);
    });
    // Sin catálogo visible para esta farmacia no hay nada que añadir: se oculta
    // el bloque entero en vez de dejar un desplegable vacío.
    document.getElementById('cart_add').classList.toggle('hide', cart_catalog.length === 0);
    paint_cart_add_cost();
}
async function render_cart_orders() {
    const tbody = document.getElementById('cart_orders_body');
    if (!tbody) return;
    tbody.innerHTML = '';
    const res = await _indexJs1.getCartOrders();
    const orders = res && res.data ? res.data.orders : [];
    const empty = document.getElementById('cart_orders_empty');
    const table = document.getElementById('cart_orders_table');
    empty.classList.toggle('hide', orders.length > 0);
    table.classList.toggle('hide', orders.length === 0);
    orders.forEach((order)=>{
        const units = order.lines.reduce((total, line)=>total + line.quantity, 0);
        const date = order.placed_at ? order.placed_at.substring(0, 10) : '';
        const by_farmaval = order.placed_by_farmaval ? ` <small>(${cart_text('cart_order_by_farmaval', '')})</small>` : '';
        const tr = document.createElement('tr');
        tr.className = 'tr';
        tr.innerHTML = `
            <td class="td">${order.number}${by_farmaval}</td>
            <td class="td">${date}</td>
            <td class="td">${units}</td>
            <td class="td">${parseFloat(order.shipping) === 0 ? cart_text('cart_free', 'Gratis') : order.shipping + " \u20AC"}</td>
            <td class="td">${order.total} \u{20AC}</td>
        `;
        tbody.appendChild(tr);
    });
}
/**
 * Guarda los datos completos de la farmacia en localStorage
 * @param {Object} pharmData - Datos completos de la respuesta del backend
 */ /**
 * BIB-05 — modo farmacia espejo del mentor: solo Servicios (informativo) y
 * Formación; su progreso se guarda a su nombre, nunca contamina KPIs porque
 * no existe farmacia real detrás.
 */ function enterMirrorMode(data) {
    localStorage.setItem('farmavel_token', data.token);
    localStorage.setItem('farmaval_mirror', '1');
    localStorage.setItem('farmaval_mirror_name', data.mentor?.name ?? 'Mentor');
    document.body.classList.add('mirror-mode');
    show_logged(true);
    // Entrar directo a Formación (el resto de secciones no aplica al espejo).
    document.querySelector('nav [aria-section="section_formacion"]')?.click();
}
/*
 * Acceso del mentor a sus farmacias: con su credencial del panel ve las farmacias
 * que tiene asignadas y confirmadas y entra como una de ellas. El token es de la
 * farmacia, así que la app y los backends legacy la tratan igual que a su login.
 */ // Credencial del mentor mientras elige farmacia: solo en memoria, nunca en localStorage.
let mentorCredentials = null;
async function showMentorPharmacies(username, password) {
    const res = await _indexJs1.getMentorPharmacies(username, password);
    if (!res?.status) return false;
    mentorCredentials = {
        username,
        password
    };
    renderMentorPharmacies(res.data.pharmacies, res.data.mentor, null);
    document.getElementById('section_login').classList.add('hide');
    document.getElementById('section_mentor_pharmacies').classList.remove('hide');
    return true;
}
/**
 * @param {Array} pharmacies - [{ pharm_id, pharm_name, pharm_city }]
 * @param {Object} mentor - { user_id, name }
 * @param {?string} currentPharmId - farmacia actual al cambiar; null al iniciar sesión
 */ function renderMentorPharmacies(pharmacies, mentor, currentPharmId) {
    const section = document.getElementById('section_mentor_pharmacies');
    const switching = currentPharmId !== null;
    section.querySelector('.login_error').classList.add('hide');
    document.getElementById('mentor_pharmacies_greeting').dataset.name = mentor?.name ?? '';
    renderMentorGreeting();
    document.getElementById('mentor_pharmacies_list').replaceChildren(...pharmacies.map((pharmacy)=>mentorPharmacyItem(pharmacy, String(pharmacy.pharm_id) === currentPharmId)));
    document.getElementById('mentor_pharmacies_empty').classList.toggle('hide', pharmacies.length > 0);
    // La farmacia espejo necesita la credencial: solo se ofrece al iniciar sesión.
    document.getElementById('btn_mentor_mirror').classList.toggle('hide', switching);
    section.classList.toggle('switching', switching);
}
// El saludo lleva el nombre del mentor: no sirve aria-lng, se repinta al cambiar de idioma.
function renderMentorGreeting() {
    const greeting = document.getElementById('mentor_pharmacies_greeting');
    greeting.textContent = ((0, _farmavalJs.page_text)['mentor_pharmacies_greeting'] || '').replace('{name}', greeting.dataset.name ?? '');
}
function mentorPharmacyItem(pharmacy, isCurrent) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = isCurrent ? 'mentor_pharmacy current' : 'mentor_pharmacy';
    button.disabled = isCurrent;
    button.addEventListener('click', ()=>enterMentorPharmacy(pharmacy.pharm_id));
    const name = document.createElement('span');
    name.className = 'mentor_pharmacy_name';
    name.textContent = pharmacy.pharm_name;
    const detail = document.createElement('span');
    detail.className = 'mentor_pharmacy_city';
    detail.textContent = isCurrent ? (0, _farmavalJs.page_text)['mentor_pharmacy_current'] : pharmacy.pharm_city || '';
    button.append(name, detail);
    const item = document.createElement('li');
    item.append(button);
    return item;
}
function showMentorError(message) {
    const error = document.querySelector('#section_mentor_pharmacies .login_error');
    error.innerHTML = message;
    error.classList.remove('hide');
}
async function enterMentorPharmacy(pharmId) {
    const section = document.getElementById('section_mentor_pharmacies');
    section.querySelector('.login_error').classList.add('hide');
    section.querySelectorAll('.mentor_pharmacy').forEach((button)=>button.disabled = true);
    // Al iniciar sesión se entra con la credencial; al cambiar, con el token de mentor actual.
    const res = mentorCredentials ? await _indexJs1.mentorAccess(mentorCredentials.username, mentorCredentials.password, pharmId) : await _indexJs1.mentorSwitch(pharmId);
    if (res?.status && res.data?.token) {
        startMentorSession(res.data.token, res.data.pharm_id);
        return;
    }
    // Al cambiar, un 401 es que el mentor ya no tiene acceso: su sesión se cierra.
    if (!mentorCredentials && res?.httpStatus === 401) {
        clearUserSession();
        location.reload();
        return;
    }
    showMentorError(res?.httpStatus === 403 ? (0, _farmavalJs.page_text)['mentor_error_access'] : (0, _farmavalJs.page_text)['login_error_server']);
    section.querySelectorAll('.mentor_pharmacy').forEach((button)=>button.disabled = button.classList.contains('current'));
}
/**
 * Entra como la farmacia con el token de mentor. Recarga para arrancar por la
 * restauración de sesión (GET /v1/auth/me, que trae la farmacia y el bloque del
 * mentor) sin arrastrar nada de la farmacia anterior.
 */ function startMentorSession(token, pharmId) {
    mentorCredentials = null;
    clearUserSession();
    purgeDataCaches();
    localStorage.setItem('farmavel_token', token);
    localStorage.setItem('farmaval_session', token);
    localStorage.setItem('pharm_id', pharmId);
    location.reload();
}
/**
 * Modo mentor: aviso en la cabecera y fuera lo que solo le corresponde a la
 * farmacia (contraseña, firma del contrato, envío del pedido; el servidor
 * también lo bloquea).
 */ function applyMentorMode(mentor, pharm) {
    document.body.classList.toggle('mentor-mode', Boolean(mentor));
    if (!mentor) return;
    const banner = document.getElementById('mentor_banner_text');
    banner.dataset.name = mentor.name;
    banner.dataset.pharm = pharm?.pharm_name ?? '';
    renderMentorBanner();
    // Sin aria-field ni required el perfil ni envía ni exige la contraseña.
    const password = document.getElementById('pharm_password');
    password?.removeAttribute('aria-field');
    password?.removeAttribute('required');
}
// Como el saludo, la franja lleva nombres: se repinta al cambiar de idioma.
function renderMentorBanner() {
    const banner = document.getElementById('mentor_banner_text');
    banner.textContent = ((0, _farmavalJs.page_text)['mentor_banner_text'] || '').replace('{pharm}', banner.dataset.pharm ?? '').replace('{name}', banner.dataset.name ?? '');
}
function openMentorSwitch() {
    const mentor = getPharmDataFromCache()?.mentor;
    if (!mentor) return;
    renderMentorPharmacies(mentor.pharmacies ?? [], mentor, localStorage.getItem('pharm_id'));
    document.getElementById('section_mentor_pharmacies').classList.remove('hide');
    // La cola offline se reenvía con el token vigente: con servicios pendientes de
    // esta farmacia, cambiar los mandaría a la otra.
    const pending = localStorage.backup_services ? JSON.parse(localStorage.backup_services).length : 0;
    if (pending > 0) {
        document.querySelectorAll('#mentor_pharmacies_list .mentor_pharmacy').forEach((button)=>button.disabled = true);
        showMentorError((0, _farmavalJs.page_text)['mentor_error_pending_services']);
    }
}
function initMentorAccess() {
    document.getElementById('btn_mentor_back')?.addEventListener('click', (e)=>{
        e.preventDefault();
        document.getElementById('section_mentor_pharmacies').classList.add('hide');
        // Al iniciar sesión, «Volver» regresa al login; al cambiar, solo cierra la lista.
        if (mentorCredentials) {
            mentorCredentials = null;
            document.getElementById('section_login').classList.remove('hide');
        }
    });
    document.getElementById('btn_mentor_mirror')?.addEventListener('click', async (e)=>{
        e.preventDefault();
        if (!mentorCredentials) return;
        const mirror = await (0, _indexJs1.mentorLogin)(mentorCredentials.username, mentorCredentials.password);
        if (mirror?.data?.mirror && mirror?.data?.token) {
            mentorCredentials = null;
            document.getElementById('section_mentor_pharmacies').classList.add('hide');
            enterMirrorMode(mirror.data);
            return;
        }
        showMentorError((0, _farmavalJs.page_text)['login_error_server']);
    });
    document.getElementById('btn_mentor_switch')?.addEventListener('click', (e)=>{
        e.preventDefault();
        openMentorSwitch();
    });
    // Se registra después del de load(): translate_page() ya actualizó page_text.
    document.querySelectorAll('.btn_lng').forEach((el)=>el.addEventListener('click', ()=>{
            renderMentorGreeting();
            renderMentorBanner();
        }));
    // Si otra pestaña cambia de farmacia o cierra la sesión, esta no puede seguir
    // guardando datos de una farmacia con el token de otra.
    window.addEventListener('storage', (e)=>{
        if (e.key === 'pharm_id' || e.key === 'farmavel_token') location.reload();
    });
}

},{"./farmaval.js":"csIXA","./calendar.js":"7QKef","./formacion/index.js":"87KdF","./clients/farmavel/index.js":"11ZIt","./formacion/workshops.js":"6sXvD","./apiResolver.js":"gZbmW","./selectElements.js":"1Uk0K","./version.js":"3zXMX","../config/services.js":"f3kwi","../config/serviceMenus.js":"jVYn2","url:../img/logo-probiomentor-symbol.png":"c0Xd8","420234599e934fc9":"5TN2t","4b2f661b5d264aec":"atDQ1","600e499a5dbbb36f":"aDS2D","6184bf91fbf2fa0a":"csECC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7QKef":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "show_calendar", ()=>show_calendar);
parcelHelpers.export(exports, "update_calendar", ()=>update_calendar);
parcelHelpers.export(exports, "update_calendar_days", ()=>update_calendar_days);
let months_array = null;
let days_array = null;
let dates_array = null;
let callback_day = null;
let callback_month = null;
function change_calendar(target, direction) {
    let month = parseInt(target.getAttribute("current_month"));
    let year = parseInt(target.getAttribute("current_year"));
    if (direction == "next") {
        year = month === 11 ? year + 1 : year;
        month = (month + 1) % 12;
    } else {
        year = month === 0 ? year - 1 : year;
        month = month === 0 ? 11 : month - 1;
    }
    callback_month(target, month, year);
//draw_calendar(target, month, year);
}
function draw_calendar(target, month = null, year = null) {
    const today = new Date();
    if (month == null) {
        month = today.getMonth();
        year = today.getFullYear();
        target.querySelectorAll(".calendar_arrow").forEach((el)=>{
            el.addEventListener("click", (e)=>{
                e.preventDefault();
                change_calendar(target, el.getAttribute("href"));
            });
        });
    }
    target.setAttribute("current_month", month);
    target.setAttribute("current_year", year);
    target.querySelector(".calendar_current").innerHTML = months_array[month] + " " + year;
    const tbl = target.querySelector("tbody");
    tbl.innerHTML = "";
    //const today = new Date();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const adjustedFirstDay = (firstDay + 6) % 7;
    // creating all cells
    let date = 1;
    for(let i = 0; i < 6; i++){
        // creates a table row
        let row = document.createElement("tr");
        //creating individual cells, filing them up with data.
        for(let j = 0; j < 7; j++){
            const cell = document.createElement("td");
            if (i === 0 && j < adjustedFirstDay) // Celdas vacías antes del primer día del mes
            row.appendChild(cell);
            else if (date > daysInMonth) // Celdas vacías después del último día del mes
            row.appendChild(cell);
            else {
                const link = document.createElement("a");
                link.innerHTML = date;
                link.setAttribute("href", `${year}-${String(month + 1).padStart(2, '0')}-${String(date).padStart(2, '0')}`);
                if (date === today.getDate() && year === today.getFullYear() && month === today.getMonth()) cell.classList.add("today");
                const wrap = document.createElement("div");
                wrap.classList.add("wrapper");
                wrap.appendChild(link);
                cell.appendChild(wrap);
                let ret = null;
                if ((ret = check_available(j)) !== false) {
                    cell.classList.add("available");
                    link.setAttribute("day_shift", `${days_array[ret].day_from} - ${days_array[ret].day_to}`);
                }
                if (check_date(date)) cell.classList.add("dated");
                row.appendChild(cell);
                date++;
            }
        }
        tbl.appendChild(row);
        if (date > daysInMonth && i >= 4) break;
    }
    tbl.querySelectorAll("td a").forEach((day)=>{
        day.addEventListener("click", (e)=>{
            e.preventDefault();
            if (tbl.querySelector("td.selected")) tbl.querySelector("td.selected").classList.remove("selected");
            day.parentNode.parentNode.classList.add("selected");
            if (callback_day) callback_day(target, day.getAttribute("href"), day.getAttribute("day_shift"));
        });
    });
}
function daysInMonth(iMonth, iYear) {
    return 32 - new Date(iYear, iMonth, 32).getDate();
}
function check_available(day) {
    if (days_array && days_array.length) for(let d in days_array){
        if (parseInt(days_array[d].day_num) == day) return d;
    }
    return false;
}
function check_date(day) {
    for(let d in dates_array){
        if (parseInt(dates_array[d].day) == day) return true;
    }
    return false;
}
function show_calendar(target, months_labels, days_available, dates, func_day_click = null, func_month_change = null) {
    months_array = months_labels.split(",");
    days_array = days_available;
    dates_array = dates;
    callback_day = func_day_click;
    callback_month = func_month_change;
    draw_calendar(target);
    const today = new Date();
    const day = target.querySelector("[href='" + String(today.getFullYear()).padStart(2, '0') + "-" + String(today.getMonth() + 1).padStart(2, '0') + "-" + String(today.getDate()).padStart(2, '0') + "']");
    if (day) day.click();
}
function update_calendar(target, month, year, dates) {
    dates_array = dates;
    draw_calendar(target, month, year);
}
function update_calendar_days(target, days_available) {
    days_array = days_available;
    draw_calendar(target);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"87KdF":[function(require,module,exports,__globalThis) {
/**
 * M10 — Sección Formación (BIB-02 parte 1).
 *
 * - Identificación ligera por persona (C4): selector del equipo; el staff_id
 *   activo vive en localStorage y viaja en cada llamada de progreso.
 * - Player propio (C5): <video> con URL firmada temporal y heartbeat de
 *   progreso; la URL se re-firma sola si expira a mitad de reproducción.
 *   Los PDF se abren embebidos (iframe + URL de play inline) y al abrirlos
 *   se registra la lectura como «visto».
 *
 * Módulo autónomo: solo se engancha vía custom_functions['load_formacion'].
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getActiveStaff", ()=>getActiveStaff);
parcelHelpers.export(exports, "resetFormacionSession", ()=>resetFormacionSession);
/** Punto de entrada: registrado en custom_functions como `load_formacion`. */ parcelHelpers.export(exports, "load_formacion", ()=>load_formacion);
var _farmavalJs = require("../farmaval.js");
var _indexJs = require("../clients/farmavel/index.js");
var _quizJs = require("./quiz.js");
var _workshopsJs = require("./workshops.js");
const STORAGE_ID = 'farmaval_training_staff_id';
const STORAGE_NAME = 'farmaval_training_staff_name';
const HEARTBEAT_SECONDS = 15;
const state = {
    tree: null,
    path: [],
    completed: new Set(),
    player: {
        file: null,
        timer: null,
        lastTick: 0,
        ended: false
    }
};
const t = (key)=>(0, _farmavalJs.page_text)?.[key] ?? key;
const el = (id)=>document.getElementById(id);
const areaLabels = {
    respiratory: 'Respiratorio',
    probiomentor: 'ProBioMentor'
};
const kindLabels = ()=>({
        pill_video: t('formacion_kind_video'),
        long_video: t('formacion_kind_video'),
        pdf: 'PDF',
        link: t('formacion_kind_link'),
        template: t('formacion_kind_template'),
        image: t('formacion_kind_image')
    });
function isMirror() {
    return localStorage.getItem('farmaval_mirror') === '1';
}
function getActiveStaff() {
    // BIB-05: en la farmacia espejo la identidad es el propio mentor — sin
    // selector de equipo ni staff_id (el backend resuelve por su token).
    if (isMirror()) return {
        id: null,
        name: localStorage.getItem('farmaval_mirror_name') ?? 'Mentor'
    };
    const id = localStorage.getItem(STORAGE_ID);
    return id ? {
        id: Number(id),
        name: localStorage.getItem(STORAGE_NAME) ?? ''
    } : null;
}
function resetFormacionSession() {
    localStorage.removeItem(STORAGE_ID);
    localStorage.removeItem(STORAGE_NAME);
    localStorage.removeItem('farmaval_mirror');
    localStorage.removeItem('farmaval_mirror_name');
    document.body.classList.remove('mirror-mode');
    state.tree = null;
    state.path = [];
    state.completed = new Set();
    closePlayer();
}
async function load_formacion() {
    bindStaticHandlers();
    const staff = getActiveStaff();
    if (!staff) {
        await showSelector();
        return;
    }
    showHeader(staff);
    await loadLibrary();
}
let handlersBound = false;
function bindStaticHandlers() {
    if (handlersBound) return;
    handlersBound = true;
    el('formacion_change_person')?.addEventListener('click', async (e)=>{
        e.preventDefault();
        resetFormacionSession();
        await showSelector();
    });
    el('formacion_player_close')?.addEventListener('click', (e)=>{
        e.preventDefault();
        closePlayer();
    });
}
// ── Selector de persona (C4) ───────────────────────────────────────────────
async function showSelector() {
    el('formacion_body').classList.add('hide');
    el('formacion_person').classList.add('hide');
    el('formacion_selector').classList.remove('hide');
    const list = el('formacion_staff_list');
    list.innerHTML = '';
    el('formacion_no_staff').classList.add('hide');
    const response = await (0, _indexJs.getTrainingStaff)();
    const staff = response?.data ?? [];
    if (!staff.length) {
        el('formacion_no_staff').classList.remove('hide');
        return;
    }
    staff.forEach((member)=>{
        const item = document.createElement('li');
        item.textContent = member.staff_name;
        item.addEventListener('click', async ()=>{
            localStorage.setItem(STORAGE_ID, String(member.staff_id));
            localStorage.setItem(STORAGE_NAME, member.staff_name);
            showHeader({
                id: member.staff_id,
                name: member.staff_name
            });
            await loadLibrary();
        });
        list.appendChild(item);
    });
}
function showHeader(staff) {
    el('formacion_selector').classList.add('hide');
    el('formacion_person').classList.remove('hide');
    el('formacion_person_name').textContent = staff.name;
    el('formacion_change_person').classList.toggle('hide', isMirror());
    el('formacion_body').classList.remove('hide');
}
// ── Biblioteca ─────────────────────────────────────────────────────────────
async function loadLibrary() {
    const staff = getActiveStaff();
    const [library, summary] = await Promise.all([
        (0, _indexJs.getTrainingLibrary)(),
        (0, _indexJs.getTrainingSummary)(staff.id)
    ]);
    state.tree = library?.data ?? {
        areas: [],
        tree: {}
    };
    state.completed = new Set((summary?.data?.progress ?? []).filter((row)=>row.completed).map((row)=>row.file_id));
    state.path = [];
    // TL-01: si se llegó desde el icono de un taller, abrir su formación.
    const workshopCode = (0, _workshopsJs.takePendingWorkshop)();
    if (workshopCode) {
        await openWorkshop(workshopCode);
        return;
    }
    render();
}
/** TL-01: la formación del taller como raíz propia (fuera de la biblioteca general). */ async function openWorkshop(serviceCode) {
    const response = await (0, _indexJs.getTrainingWorkshop)(serviceCode);
    const folders = response?.data?.folders ?? [];
    if (!folders.length) {
        render();
        return;
    }
    state.workshopService = serviceCode;
    const root = folders.length === 1 ? {
        ...folders[0],
        type: 'workshop'
    } : {
        id: `workshop-${serviceCode}`,
        name: t(`${serviceCode.toLowerCase()}_name`),
        type: 'workshop',
        pb_block: null,
        locked: false,
        files: [],
        children: folders
    };
    state.path = [
        root
    ];
    render();
}
function currentNodes() {
    if (!state.path.length) return null;
    return state.path[state.path.length - 1];
}
function render() {
    closePlayer();
    closeQuizIfOpen();
    const grid = el('formacion_grid');
    grid.innerHTML = '';
    el('formacion_empty').classList.add('hide');
    renderBreadcrumb();
    const current = currentNodes();
    if (!current) {
        renderRoot(grid);
        loadProgramResult();
        return;
    }
    el('formacion_result')?.classList.add('hide');
    current.children.forEach((child)=>grid.appendChild(folderCard(child)));
    current.files.forEach((file)=>grid.appendChild(fileCard(file)));
    if (!current.children.length && !current.files.length) el('formacion_empty').classList.remove('hide');
    loadQuizButton(current);
    addMentoringButton(current);
}
/**
 * BIB-07 (C8): al final de cada bloque formativo, el EQUIPO puede pedir
 * agendar la mentoría con su mentor. Es intención de agendar — no exige que
 * todo el mundo haya terminado (C7) y no lo dispara ver contenido.
 * En un taller va solo en su portada: sus carpetas son solo contenido.
 */ function addMentoringButton(folderNode) {
    if (isMirror()) return;
    if (folderNode.type !== 'pb_block' && folderNode.type !== 'workshop') return;
    if (folderNode.type === 'workshop' && folderNode !== state.path[0]) return;
    const grid = el('formacion_grid');
    const button = document.createElement('a');
    button.className = 'formacion_mentoring_btn';
    button.textContent = t('formacion_mentoring_btn');
    button.addEventListener('click', async (e)=>{
        e.preventDefault();
        if (!confirm(t('formacion_mentoring_confirm'))) return;
        const staff = getActiveStaff();
        const isWorkshop = folderNode.type === 'workshop';
        const payload = isWorkshop ? {
            origin: 'workshop',
            service: state.workshopService
        } : {
            origin: 'pb_block',
            block: folderNode.pb_block,
            folder_id: folderNode.id
        };
        if (!isWorkshop && typeof folderNode.id === 'number') payload.folder_id = folderNode.id;
        if (staff && staff.id !== null) payload.staff_id = staff.id;
        const response = await (0, _indexJs.postMentoringRequest)(payload);
        if (response?.data) alert(response.data.already_pending ? t('formacion_mentoring_already') : t('formacion_mentoring_sent'));
    });
    grid.appendChild(button);
}
/** BIB-02: si la carpeta tiene cuestionario activo, ofrece hacerlo. */ async function loadQuizButton(folderNode) {
    const staff = getActiveStaff();
    if (!staff) return;
    const response = await (0, _indexJs.getTrainingQuiz)(folderNode.id, staff.id);
    const quiz = response?.data?.quiz;
    // La navegación pudo cambiar mientras llegaba la respuesta.
    if (!quiz || currentNodes()?.id !== folderNode.id) return;
    const grid = el('formacion_grid');
    const button = document.createElement('a');
    button.className = 'formacion_quiz_btn';
    button.textContent = quiz.best_score !== null ? `${t('formacion_quiz_btn')} (${t('formacion_quiz_best')}: ${quiz.best_score}%)` : t('formacion_quiz_btn');
    button.addEventListener('click', (e)=>{
        e.preventDefault();
        (0, _quizJs.openQuiz)(quiz, staff.id, ()=>render());
    });
    grid.appendChild(button);
}
function renderRoot(grid) {
    const areas = state.tree.areas ?? [];
    if (!areas.length) {
        el('formacion_empty').classList.remove('hide');
        return;
    }
    areas.forEach((area)=>{
        const nodes = state.tree.tree[area] ?? [];
        if (!nodes.length) return;
        if (areas.length > 1) {
            const title = document.createElement('h3');
            title.className = 'formacion_area_title';
            title.textContent = areaLabels[area] ?? area;
            grid.appendChild(title);
        }
        nodes.forEach((node)=>grid.appendChild(folderCard(node)));
    });
}
/** BIB-03: card «Mi resultado» del itinerario PB en la portada de Formación. */ async function loadProgramResult() {
    const staff = getActiveStaff();
    const box = el('formacion_result');
    if (!staff || !box || isMirror() || staff.id === null) {
        box?.classList.add('hide');
        return;
    }
    const response = await (0, _indexJs.getTrainingAwards)(staff.id);
    const data = response?.data;
    if (!data || !data.program || state.path.length) {
        box.classList.add('hide');
        return;
    }
    el('formacion_result_avg').textContent = data.average !== null ? `${data.average}%` : "\u2014";
    const blocks = el('formacion_result_blocks');
    blocks.innerHTML = '';
    data.blocks.forEach((block)=>{
        const chip = document.createElement('span');
        const label = `B${block.number}: ${block.best !== null ? block.best + '%' : block.has_quiz ? t('formacion_result_pending') : t('formacion_result_noquiz')}`;
        chip.textContent = label;
        if (block.best !== null) chip.className = block.best >= data.pass_threshold ? 'ok' : 'low';
        blocks.appendChild(chip);
    });
    const awardBox = el('formacion_result_award');
    awardBox.innerHTML = '';
    if (data.award) {
        const link = document.createElement('a');
        link.textContent = data.award.kind === 'diploma' ? t('formacion_result_diploma') : t('formacion_result_certificate');
        link.addEventListener('click', async (e)=>{
            e.preventDefault();
            const download = await (0, _indexJs.getTrainingAwardDownload)(staff.id);
            if (download?.data?.url) window.open(download.data.url, '_blank', 'noopener');
        });
        awardBox.appendChild(link);
        if (data.award.kind !== 'diploma') {
            const hint = document.createElement('p');
            hint.textContent = t('formacion_result_retake_hint');
            awardBox.appendChild(hint);
        }
    } else if (!data.complete) {
        const hint = document.createElement('p');
        hint.textContent = t('formacion_result_incomplete');
        awardBox.appendChild(hint);
    }
    box.classList.remove('hide');
}
function renderBreadcrumb() {
    const breadcrumb = el('formacion_breadcrumb');
    breadcrumb.innerHTML = '';
    const home = document.createElement('a');
    home.textContent = t('formacion_home');
    home.addEventListener('click', ()=>{
        state.path = [];
        render();
    });
    breadcrumb.appendChild(home);
    state.path.forEach((node, index)=>{
        const sep = document.createElement('span');
        sep.className = 'sep';
        sep.textContent = "\u203A";
        breadcrumb.appendChild(sep);
        const link = document.createElement('a');
        link.textContent = node.name;
        link.addEventListener('click', ()=>{
            state.path = state.path.slice(0, index + 1);
            render();
        });
        breadcrumb.appendChild(link);
    });
}
/**
 * Nombre de una tarjeta con un punto de corte tras cada «_»: los nombres de
 * archivo no llevan espacios y el navegador no tenía dónde partirlos, así que
 * se salían de la tarjeta. El nombre completo va en el title, porque el CSS
 * corta a 3 líneas.
 */ function cardName(text) {
    const value = String(text ?? '');
    const name = document.createElement('div');
    name.className = 'card_name';
    name.title = value;
    value.split('_').forEach((part, index)=>{
        if (index > 0) name.append('_', document.createElement('wbr'));
        name.append(part);
    });
    return name;
}
function folderCard(node) {
    const card = document.createElement('div');
    card.className = 'formacion_card' + (node.locked ? ' locked' : '') + (node.cover_url ? ' has_cover' : '');
    if (node.cover_url) {
        const cover = document.createElement('img');
        cover.className = 'card_cover';
        cover.src = node.cover_url;
        cover.alt = node.name;
        cover.loading = 'lazy';
        cover.addEventListener('error', ()=>{
            cover.remove();
            card.classList.remove('has_cover');
        });
        card.appendChild(cover);
    }
    const kind = document.createElement('div');
    kind.className = 'card_kind';
    kind.textContent = node.type === 'pb_block' ? `${t('formacion_block')} ${node.pb_block ?? ''}` : t('formacion_folder');
    card.appendChild(kind);
    card.appendChild(cardName(node.name));
    if (node.locked) {
        const meta = document.createElement('div');
        meta.className = 'card_meta';
        meta.textContent = "\uD83D\uDD12 " + t('formacion_locked');
        card.appendChild(meta);
        return card;
    }
    card.addEventListener('click', ()=>{
        state.path.push(node);
        render();
    });
    return card;
}
function fileCard(file) {
    const card = document.createElement('div');
    card.className = 'formacion_card';
    card.dataset.fileId = String(file.id);
    const kind = document.createElement('div');
    kind.className = 'card_kind';
    kind.textContent = kindLabels()[file.kind] ?? file.kind;
    card.appendChild(kind);
    card.appendChild(cardName(file.name));
    const meta = document.createElement('div');
    meta.className = 'card_meta';
    if (file.lang && file.lang !== 'na') {
        const lang = document.createElement('span');
        lang.className = 'badge_lang';
        lang.textContent = file.lang;
        meta.appendChild(lang);
    }
    if (state.completed.has(file.id)) {
        const seen = document.createElement('span');
        seen.className = 'badge_seen';
        seen.textContent = "\u2713 " + t('formacion_seen');
        meta.appendChild(seen);
    }
    card.appendChild(meta);
    card.addEventListener('click', ()=>openFile(file));
    return card;
}
// ── Player con heartbeat (C5 / BIB-02) ─────────────────────────────────────
async function openFile(file) {
    const staff = getActiveStaff();
    if (!staff) return;
    const isVideo = file.kind === 'pill_video' || file.kind === 'long_video';
    const isPdf = file.kind === 'pdf';
    if (!isVideo && !isPdf) {
        const response = file.kind === 'link' ? await (0, _indexJs.getTrainingPlayUrl)(file.id, staff.id) : await (0, _indexJs.getTrainingDownloadUrl)(file.id, staff.id);
        const url = response?.data?.url;
        if (url) window.open(url, '_blank', 'noopener');
        return;
    }
    const response = await (0, _indexJs.getTrainingPlayUrl)(file.id, staff.id);
    const url = response?.data?.url;
    if (!url) return;
    if (isPdf) {
        await openPdf(file, staff, url);
        return;
    }
    openVideo(file, staff, url);
}
function showPlayer(file, documentMode) {
    el('formacion_player_title').textContent = file.name;
    const player = el('formacion_player');
    player.classList.toggle('is-document', documentMode);
    player.classList.remove('hide');
    player.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
    });
}
async function openPdf(file, staff, url) {
    clearMedia();
    state.player.file = file;
    state.player.ended = true;
    showPlayer(file, true);
    const video = el('formacion_video');
    video?.classList.add('hide');
    const iframe = el('formacion_pdf');
    iframe.classList.remove('hide');
    iframe.title = file.name;
    iframe.src = url;
    const tabLink = el('formacion_player_open_tab');
    if (tabLink) {
        tabLink.textContent = t('formacion_open_tab');
        tabLink.href = url;
        tabLink.classList.remove('hide');
    }
    const payload = {
        file_id: file.id,
        position: 0,
        watched_delta: 0,
        ended: true
    };
    if (staff.id !== null) payload.staff_id = staff.id;
    const progress = await (0, _indexJs.postTrainingProgress)(payload);
    if (progress?.data?.completed) markFileSeenInGrid(file.id);
}
function openVideo(file, staff, url) {
    clearMedia();
    el('formacion_video')?.classList.remove('hide');
    const video = el('formacion_video');
    state.player.file = file;
    state.player.ended = false;
    showPlayer(file, false);
    video.src = url;
    video.play().catch(()=>undefined);
    video.onplay = startHeartbeat;
    video.onpause = ()=>{
        stopHeartbeat();
        sendHeartbeat() // el tramo visto hasta la pausa
        ;
    };
    video.onended = async ()=>{
        state.player.ended = true;
        stopHeartbeat();
        await sendHeartbeat(true);
        markFileSeenInGrid(file.id);
    };
    // URL expirada a mitad de vídeo: re-firmar y continuar donde iba (C5).
    video.onerror = async ()=>{
        if (!state.player.file) return;
        const position = video.currentTime;
        const retry = await (0, _indexJs.getTrainingPlayUrl)(state.player.file.id, staff.id);
        if (retry?.data?.url) {
            video.src = retry.data.url;
            video.currentTime = position;
            video.play().catch(()=>undefined);
        }
    };
}
function markFileSeenInGrid(fileId) {
    state.completed.add(fileId);
    const card = el('formacion_grid')?.querySelector(`[data-file-id="${fileId}"]`);
    if (!card || card.querySelector('.badge_seen')) return;
    const meta = card.querySelector('.card_meta');
    if (!meta) return;
    const seen = document.createElement('span');
    seen.className = 'badge_seen';
    seen.textContent = "\u2713 " + t('formacion_seen');
    meta.appendChild(seen);
}
function startHeartbeat() {
    stopHeartbeat();
    state.player.lastTick = Date.now();
    state.player.timer = setInterval(sendHeartbeat, HEARTBEAT_SECONDS * 1000);
}
function stopHeartbeat() {
    if (state.player.timer) {
        clearInterval(state.player.timer);
        state.player.timer = null;
    }
}
async function sendHeartbeat(ended = false) {
    const staff = getActiveStaff();
    const file = state.player.file;
    const video = el('formacion_video');
    if (!staff || !file || !video || file.kind === 'pdf') return;
    const now = Date.now();
    const delta = Math.round((now - state.player.lastTick) / 1000);
    state.player.lastTick = now;
    const payload = {
        file_id: file.id,
        position: Math.floor(video.currentTime || 0),
        watched_delta: Math.max(0, delta),
        ended: ended || state.player.ended
    };
    if (staff.id !== null) payload.staff_id = staff.id;
    const response = await (0, _indexJs.postTrainingProgress)(payload);
    if (response?.data?.completed) markFileSeenInGrid(file.id);
}
function closeQuizIfOpen() {
    const quizBox = el('formacion_quiz');
    if (quizBox && !quizBox.classList.contains('hide')) {
        quizBox.classList.add('hide');
        el('formacion_grid')?.classList.remove('hide');
        el('formacion_breadcrumb')?.classList.remove('hide');
    }
}
function clearMedia() {
    stopHeartbeat();
    const video = el('formacion_video');
    if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
        video.onplay = null;
        video.onpause = null;
        video.onended = null;
        video.onerror = null;
        video.classList.remove('hide');
    }
    const iframe = el('formacion_pdf');
    if (iframe) {
        iframe.src = 'about:blank';
        iframe.classList.add('hide');
    }
    const tabLink = el('formacion_player_open_tab');
    if (tabLink) {
        tabLink.removeAttribute('href');
        tabLink.classList.add('hide');
    }
    el('formacion_player')?.classList.remove('is-document');
}
function closePlayer() {
    clearMedia();
    state.player.file = null;
    el('formacion_player')?.classList.add('hide');
}

},{"../farmaval.js":"csIXA","../clients/farmavel/index.js":"11ZIt","./quiz.js":"aSmq0","./workshops.js":"6sXvD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"11ZIt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "login", ()=>login);
parcelHelpers.export(exports, "getPharmDetails", ()=>getPharmDetails);
parcelHelpers.export(exports, "getMonthDates", ()=>getMonthDates);
parcelHelpers.export(exports, "getDayDates", ()=>getDayDates);
parcelHelpers.export(exports, "getCepocCandidates", ()=>getCepocCandidates);
parcelHelpers.export(exports, "deleteCepocCandidate", ()=>deleteCepocCandidate);
parcelHelpers.export(exports, "getDosingResults", ()=>getDosingResults);
parcelHelpers.export(exports, "toggleDosingAcceptance", ()=>toggleDosingAcceptance);
parcelHelpers.export(exports, "deleteDosingResult", ()=>deleteDosingResult);
parcelHelpers.export(exports, "getReports", ()=>getReports);
parcelHelpers.export(exports, "getSatiReport", ()=>getSatiReport);
parcelHelpers.export(exports, "getCart", ()=>getCart);
parcelHelpers.export(exports, "getCartCatalog", ()=>getCartCatalog);
parcelHelpers.export(exports, "addCartLine", ()=>addCartLine);
parcelHelpers.export(exports, "updateCartLine", ()=>updateCartLine);
parcelHelpers.export(exports, "removeCartLine", ()=>removeCartLine);
parcelHelpers.export(exports, "submitCart", ()=>submitCart);
parcelHelpers.export(exports, "getCartOrders", ()=>getCartOrders);
parcelHelpers.export(exports, "updateReport", ()=>updateReport);
parcelHelpers.export(exports, "getReportSales", ()=>getReportSales);
parcelHelpers.export(exports, "getPharmacyProducts", ()=>getPharmacyProducts);
parcelHelpers.export(exports, "savePharmacyProduct", ()=>savePharmacyProduct);
parcelHelpers.export(exports, "deletePharmacyProduct", ()=>deletePharmacyProduct);
parcelHelpers.export(exports, "getTrainingLibrary", ()=>getTrainingLibrary);
parcelHelpers.export(exports, "getTrainingFolder", ()=>getTrainingFolder);
parcelHelpers.export(exports, "getTrainingStaff", ()=>getTrainingStaff);
parcelHelpers.export(exports, "getTrainingPlayUrl", ()=>getTrainingPlayUrl);
parcelHelpers.export(exports, "getTrainingDownloadUrl", ()=>getTrainingDownloadUrl);
parcelHelpers.export(exports, "postTrainingProgress", ()=>postTrainingProgress);
parcelHelpers.export(exports, "getTrainingSummary", ()=>getTrainingSummary);
parcelHelpers.export(exports, "getTrainingQuiz", ()=>getTrainingQuiz);
parcelHelpers.export(exports, "postTrainingQuizAttempt", ()=>postTrainingQuizAttempt);
parcelHelpers.export(exports, "getTrainingAwards", ()=>getTrainingAwards);
parcelHelpers.export(exports, "getTrainingAwardDownload", ()=>getTrainingAwardDownload);
parcelHelpers.export(exports, "mentorLogin", ()=>mentorLogin);
parcelHelpers.export(exports, "getMentorPharmacies", ()=>getMentorPharmacies);
parcelHelpers.export(exports, "mentorAccess", ()=>mentorAccess);
parcelHelpers.export(exports, "mentorSwitch", ()=>mentorSwitch);
parcelHelpers.export(exports, "postMentoringRequest", ()=>postMentoringRequest);
parcelHelpers.export(exports, "getTrainingWorkshops", ()=>getTrainingWorkshops);
parcelHelpers.export(exports, "getTrainingWorkshop", ()=>getTrainingWorkshop);
parcelHelpers.export(exports, "startProbiomentorService", ()=>startProbiomentorService);
parcelHelpers.export(exports, "getProbiomentorIndications", ()=>getProbiomentorIndications);
parcelHelpers.export(exports, "endProbiomentorService", ()=>endProbiomentorService);
parcelHelpers.export(exports, "getServicesCatalog", ()=>getServicesCatalog);
parcelHelpers.export(exports, "getProbiomentorHistory", ()=>getProbiomentorHistory);
parcelHelpers.export(exports, "getProbiomentorTeamStats", ()=>getProbiomentorTeamStats);
parcelHelpers.export(exports, "getProbiomentorServicesStats", ()=>getProbiomentorServicesStats);
parcelHelpers.export(exports, "getProbiomentorConsultationsStats", ()=>getProbiomentorConsultationsStats);
parcelHelpers.export(exports, "deleteProbiomentorService", ()=>deleteProbiomentorService);
parcelHelpers.export(exports, "getPharmProbiotics", ()=>getPharmProbiotics);
parcelHelpers.export(exports, "addPharmProbiotic", ()=>addPharmProbiotic);
parcelHelpers.export(exports, "updatePharmProbiotic", ()=>updatePharmProbiotic);
parcelHelpers.export(exports, "removePharmProbiotic", ()=>removePharmProbiotic);
parcelHelpers.export(exports, "searchPharmProbiotics", ()=>searchPharmProbiotics);
parcelHelpers.export(exports, "lookupPharmProbiotic", ()=>lookupPharmProbiotic);
parcelHelpers.export(exports, "getFormationLink", ()=>getFormationLink);
parcelHelpers.export(exports, "getMaterials", ()=>getMaterials);
parcelHelpers.export(exports, "refreshPharmData", ()=>refreshPharmData);
parcelHelpers.export(exports, "getPatientFollowup", ()=>getPatientFollowup);
parcelHelpers.export(exports, "getPatientHistory", ()=>getPatientHistory);
parcelHelpers.export(exports, "farmavel", ()=>(0, _farmavelJs.farmavel));
var _farmavelJs = require("../../repo/farmavel.js");
const login = async (username, password)=>{
    try {
        const response = await (0, _farmavelJs.farmavel).post('v1/auth/login', {
            username,
            password
        });
        return response;
    } catch (error) {
        console.error(error);
        // FIC-07: farmacia Suspendida o de Baja — credenciales válidas, acceso cerrado.
        if (error?.status === 403 && error?.data?.error === 'pharmacy_access_blocked') return {
            accessBlocked: true
        };
        return null;
    }
};
const getPharmDetails = async (lng = 'es')=>{
    try {
        const response = await (0, _farmavelJs.farmavel).get('v1/pharmacy/details', {
            lng
        });
        return response;
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getMonthDates = async (month, year)=>{
    try {
        const response = await (0, _farmavelJs.farmavel).get('v1/calendar/month-dates', {
            month,
            year
        });
        return response;
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getDayDates = async (date)=>{
    try {
        const response = await (0, _farmavelJs.farmavel).get('v1/calendar/day-dates', {
            date
        });
        return response;
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getCepocCandidates = async ({ patient_name = '', date_from = '', date_to = '' } = {})=>{
    try {
        const params = {};
        if (patient_name) params.patient_name = patient_name;
        if (date_from) params.date_from = date_from;
        if (date_to) params.date_to = date_to;
        const response = await (0, _farmavelJs.farmavel).get('v1/screenings/cepoc-candidates', params);
        return response;
    } catch (error) {
        console.error(error);
        return null;
    }
};
const deleteCepocCandidate = async (id)=>{
    try {
        const response = await (0, _farmavelJs.farmavel).delete(`v1/screenings/cepoc-candidates/${id}`);
        return response;
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getDosingResults = async ({ from = '', to = '', drug = '', patient = '', state = 'active' } = {})=>{
    try {
        const params = {
            status: state
        };
        if (from) params.filter_dosing_from = from;
        if (to) params.filter_dosing_to = to;
        if (drug) params.filter_dosing_drug = drug;
        if (patient) params.filter_dosing_patient = patient;
        const response = await (0, _farmavelJs.farmavel).get('v1/reports/dosing-results', params);
        return response;
    } catch (error) {
        console.error(error);
        return null;
    }
};
const toggleDosingAcceptance = async (id)=>{
    try {
        const response = await (0, _farmavelJs.farmavel).patch(`v1/reports/dosing-results/${id}/toggle-acceptance`);
        return response;
    } catch (error) {
        console.error(error);
        return null;
    }
};
const deleteDosingResult = async (id, deletion_reason = '')=>{
    try {
        const response = await (0, _farmavelJs.farmavel).delete(`v1/reports/dosing-results/${id}`, {
            deletion_reason
        });
        return response;
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getReports = async ({ service = '0', from = '', to = '', patient = '' } = {})=>{
    try {
        const params = {
            filter_service_type: service
        };
        if (from) params.filter_service_from = from;
        if (to) params.filter_service_to = to;
        if (patient) params.filter_service_patient = patient;
        const response = await (0, _farmavelJs.farmavel).get('v1/reports', params);
        return response;
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getSatiReport = async (pharm_id, from, to, lng = 'es')=>{
    try {
        const response = await (0, _farmavelJs.farmavel).get('v1/reports/sati', {
            user_pharm: pharm_id,
            filter_stats_from: from,
            filter_stats_to: to,
            lng
        });
        console.log({
            sati_report: response
        });
        return response;
    } catch (error) {
        console.error(error);
        return null;
    }
};
/*
 * Carrito de reposición (FA-01 a FA-04).
 *
 * Endpoints aditivos del backend nuevo. Los importes llegan ya calculados desde
 * el servidor: aquí NO se recalculan totales ni IVA.
 *
 * A diferencia del resto del SDK, estas funciones NO devuelven `null` al fallar:
 * el carrito necesita distinguir un 409 (alguien lo cambió) de un 422
 * (validación) para poder decírselo a la farmacia. Devuelven siempre
 * `{ status, message, data }`.
 */ const cartError = (error)=>({
        status: false,
        message: error?.message || "No se ha podido completar la operaci\xf3n.",
        http_status: error?.status || 0,
        data: null
    });
const getCart = async ()=>{
    try {
        return await (0, _farmavelJs.farmavel).get('v1/client/cart');
    } catch (error) {
        console.error(error);
        return cartError(error);
    }
};
const getCartCatalog = async ()=>{
    try {
        return await (0, _farmavelJs.farmavel).get('v1/client/cart/catalog');
    } catch (error) {
        console.error(error);
        return cartError(error);
    }
};
const addCartLine = async (productId, quantity)=>{
    try {
        return await (0, _farmavelJs.farmavel).post('v1/client/cart/lines', {
            product_id: productId,
            quantity
        });
    } catch (error) {
        console.error(error);
        return cartError(error);
    }
};
const updateCartLine = async (lineId, quantity)=>{
    try {
        return await (0, _farmavelJs.farmavel).patch(`v1/client/cart/lines/${lineId}`, {
            quantity
        });
    } catch (error) {
        console.error(error);
        return cartError(error);
    }
};
const removeCartLine = async (lineId)=>{
    try {
        return await (0, _farmavelJs.farmavel).delete(`v1/client/cart/lines/${lineId}`);
    } catch (error) {
        console.error(error);
        return cartError(error);
    }
};
const submitCart = async (version)=>{
    try {
        return await (0, _farmavelJs.farmavel).post('v1/client/cart/submit', {
            version
        });
    } catch (error) {
        console.error(error);
        return cartError(error);
    }
};
const getCartOrders = async ()=>{
    try {
        return await (0, _farmavelJs.farmavel).get('v1/client/orders');
    } catch (error) {
        console.error(error);
        return cartError(error);
    }
};
const updateReport = async (reportId, comments, sales = [])=>{
    try {
        return await (0, _farmavelJs.farmavel).patch(`v1/client/reports/${reportId}`, {
            rep_comments: comments ?? '',
            rep_sales: sales
        });
    } catch (error) {
        console.error(error);
        return {
            status: false,
            message: error?.message || 'No se ha podido guardar el informe. Vuelve a intentarlo.'
        };
    }
};
const getReportSales = async (reportId)=>{
    try {
        return await (0, _farmavelJs.farmavel).get(`v1/client/reports/${reportId}/sales`);
    } catch (error) {
        console.error(error);
        return null;
    }
};
/*
 * AD-31 — productos de la farmacia. Una sola fuente en farmavel para «Mis
 * productos», el desplegable de ventas del informe y el selector de SATI/IRETIA
 * (iframe de farmaval-v1). Sustituye a `addProduct`/`deleteProduct` de
 * `farmaval-server-v2`.
 *
 * Las respuestas de éxito traen `data.products` (la lista de «Mis productos»
 * ya actualizada); los errores se devuelven con la forma `{ status, error }`
 * que pinta el formulario.
 */ const productError = (error, fallback)=>({
        status: false,
        error: error?.data?.message || error?.message || fallback
    });
const getPharmacyProducts = async (service = null, lng = null)=>{
    try {
        return await (0, _farmavelJs.farmavel).get('v1/client/products', {
            ...service ? {
                service
            } : {},
            ...lng ? {
                lng
            } : {}
        });
    } catch (error) {
        console.error(error);
        return productError(error, 'No se han podido cargar los productos.');
    }
};
const savePharmacyProduct = async (product)=>{
    const id = parseInt(product.prod_id, 10) || 0;
    // Del catálogo llega `prod_pharm` vacío, no '0': `fill_list` no pinta los
    // valores falsy y la fila se queda sin él. Sin farmacia dueña = catálogo.
    const isCatalog = !(parseInt(product.prod_pharm, 10) > 0);
    try {
        if (id && isCatalog) return await (0, _farmavelJs.farmavel).put(`v1/client/products/${id}/price`, {
            prod_cost: product.prod_cost,
            lng: product.lng
        });
        const payload = {
            prod_name: product.prod_name,
            prod_name_ca: product.prod_name_ca,
            prod_info: product.prod_info,
            prod_info_ca: product.prod_info_ca,
            prod_cost: product.prod_cost,
            prod_state: product.prod_state,
            lng: product.lng
        };
        return id ? await (0, _farmavelJs.farmavel).put(`v1/client/products/${id}`, payload) : await (0, _farmavelJs.farmavel).post('v1/client/products', payload);
    } catch (error) {
        console.error(error);
        return productError(error, 'No se ha podido guardar el producto.');
    }
};
const deletePharmacyProduct = async (id, lng = null)=>{
    try {
        return await (0, _farmavelJs.farmavel).delete(`v1/client/products/${id}`, lng ? {
            lng
        } : null);
    } catch (error) {
        console.error(error);
        return productError(error, 'No se ha podido eliminar el producto.');
    }
};
const getTrainingLibrary = async ()=>{
    try {
        return await (0, _farmavelJs.farmavel).get('v1/training/library');
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getTrainingFolder = async (folderId)=>{
    try {
        return await (0, _farmavelJs.farmavel).get(`v1/training/folders/${folderId}`);
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getTrainingStaff = async ()=>{
    try {
        return await (0, _farmavelJs.farmavel).get('v1/training/staff');
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getTrainingPlayUrl = async (fileId, staffId)=>{
    try {
        return await (0, _farmavelJs.farmavel).get(`v1/training/files/${fileId}/play`, {
            staff_id: staffId
        });
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getTrainingDownloadUrl = async (fileId, staffId)=>{
    try {
        return await (0, _farmavelJs.farmavel).get(`v1/training/files/${fileId}/download`, {
            staff_id: staffId
        });
    } catch (error) {
        console.error(error);
        return null;
    }
};
const postTrainingProgress = async (payload)=>{
    try {
        return await (0, _farmavelJs.farmavel).post('v1/training/progress', payload);
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getTrainingSummary = async (staffId)=>{
    try {
        return await (0, _farmavelJs.farmavel).get('v1/training/progress/summary', {
            staff_id: staffId
        });
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getTrainingQuiz = async (folderId, staffId)=>{
    try {
        return await (0, _farmavelJs.farmavel).get(`v1/training/folders/${folderId}/quiz`, {
            staff_id: staffId
        });
    } catch (error) {
        console.error(error);
        return null;
    }
};
const postTrainingQuizAttempt = async (quizId, payload)=>{
    try {
        return await (0, _farmavelJs.farmavel).post(`v1/training/quizzes/${quizId}/attempts`, payload);
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getTrainingAwards = async (staffId)=>{
    try {
        return await (0, _farmavelJs.farmavel).get('v1/training/awards', {
            staff_id: staffId
        });
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getTrainingAwardDownload = async (staffId)=>{
    try {
        return await (0, _farmavelJs.farmavel).get('v1/training/awards/download', {
            staff_id: staffId
        });
    } catch (error) {
        console.error(error);
        return null;
    }
};
const mentorLogin = async (username, password)=>{
    try {
        return await (0, _farmavelJs.farmavel).post('v1/auth/mentor-login', {
            username,
            password
        });
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getMentorPharmacies = async (username, password)=>{
    try {
        return await (0, _farmavelJs.farmavel).post('v1/auth/mentor/pharmacies', {
            username,
            password
        });
    } catch (error) {
        console.error(error);
        return {
            status: false,
            httpStatus: error?.status ?? 0
        };
    }
};
const mentorAccess = async (username, password, pharmId)=>{
    try {
        return await (0, _farmavelJs.farmavel).post('v1/auth/mentor/access', {
            username,
            password,
            pharm_id: pharmId
        });
    } catch (error) {
        console.error(error);
        return {
            status: false,
            httpStatus: error?.status ?? 0
        };
    }
};
const mentorSwitch = async (pharmId)=>{
    try {
        return await (0, _farmavelJs.farmavel).post('v1/auth/mentor/switch', {
            pharm_id: pharmId
        });
    } catch (error) {
        console.error(error);
        return {
            status: false,
            httpStatus: error?.status ?? 0
        };
    }
};
const postMentoringRequest = async (payload)=>{
    try {
        return await (0, _farmavelJs.farmavel).post('v1/training/mentoring-requests', payload);
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getTrainingWorkshops = async ()=>{
    try {
        return await (0, _farmavelJs.farmavel).get('v1/training/workshops');
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getTrainingWorkshop = async (serviceCode)=>{
    try {
        return await (0, _farmavelJs.farmavel).get(`v1/training/workshops/${serviceCode}`);
    } catch (error) {
        console.error(error);
        return null;
    }
};
const startProbiomentorService = async (staffId)=>{
    try {
        return await (0, _farmavelJs.farmavel).post('v1/probiomentor/start', {
            staff_id: staffId
        });
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getProbiomentorIndications = async ()=>{
    try {
        return await (0, _farmavelJs.farmavel).get('v1/probiomentor/indications');
    } catch (error) {
        console.error(error);
        return null;
    }
};
const endProbiomentorService = async (data)=>{
    try {
        return await (0, _farmavelJs.farmavel).post('v1/probiomentor/end', data);
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getServicesCatalog = async ()=>{
    try {
        return await (0, _farmavelJs.farmavel).get('v1/services');
    } catch (error) {
        console.error('[farmavel] getServicesCatalog:', error);
        return null;
    }
};
const getProbiomentorHistory = async (params = {})=>{
    try {
        return await (0, _farmavelJs.farmavel).get('v1/probiomentor/history', params);
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getProbiomentorTeamStats = async (params = {})=>{
    try {
        return await (0, _farmavelJs.farmavel).get('v1/probiomentor/team-stats', params);
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getProbiomentorServicesStats = async (params = {})=>{
    try {
        return await (0, _farmavelJs.farmavel).get('v1/probiomentor/services-stats', params);
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getProbiomentorConsultationsStats = async (params = {})=>{
    try {
        return await (0, _farmavelJs.farmavel).get('v1/probiomentor/consultations-stats', params);
    } catch (error) {
        console.error(error);
        return null;
    }
};
const deleteProbiomentorService = async (id, deletion_reason = '')=>{
    try {
        return await (0, _farmavelJs.farmavel).delete(`v1/probiomentor/history/${id}`, {
            deletion_reason
        });
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getPharmProbiotics = async ()=>{
    try {
        return await (0, _farmavelJs.farmavel).get('v1/pharm-probiotics');
    } catch (error) {
        console.error(error);
        return null;
    }
};
const addPharmProbiotic = async (data)=>{
    try {
        return await (0, _farmavelJs.farmavel).post('v1/pharm-probiotics', data);
    } catch (error) {
        console.error(error);
        return null;
    }
};
const updatePharmProbiotic = async (id, data)=>{
    try {
        return await (0, _farmavelJs.farmavel).patch(`v1/pharm-probiotics/${id}`, data);
    } catch (error) {
        console.error(error);
        return null;
    }
};
const removePharmProbiotic = async (id)=>{
    try {
        return await (0, _farmavelJs.farmavel).delete(`v1/pharm-probiotics/${id}`);
    } catch (error) {
        console.error(error);
        return null;
    }
};
const searchPharmProbiotics = async (q)=>{
    try {
        return await (0, _farmavelJs.farmavel).get('v1/pharm-probiotics/search', {
            q
        });
    } catch (error) {
        console.error(error);
        return null;
    }
};
const lookupPharmProbiotic = async (cn)=>{
    try {
        return await (0, _farmavelJs.farmavel).get('v1/pharm-probiotics/lookup', {
            cn
        });
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getFormationLink = async ()=>{
    try {
        return await (0, _farmavelJs.farmavel).get('v1/auth/formation-link');
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getMaterials = async ()=>{
    try {
        const response = await (0, _farmavelJs.farmavel).get('v1/materials');
        return response;
    } catch (error) {
        console.error(error);
        return null;
    }
};
const refreshPharmData = async ()=>{
    try {
        return await (0, _farmavelJs.farmavel).get('v1/auth/me');
    } catch (error) {
        console.error(error);
        return {
            status: false,
            httpStatus: error?.status ?? 0
        };
    }
};
const getPatientFollowup = async (filters = {})=>{
    try {
        return await (0, _farmavelJs.farmavel).get('v1/client/patients/followup', filters);
    } catch (error) {
        console.error(error);
        return null;
    }
};
const getPatientHistory = async (patientId)=>{
    try {
        return await (0, _farmavelJs.farmavel).get(`v1/client/patients/${patientId}/history`);
    } catch (error) {
        console.error(error);
        return null;
    }
};

},{"../../repo/farmavel.js":"48Zvu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"48Zvu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "farmavel", ()=>farmavel);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _apiResolverJs = require("../apiResolver.js");
/**
 * FarmavelAPI Class
 * Maneja todas las comunicaciones REST con el nuevo backend de Farmavel (Laravel).
 * Implementa autenticación Sanctum mediante tokens Bearer.
 */ class FarmavelAPI {
    constructor(){
        this.baseUrl = this._resolveBaseUrl();
        this.client = (0, _axiosDefault.default).create({
            baseURL: this.baseUrl,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }
        });
        // Interceptor para incluir el token de Sanctum en cada petición
        this.client.interceptors.request.use((config)=>{
            const token = localStorage.getItem('farmavel_token');
            if (token) config.headers.Authorization = `Bearer ${token}`;
            return config;
        }, (error)=>Promise.reject(error));
    }
    getBaseUrl() {
        return this.baseUrl;
    }
    /**
     * Determina la URL base según el hostname actual para el nuevo backend Laravel.
     * @private
     */ _resolveBaseUrl() {
        const { api_base, server_base } = (0, _apiResolverJs.getServerConfig)();
        const normalizedApiBase = (api_base || `${server_base}api/`).replace(/\/?$/, '/');
        return normalizedApiBase;
    }
    /**
     * Manejador central de peticiones.
     * @private
     */ async _request(method, path, data = null, config = {}) {
        try {
            const requestConfig = {
                method,
                url: path,
                ...config
            };
            if (data) {
                if (method.toLowerCase() === 'get') requestConfig.params = data;
                else requestConfig.data = data;
            }
            const response = await this.client.request(requestConfig);
            return response.data;
        } catch (error) {
            return this._handleError(error);
        }
    }
    /**
     * Manejo centralizado de errores.
     * @private
     */ _handleError(error) {
        const errorDetail = {
            message: error.response?.data?.message || // Laravel suele usar 'message' en lugar de 'msg'
            error.message || 'Unknown API Error',
            status: error.response?.status,
            data: error.response?.data
        };
        console.error('[FarmavelAPI Error]:', errorDetail);
        throw errorDetail;
    }
    // Métodos REST Públicos
    get(path, params = {}, config = {}) {
        return this._request('get', path, params, config);
    }
    post(path, data = {}, config = {}) {
        return this._request('post', path, data, config);
    }
    put(path, data = {}, config = {}) {
        return this._request('put', path, data, config);
    }
    patch(path, data = {}, config = {}) {
        return this._request('patch', path, data, config);
    }
    delete(path, data = null, config = {}) {
        return this._request('delete', path, data, config);
    }
}
const farmavel = new FarmavelAPI();

},{"axios":"kL5AO","../apiResolver.js":"gZbmW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aSmq0":[function(require,module,exports,__globalThis) {
/**
 * BIB-02 — cuestionario del bloque/carpeta en la app de farmacia. Las
 * opciones llegan sin la marca de correcta; la corrección es server-side y
 * la nota queda guardada a nombre de la persona activa (C4).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "openQuiz", ()=>openQuiz);
parcelHelpers.export(exports, "closeQuiz", ()=>closeQuiz);
var _farmavalJs = require("../farmaval.js");
var _indexJs = require("../clients/farmavel/index.js");
const t = (key)=>(0, _farmavalJs.page_text)?.[key] ?? key;
const el = (id)=>document.getElementById(id);
let current = null // { quiz, staffId, onClose }
;
function openQuiz(quiz, staffId, onClose) {
    current = {
        quiz,
        staffId,
        onClose
    };
    el('formacion_grid').classList.add('hide');
    el('formacion_breadcrumb').classList.add('hide');
    el('formacion_player').classList.add('hide');
    const container = el('formacion_quiz');
    container.classList.remove('hide');
    el('formacion_quiz_title').textContent = quiz.title;
    el('formacion_quiz_result').classList.add('hide');
    el('formacion_quiz_result').innerHTML = '';
    el('formacion_quiz_error').classList.add('hide');
    el('formacion_quiz_send').disabled = false;
    el('formacion_quiz_send').classList.remove('hide');
    const list = el('formacion_quiz_questions');
    list.innerHTML = '';
    quiz.questions.forEach((question, index)=>{
        const wrapper = document.createElement('div');
        wrapper.className = 'formacion_question';
        const text = document.createElement('p');
        text.textContent = `${index + 1}. ${question.text}`;
        wrapper.appendChild(text);
        question.options.forEach((option)=>{
            const label = document.createElement('label');
            const radio = document.createElement('input');
            radio.type = 'radio';
            radio.name = `q_${question.id}`;
            radio.value = String(option.id);
            label.appendChild(radio);
            label.appendChild(document.createTextNode(' ' + option.text));
            wrapper.appendChild(label);
        });
        list.appendChild(wrapper);
    });
    bindOnce();
}
let bound = false;
function bindOnce() {
    if (bound) return;
    bound = true;
    el('formacion_quiz_back').addEventListener('click', (e)=>{
        e.preventDefault();
        closeQuiz();
    });
    el('formacion_quiz_send').addEventListener('click', async ()=>{
        if (!current) return;
        const answers = current.quiz.questions.map((question)=>{
            const chosen = document.querySelector(`input[name="q_${question.id}"]:checked`);
            return {
                question_id: question.id,
                option_id: chosen ? Number(chosen.value) : null
            };
        });
        if (answers.some((answer)=>answer.option_id === null)) {
            el('formacion_quiz_error').classList.remove('hide');
            return;
        }
        el('formacion_quiz_error').classList.add('hide');
        el('formacion_quiz_send').disabled = true;
        const payload = {
            answers
        };
        if (current.staffId !== null) payload.staff_id = current.staffId;
        const response = await (0, _indexJs.postTrainingQuizAttempt)(current.quiz.id, payload);
        if (!response?.data) {
            el('formacion_quiz_send').disabled = false;
            return;
        }
        const { score, correct_count, question_count, best_score } = response.data;
        const result = el('formacion_quiz_result');
        result.innerHTML = '';
        const line = document.createElement('div');
        line.textContent = `${t('formacion_quiz_result')}: ${score}% (${correct_count}/${question_count})`;
        result.appendChild(line);
        const best = document.createElement('div');
        best.textContent = `${t('formacion_quiz_best')}: ${best_score}%`;
        result.appendChild(best);
        result.classList.remove('hide');
        el('formacion_quiz_send').classList.add('hide');
    });
}
function closeQuiz() {
    el('formacion_quiz').classList.add('hide');
    el('formacion_grid').classList.remove('hide');
    el('formacion_breadcrumb').classList.remove('hide');
    const done = current?.onClose;
    current = null;
    if (done) done();
}

},{"../farmaval.js":"csIXA","../clients/farmavel/index.js":"11ZIt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6sXvD":[function(require,module,exports,__globalThis) {
/**
 * TL-01 / C9 — la formación de cada taller vive DENTRO del icono del propio
 * taller en la sección Servicios (nunca en la biblioteca general) y su
 * acceso es VITALICIO (lo resuelve el backend con el histórico de servicios).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "takePendingWorkshop", ()=>takePendingWorkshop);
/**
 * Habilita los iconos de taller accesibles (aunque el servicio ya no esté
 * activo — vitalicio) y engancha su click para abrir la formación del taller.
 */ parcelHelpers.export(exports, "initWorkshopIcons", ()=>initWorkshopIcons);
var _indexJs = require("../clients/farmavel/index.js");
const WORKSHOP_CODES = [
    'TALLER_INHALADORES',
    'TALLER_INSULINAS'
];
let pendingWorkshop = null;
function takePendingWorkshop() {
    const value = pendingWorkshop;
    pendingWorkshop = null;
    return value;
}
async function initWorkshopIcons() {
    if (!localStorage.getItem('farmavel_token')) return;
    const response = await (0, _indexJs.getTrainingWorkshops)();
    const accessible = new Set((response?.data ?? []).flatMap((workshop)=>workshop.services ?? []));
    WORKSHOP_CODES.forEach((code)=>{
        const icon = document.getElementById(`service_${code}`);
        if (!icon) return;
        if (accessible.has(code)) {
            icon.classList.remove('disabled');
            icon.setAttribute('data-workshop', code);
            if (!icon.dataset.workshopBound) {
                icon.dataset.workshopBound = '1';
                icon.addEventListener('click', (e)=>{
                    e.preventDefault();
                    if (icon.classList.contains('disabled')) return;
                    pendingWorkshop = code;
                    document.querySelector('nav [aria-section="section_formacion"]')?.click();
                });
            }
        }
    });
}

},{"../clients/farmavel/index.js":"11ZIt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1Uk0K":[function(require,module,exports,__globalThis) {
/**
 * DOM selection utilities using jQuery-like CSS selector syntax.
 * Returns a wrapper with chainable methods: .val(), .text(), .parent(), .children()
 * Supports: #id, .class, tag, [attr], tag.class, tag#id, combinators, etc.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Selects the first element and returns a wrapper with chainable methods.
 * @param {string} selector - jQuery-style CSS selector (#id, .class, tag, etc.)
 * @param {Document|Element} [context=document] - Root element to search within
 * @returns {Object} Wrapper with .val(), .text(), .parent(), .children(), .get()
 * @example
 * $('#user').val()        // value of input/select/textarea, or null
 * $('#contenedor').text() // innerHTML
 * $('#user').parent()    // wrapper of parent element
 * $('#contenedor').children() // array of child wrappers
 */ parcelHelpers.export(exports, "$", ()=>$);
/**
 * Returns the raw first element matching the selector (no wrapper).
 */ parcelHelpers.export(exports, "select", ()=>select);
/**
 * Returns all raw elements matching the selector as an array (no wrappers).
 */ parcelHelpers.export(exports, "selectAll", ()=>selectAll);
/**
 * Selects all matching elements and returns an array of wrappers.
 * @param {string} selector - jQuery-style CSS selector
 * @param {Document|Element} [context=document] - Root element to search within
 * @returns {Object[]} Array of wrappers
 */ parcelHelpers.export(exports, "$$", ()=>$$);
const defaultContext = document;
const VALUE_ELEMENTS = [
    'INPUT',
    'SELECT',
    'TEXTAREA',
    'BUTTON'
];
function hasValueProperty(element) {
    return element && VALUE_ELEMENTS.includes(element.tagName);
}
/**
 * Creates a wrapper around a DOM element with chainable methods.
 * @param {Element|null} element - The DOM element to wrap
 * @returns {Object} Wrapper with .val(), .text(), .parent(), .children(), .get()
 */ function createWrapper(element) {
    return {
        /**
         * Returns the value attribute (for input, select, textarea, button).
         * Returns null if the element has no value property.
         */ val () {
            return hasValueProperty(element) ? element.value : null;
        },
        /**
         * Returns the innerHTML of the element.
         * Returns null if element is null.
         */ text () {
            return element ? element.innerHTML : null;
        },
        /**
         * Returns a wrapper around the parent element.
         */ parent () {
            return createWrapper(element?.parentElement ?? null);
        },
        /**
         * Returns an array of wrappers for each direct child element.
         */ children () {
            if (!element?.children) return [];
            return Array.from(element.children).map((child)=>createWrapper(child));
        },
        /**
         * Returns the raw DOM element.
         */ el () {
            return element ?? null;
        }
    };
}
function $(selector, context = defaultContext) {
    if (!selector || typeof selector !== 'string') return createWrapper(null);
    const element = context.querySelector(selector);
    return createWrapper(element);
}
function select(selector, context = defaultContext) {
    if (!selector || typeof selector !== 'string') return null;
    return context.querySelector(selector);
}
function selectAll(selector, context = defaultContext) {
    if (!selector || typeof selector !== 'string') return [];
    return Array.from(context.querySelectorAll(selector));
}
function $$(selector, context = defaultContext) {
    if (!selector || typeof selector !== 'string') return [];
    const elements = context.querySelectorAll(selector);
    return Array.from(elements).map((el)=>createWrapper(el));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3zXMX":[function(require,module,exports,__globalThis) {
// Fuente única de la versión del bundle en ejecución.
// Parcel inlinea process.env.APP_BUILD_VERSION en build time.
// El deploy script de Forge lo exporta: export APP_BUILD_VERSION=$(git rev-parse --short HEAD)
// Fallback estable para `npm run dev`: Date.now() en cada carga purgaba la caché
// de farmacia y rompía el restore de sesión.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "APP_BUILD_VERSION", ()=>APP_BUILD_VERSION);
const APP_BUILD_VERSION = 'dev';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jVYn2":[function(require,module,exports,__globalThis) {
/**
 * Perfil de visibilidad de menús/secciones por grupo médico de servicio.
 *
 * MANAGED_MENUS es la lista declarativa de todos los elementos del DOM
 * cuya visibilidad se gestiona por el motor applyServiceVisibility().
 * Cada entrada define:
 *   - selector: selector CSS para encontrar el elemento.
 *   - closest (opcional): si está presente, el elemento a mostrar/ocultar
 *     es el ancestro más cercano que coincida con este selector.
 *   - groups: array de grupos médicos que hacen visible este elemento.
 *     Si la farmacia tiene al menos un servicio activo de alguno de esos
 *     grupos, el elemento se muestra; si no, se oculta.
 *
 * Para añadir un grupo médico nuevo:
 *   1. Insertar el/los servicios en la tabla `services` del backend con el nuevo srv_group.
 *   2. Añadir aquí las entradas de menú/sección que corresponden a ese grupo.
 *
 * Para añadir un menú nuevo a un grupo existente:
 *   1. Añadir la entrada aquí. Sin tocar ningún otro archivo.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MANAGED_MENUS", ()=>MANAGED_MENUS);
const MANAGED_MENUS = [
    // ── Secciones de navegación ────────────────────────────────────────────────
    // Pacientes y Calendario: solo disponibles para farmacias con servicios respiratorios
    {
        selector: '[aria-section="section_patients"]',
        groups: [
            'respiratorio'
        ]
    },
    {
        selector: '[aria-section="section_calendar"]',
        groups: [
            'respiratorio'
        ]
    },
    // ── Perfil del administrador ───────────────────────────────────────────────
    // Firma del titular: exclusiva de servicios respiratorios (requiere firma en formulario SATI/CEPOC)
    {
        selector: '#btn_admin_signature',
        closest: '.popup_sep',
        groups: [
            'respiratorio'
        ]
    },
    // Tabs de Perfil exclusivas de servicios respiratorios
    {
        selector: '#section_profile a[href="profile_drugs"]',
        groups: [
            'respiratorio'
        ]
    },
    {
        selector: '#section_profile a[href="profile_calendar"]',
        groups: [
            'respiratorio'
        ]
    },
    {
        selector: '#section_profile a[href="profile_syncro"]',
        groups: [
            'respiratorio'
        ]
    },
    // ── Tabs de Consultas (reportes) ───────────────────────────────────────────
    // Grupos visuales Respiratorios / Digestivos
    {
        selector: '#reports_tabs_group_respiratorios',
        groups: [
            'respiratorio'
        ]
    },
    {
        selector: '#reports_tabs_group_digestivos',
        groups: [
            'probioticos'
        ]
    },
    // Tabs de Consultas: Servicios, SATI, IRETIA, Dosing y Equipo → área respiratoria
    {
        selector: '#section_reports a[href="reports_list"]',
        groups: [
            'respiratorio'
        ]
    },
    {
        selector: 'a[href="reports_stats"]',
        groups: [
            'respiratorio'
        ]
    },
    {
        selector: 'a[href="reports_stats_iretia"]',
        groups: [
            'respiratorio'
        ]
    },
    {
        selector: 'a[href="reports_dosing"]',
        groups: [
            'respiratorio'
        ]
    },
    {
        selector: 'a[href="reports_staff"]',
        groups: [
            'respiratorio'
        ]
    },
    // ── Material divulgativo — sección de tabaco (solo servicios respiratorios) ──
    {
        selector: 'a[aria-marketing="marketing_tobacco"]',
        groups: [
            'respiratorio'
        ]
    },
    // ── Tabs de Probióticos ────────────────────────────────────────────────────
    // Tab de probióticos en el perfil de la farmacia
    {
        selector: '#tab_btn_profile_probiotics',
        groups: [
            'probioticos'
        ]
    },
    // Tabs de historial y estadísticas de equipo en Consultas Probiomentor
    {
        selector: '#tab_reports_probio_history',
        groups: [
            'probioticos'
        ]
    },
    {
        selector: '#tab_reports_probio_team',
        groups: [
            'probioticos'
        ]
    }
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c0Xd8":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("kOekv");

},{}],"5TN2t":[function(require,module,exports,__globalThis) {
module.exports = import("bFHST").then(()=>module.bundle.root('jc5UF'));

},{}],"atDQ1":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("490e0162369ef2ff")(import.meta.resolve("3XWFs")),
    import("bFHST"),
    import("hBup2")
]).then(()=>module.bundle.root('2jqlx'));

},{"490e0162369ef2ff":"deFMk"}],"deFMk":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ae7c5e215a4907e2");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

},{"ae7c5e215a4907e2":"hGvN3"}],"hGvN3":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"aDS2D":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("69342bff906b4b2d")(import.meta.resolve("1YESW")),
    import("bFHST"),
    import("4AgrX")
]).then(()=>module.bundle.root('5v4r6'));

},{"69342bff906b4b2d":"deFMk"}],"csECC":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("db116d2db77f4d3c")(import.meta.resolve("jm5P1")),
    import("bFHST"),
    import("lugtD")
]).then(()=>module.bundle.root('lq9H1'));

},{"db116d2db77f4d3c":"deFMk"}]},["3E0DQ"], "3E0DQ", "parcelRequiree3ea", {})

//# sourceMappingURL=82026572.3e9fa90f.js.map
